// Generated from the supplied CollegeShine course list.
export const COURSE_CATEGORIES = [
  {
    "key": "engineering",
    "label": "Engineering",
    "path": "/course/engineering/",
    "component": "./pages/Courses/Engineering/Engineering.jsx"
  },
  {
    "key": "agriculture",
    "label": "Agriculture",
    "path": "/course/agriculture/",
    "component": "./pages/Courses/Agriculture/Agriculture.jsx"
  },
  {
    "key": "arts-science",
    "label": "Arts & Science",
    "path": "/course/arts-science/",
    "component": "./pages/Courses/ArtsScience/ArtsScience.jsx"
  },
  {
    "key": "diploma",
    "label": "Diploma",
    "path": "/course/diploma/",
    "component": "./pages/Courses/Diploma/Diploma.jsx"
  },
  {
    "key": "architecture-design",
    "label": "Architecture & Design",
    "path": "/course/architecture-design/",
    "component": "./pages/Courses/ArchitectureDesign/ArchitectureDesign.jsx"
  },
  {
    "key": "fishery-science",
    "label": "Fishery Science",
    "path": "/course/fishery-science/",
    "component": "./pages/Courses/FisheryScience/FisheryScience.jsx"
  },
  {
    "key": "management-mba",
    "label": "Management & MBA",
    "path": "/course/management-mba/",
    "component": "./pages/Courses/ManagementMba/ManagementMba.jsx"
  },
  {
    "key": "bds",
    "label": "BDS",
    "path": "/course/bds/",
    "component": "./pages/Courses/Bds/Bds.jsx"
  },
  {
    "key": "mbbs",
    "label": "MBBS & Medical",
    "path": "/course/mbbs/",
    "component": "./pages/Courses/Mbbs/Mbbs.jsx"
  },
  {
    "key": "allied-health-science",
    "label": "Allied Health Science",
    "path": "/course/allied-health-science/",
    "component": "./pages/Courses/AlliedHealthScience/AlliedHealthScience.jsx"
  },
  {
    "key": "veterinary-science",
    "label": "Veterinary Science",
    "path": "/course/veterinary-science/",
    "component": "./pages/Courses/VeterinaryScience/VeterinaryScience.jsx"
  },
  {
    "key": "pharmacy",
    "label": "Pharmacy",
    "path": "/course/pharmacy/",
    "component": "./pages/Courses/Pharmacy/Pharmacy.jsx"
  },
  {
    "key": "nursing",
    "label": "Nursing",
    "path": "/course/nursing/",
    "component": "./pages/Courses/Nursing/Nursing.jsx"
  },
  {
    "key": "physiotherapy",
    "label": "Physiotherapy",
    "path": "/course/physiotherapy/",
    "component": "./pages/Courses/Physiotherapy/Physiotherapy.jsx"
  },
  {
    "key": "occupational-therapy",
    "label": "Occupational Therapy",
    "path": "/course/occupational-therapy/",
    "component": "./pages/Courses/OccupationalTherapy/OccupationalTherapy.jsx"
  },
  {
    "key": "ayurveda",
    "label": "Ayurveda",
    "path": "/course/ayurveda/",
    "component": "./pages/Courses/Ayurveda/Ayurveda.jsx"
  },
  {
    "key": "homeopathy",
    "label": "Homeopathy",
    "path": "/course/homeopathy/",
    "component": "./pages/Courses/Homeopathy/Homeopathy.jsx"
  },
  {
    "key": "unani",
    "label": "Unani Medicine",
    "path": "/course/unani/",
    "component": "./pages/Courses/Unani/Unani.jsx"
  },
  {
    "key": "teacher-education",
    "label": "Teacher Education",
    "path": "/course/teacher-education/",
    "component": "./pages/Courses/TeacherEducation/TeacherEducation.jsx"
  },
  {
    "key": "marine-nautical",
    "label": "Marine & Nautical",
    "path": "/course/marine-nautical/",
    "component": "./pages/Courses/MarineNautical/MarineNautical.jsx"
  },
  {
    "key": "hotel-management",
    "label": "Hotel Management",
    "path": "/course/hotel-management/",
    "component": "./pages/Courses/HotelManagement/HotelManagement.jsx"
  },
  {
    "key": "law",
    "label": "Law",
    "path": "/course/law/",
    "component": "./pages/Courses/Law/Law.jsx"
  },
  {
    "key": "psychology",
    "label": "Psychology",
    "path": "/course/psychology/",
    "component": "./pages/Courses/Psychology/Psychology.jsx"
  },
  {
    "key": "aviation",
    "label": "Aviation",
    "path": "/course/aviation/",
    "component": "./pages/Courses/Aviation/Aviation.jsx"
  },
  {
    "key": "sports-physical-education",
    "label": "Sports & Physical Education",
    "path": "/course/sports-physical-education/",
    "component": "./pages/Courses/SportsPhysicalEducation/SportsPhysicalEducation.jsx"
  },
  {
    "key": "commerce-finance-accounting",
    "label": "Commerce, Finance & Accounting",
    "path": "/course/commerce-finance-accounting/",
    "component": "./pages/Courses/CommerceFinanceAccounting/CommerceFinanceAccounting.jsx"
  },
  {
    "key": "media-journalism-visual-communication",
    "label": "Media, Journalism & Visual Communication",
    "path": "/course/media-journalism-visual-communication/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/MediaJournalismVisualCommunication.jsx"
  },
  {
    "key": "fine-arts-performing-arts",
    "label": "Fine Arts & Performing Arts",
    "path": "/course/fine-arts-performing-arts/",
    "component": "./pages/Courses/FineArtsPerformingArts/FineArtsPerformingArts.jsx"
  }
]

export const COURSE_ROUTES = [
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.E. Aeronautical Engineering",
    "slug": "be-aeronautical-engineering",
    "path": "/course/engineering/be-aeronautical-engineering/",
    "component": "./pages/Courses/Engineering/BEAeronauticalEngineering/BEAeronauticalEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.E. Aerospace Engineering",
    "slug": "be-aerospace-engineering",
    "path": "/course/engineering/be-aerospace-engineering/",
    "component": "./pages/Courses/Engineering/BEAerospaceEngineering/BEAerospaceEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.E. Agricultural Engineering",
    "slug": "be-agricultural-engineering",
    "path": "/course/engineering/be-agricultural-engineering/",
    "component": "./pages/Courses/Engineering/BEAgriculturalEngineering/BEAgriculturalEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.E. Artificial Intelligence and Data Science",
    "slug": "be-artificial-intelligence-and-data-science",
    "path": "/course/engineering/be-artificial-intelligence-and-data-science/",
    "component": "./pages/Courses/Engineering/BEArtificialIntelligenceAndDataScience/BEArtificialIntelligenceAndDataScience.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.E. Automobile Engineering",
    "slug": "be-automobile-engineering",
    "path": "/course/engineering/be-automobile-engineering/",
    "component": "./pages/Courses/Engineering/BEAutomobileEngineering/BEAutomobileEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.E. Biomedical Engineering",
    "slug": "be-biomedical-engineering",
    "path": "/course/engineering/be-biomedical-engineering/",
    "component": "./pages/Courses/Engineering/BEBiomedicalEngineering/BEBiomedicalEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.E. Civil Engineering",
    "slug": "be-civil-engineering",
    "path": "/course/engineering/be-civil-engineering/",
    "component": "./pages/Courses/Engineering/BECivilEngineering/BECivilEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.E. Computer and Communication Engineering",
    "slug": "be-computer-and-communication-engineering",
    "path": "/course/engineering/be-computer-and-communication-engineering/",
    "component": "./pages/Courses/Engineering/BEComputerAndCommunicationEngineering/BEComputerAndCommunicationEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.E. Computer Science and Engineering (CSE)",
    "slug": "be-computer-science-and-engineering-cse",
    "path": "/course/engineering/be-computer-science-and-engineering-cse/",
    "component": "./pages/Courses/Engineering/BEComputerScienceAndEngineeringCse/BEComputerScienceAndEngineeringCse.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.E. Electrical and Electronics Engineering (EEE)",
    "slug": "be-electrical-and-electronics-engineering-eee",
    "path": "/course/engineering/be-electrical-and-electronics-engineering-eee/",
    "component": "./pages/Courses/Engineering/BEElectricalAndElectronicsEngineeringEee/BEElectricalAndElectronicsEngineeringEee.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.E. Electronics and Communication Engineering (ECE)",
    "slug": "be-electronics-and-communication-engineering-ece",
    "path": "/course/engineering/be-electronics-and-communication-engineering-ece/",
    "component": "./pages/Courses/Engineering/BEElectronicsAndCommunicationEngineeringEce/BEElectronicsAndCommunicationEngineeringEce.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.E. Electronics and Instrumentation Engineering",
    "slug": "be-electronics-and-instrumentation-engineering",
    "path": "/course/engineering/be-electronics-and-instrumentation-engineering/",
    "component": "./pages/Courses/Engineering/BEElectronicsAndInstrumentationEngineering/BEElectronicsAndInstrumentationEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.E. Environmental Engineering",
    "slug": "be-environmental-engineering",
    "path": "/course/engineering/be-environmental-engineering/",
    "component": "./pages/Courses/Engineering/BEEnvironmentalEngineering/BEEnvironmentalEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.E. Instrumentation and Control Engineering",
    "slug": "be-instrumentation-and-control-engineering",
    "path": "/course/engineering/be-instrumentation-and-control-engineering/",
    "component": "./pages/Courses/Engineering/BEInstrumentationAndControlEngineering/BEInstrumentationAndControlEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.E. Manufacturing Engineering",
    "slug": "be-manufacturing-engineering",
    "path": "/course/engineering/be-manufacturing-engineering/",
    "component": "./pages/Courses/Engineering/BEManufacturingEngineering/BEManufacturingEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.E. Production Engineering",
    "slug": "be-production-engineering",
    "path": "/course/engineering/be-production-engineering/",
    "component": "./pages/Courses/Engineering/BEProductionEngineering/BEProductionEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.E. Robotics and Automation",
    "slug": "be-robotics-and-automation",
    "path": "/course/engineering/be-robotics-and-automation/",
    "component": "./pages/Courses/Engineering/BERoboticsAndAutomation/BERoboticsAndAutomation.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.E. Medical Electronics",
    "slug": "be-medical-electronics",
    "path": "/course/engineering/be-medical-electronics/",
    "component": "./pages/Courses/Engineering/BEMedicalElectronics/BEMedicalElectronics.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.E. Marine Engineering",
    "slug": "be-marine-engineering",
    "path": "/course/engineering/be-marine-engineering/",
    "component": "./pages/Courses/Engineering/BEMarineEngineering/BEMarineEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.E. Mechanical Engineering",
    "slug": "be-mechanical-engineering",
    "path": "/course/engineering/be-mechanical-engineering/",
    "component": "./pages/Courses/Engineering/BEMechanicalEngineering/BEMechanicalEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.E. Mechatronics Engineering",
    "slug": "be-mechatronics-engineering",
    "path": "/course/engineering/be-mechatronics-engineering/",
    "component": "./pages/Courses/Engineering/BEMechatronicsEngineering/BEMechatronicsEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.Tech Aerospace Engineering",
    "slug": "btech-aerospace-engineering",
    "path": "/course/engineering/btech-aerospace-engineering/",
    "component": "./pages/Courses/Engineering/BTechAerospaceEngineering/BTechAerospaceEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.Tech Agricultural Engineering",
    "slug": "btech-agricultural-engineering",
    "path": "/course/engineering/btech-agricultural-engineering/",
    "component": "./pages/Courses/Engineering/BTechAgriculturalEngineering/BTechAgriculturalEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.Tech Artificial Intelligence",
    "slug": "btech-artificial-intelligence",
    "path": "/course/engineering/btech-artificial-intelligence/",
    "component": "./pages/Courses/Engineering/BTechArtificialIntelligence/BTechArtificialIntelligence.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.Tech Bioinformatics",
    "slug": "btech-bioinformatics",
    "path": "/course/engineering/btech-bioinformatics/",
    "component": "./pages/Courses/Engineering/BTechBioinformatics/BTechBioinformatics.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.Tech Biotechnology",
    "slug": "btech-biotechnology",
    "path": "/course/engineering/btech-biotechnology/",
    "component": "./pages/Courses/Engineering/BTechBiotechnology/BTechBiotechnology.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.Tech Building Science and Construction Management",
    "slug": "btech-building-science-and-construction-management",
    "path": "/course/engineering/btech-building-science-and-construction-management/",
    "component": "./pages/Courses/Engineering/BTechBuildingScienceAndConstructionManagement/BTechBuildingScienceAndConstructionManagement.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.Tech Chemical Engineering",
    "slug": "btech-chemical-engineering",
    "path": "/course/engineering/btech-chemical-engineering/",
    "component": "./pages/Courses/Engineering/BTechChemicalEngineering/BTechChemicalEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.Tech Computer Science and Business Systems",
    "slug": "btech-computer-science-and-business-systems",
    "path": "/course/engineering/btech-computer-science-and-business-systems/",
    "component": "./pages/Courses/Engineering/BTechComputerScienceAndBusinessSystems/BTechComputerScienceAndBusinessSystems.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.Tech Cyber Security",
    "slug": "btech-cyber-security",
    "path": "/course/engineering/btech-cyber-security/",
    "component": "./pages/Courses/Engineering/BTechCyberSecurity/BTechCyberSecurity.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.Tech Fisheries Engineering",
    "slug": "btech-fisheries-engineering",
    "path": "/course/engineering/btech-fisheries-engineering/",
    "component": "./pages/Courses/Engineering/BTechFisheriesEngineering/BTechFisheriesEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.Tech Food Technology",
    "slug": "btech-food-technology",
    "path": "/course/engineering/btech-food-technology/",
    "component": "./pages/Courses/Engineering/BTechFoodTechnology/BTechFoodTechnology.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.Tech Information Technology (IT)",
    "slug": "btech-information-technology-it",
    "path": "/course/engineering/btech-information-technology-it/",
    "component": "./pages/Courses/Engineering/BTechInformationTechnologyIt/BTechInformationTechnologyIt.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.Tech Internet of Things (IoT)",
    "slug": "btech-internet-of-things-iot",
    "path": "/course/engineering/btech-internet-of-things-iot/",
    "component": "./pages/Courses/Engineering/BTechInternetOfThingsIot/BTechInternetOfThingsIot.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.Tech Nanotechnology",
    "slug": "btech-nanotechnology",
    "path": "/course/engineering/btech-nanotechnology/",
    "component": "./pages/Courses/Engineering/BTechNanotechnology/BTechNanotechnology.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.Tech Petroleum Engineering",
    "slug": "btech-petroleum-engineering",
    "path": "/course/engineering/btech-petroleum-engineering/",
    "component": "./pages/Courses/Engineering/BTechPetroleumEngineering/BTechPetroleumEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.Tech Rubber and Plastic Technology",
    "slug": "btech-rubber-and-plastic-technology",
    "path": "/course/engineering/btech-rubber-and-plastic-technology/",
    "component": "./pages/Courses/Engineering/BTechRubberAndPlasticTechnology/BTechRubberAndPlasticTechnology.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.Tech Textile Chemistry",
    "slug": "btech-textile-chemistry",
    "path": "/course/engineering/btech-textile-chemistry/",
    "component": "./pages/Courses/Engineering/BTechTextileChemistry/BTechTextileChemistry.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "B.Tech Textile Technology",
    "slug": "btech-textile-technology",
    "path": "/course/engineering/btech-textile-technology/",
    "component": "./pages/Courses/Engineering/BTechTextileTechnology/BTechTextileTechnology.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. Aeronautical Engineering",
    "slug": "me-aeronautical-engineering",
    "path": "/course/engineering/me-aeronautical-engineering/",
    "component": "./pages/Courses/Engineering/MEAeronauticalEngineering/MEAeronauticalEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. Aerospace Technology",
    "slug": "me-aerospace-technology",
    "path": "/course/engineering/me-aerospace-technology/",
    "component": "./pages/Courses/Engineering/MEAerospaceTechnology/MEAerospaceTechnology.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. Agricultural Engineering",
    "slug": "me-agricultural-engineering",
    "path": "/course/engineering/me-agricultural-engineering/",
    "component": "./pages/Courses/Engineering/MEAgriculturalEngineering/MEAgriculturalEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. Applied Electronics",
    "slug": "me-applied-electronics",
    "path": "/course/engineering/me-applied-electronics/",
    "component": "./pages/Courses/Engineering/MEAppliedElectronics/MEAppliedElectronics.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. Artificial Intelligence and Data Science",
    "slug": "me-artificial-intelligence-and-data-science",
    "path": "/course/engineering/me-artificial-intelligence-and-data-science/",
    "component": "./pages/Courses/Engineering/MEArtificialIntelligenceAndDataScience/MEArtificialIntelligenceAndDataScience.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. Automobile Engineering",
    "slug": "me-automobile-engineering",
    "path": "/course/engineering/me-automobile-engineering/",
    "component": "./pages/Courses/Engineering/MEAutomobileEngineering/MEAutomobileEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. CAD-CAM – Design & Manufacturing",
    "slug": "me-cad-cam-design-and-manufacturing",
    "path": "/course/engineering/me-cad-cam-design-and-manufacturing/",
    "component": "./pages/Courses/Engineering/MECadCamDesignManufacturing/MECadCamDesignManufacturing.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. Communication Systems",
    "slug": "me-communication-systems",
    "path": "/course/engineering/me-communication-systems/",
    "component": "./pages/Courses/Engineering/MECommunicationSystems/MECommunicationSystems.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. Computer and Communication",
    "slug": "me-computer-and-communication",
    "path": "/course/engineering/me-computer-and-communication/",
    "component": "./pages/Courses/Engineering/MEComputerAndCommunication/MEComputerAndCommunication.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. Construction Engineering & Management",
    "slug": "me-construction-engineering-and-management",
    "path": "/course/engineering/me-construction-engineering-and-management/",
    "component": "./pages/Courses/Engineering/MEConstructionEngineeringManagement/MEConstructionEngineeringManagement.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. Control and Instrumentation",
    "slug": "me-control-and-instrumentation",
    "path": "/course/engineering/me-control-and-instrumentation/",
    "component": "./pages/Courses/Engineering/MEControlAndInstrumentation/MEControlAndInstrumentation.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. Embedded System Technologies",
    "slug": "me-embedded-system-technologies",
    "path": "/course/engineering/me-embedded-system-technologies/",
    "component": "./pages/Courses/Engineering/MEEmbeddedSystemTechnologies/MEEmbeddedSystemTechnologies.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. Energy Engineering",
    "slug": "me-energy-engineering",
    "path": "/course/engineering/me-energy-engineering/",
    "component": "./pages/Courses/Engineering/MEEnergyEngineering/MEEnergyEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. Engineering Design",
    "slug": "me-engineering-design",
    "path": "/course/engineering/me-engineering-design/",
    "component": "./pages/Courses/Engineering/MEEngineeringDesign/MEEngineeringDesign.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. Industrial Engineering",
    "slug": "me-industrial-engineering",
    "path": "/course/engineering/me-industrial-engineering/",
    "component": "./pages/Courses/Engineering/MEIndustrialEngineering/MEIndustrialEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. Internal Combustion Engineering",
    "slug": "me-internal-combustion-engineering",
    "path": "/course/engineering/me-internal-combustion-engineering/",
    "component": "./pages/Courses/Engineering/MEInternalCombustionEngineering/MEInternalCombustionEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. Manufacturing Engineering",
    "slug": "me-manufacturing-engineering",
    "path": "/course/engineering/me-manufacturing-engineering/",
    "component": "./pages/Courses/Engineering/MEManufacturingEngineering/MEManufacturingEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. Mechatronics",
    "slug": "me-mechatronics",
    "path": "/course/engineering/me-mechatronics/",
    "component": "./pages/Courses/Engineering/MEMechatronics/MEMechatronics.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. Medical Electronics",
    "slug": "me-medical-electronics",
    "path": "/course/engineering/me-medical-electronics/",
    "component": "./pages/Courses/Engineering/MEMedicalElectronics/MEMedicalElectronics.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. Power Electronics and Drives",
    "slug": "me-power-electronics-and-drives",
    "path": "/course/engineering/me-power-electronics-and-drives/",
    "component": "./pages/Courses/Engineering/MEPowerElectronicsAndDrives/MEPowerElectronicsAndDrives.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. Power Systems Engineering",
    "slug": "me-power-systems-engineering",
    "path": "/course/engineering/me-power-systems-engineering/",
    "component": "./pages/Courses/Engineering/MEPowerSystemsEngineering/MEPowerSystemsEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. Software Engineering",
    "slug": "me-software-engineering",
    "path": "/course/engineering/me-software-engineering/",
    "component": "./pages/Courses/Engineering/MESoftwareEngineering/MESoftwareEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. Structural Engineering",
    "slug": "me-structural-engineering",
    "path": "/course/engineering/me-structural-engineering/",
    "component": "./pages/Courses/Engineering/MEStructuralEngineering/MEStructuralEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. Thermal Engineering",
    "slug": "me-thermal-engineering",
    "path": "/course/engineering/me-thermal-engineering/",
    "component": "./pages/Courses/Engineering/METhermalEngineering/METhermalEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.E. VLSI Design",
    "slug": "me-vlsi-design",
    "path": "/course/engineering/me-vlsi-design/",
    "component": "./pages/Courses/Engineering/MEVlsiDesign/MEVlsiDesign.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.Tech Biotechnology",
    "slug": "mtech-biotechnology",
    "path": "/course/engineering/mtech-biotechnology/",
    "component": "./pages/Courses/Engineering/MTechBiotechnology/MTechBiotechnology.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.Tech Aeronautical Engineering",
    "slug": "mtech-aeronautical-engineering",
    "path": "/course/engineering/mtech-aeronautical-engineering/",
    "component": "./pages/Courses/Engineering/MTechAeronauticalEngineering/MTechAeronauticalEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.Tech Aerospace Engineering",
    "slug": "mtech-aerospace-engineering",
    "path": "/course/engineering/mtech-aerospace-engineering/",
    "component": "./pages/Courses/Engineering/MTechAerospaceEngineering/MTechAerospaceEngineering.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.Tech Building Science Technology",
    "slug": "mtech-building-science-technology",
    "path": "/course/engineering/mtech-building-science-technology/",
    "component": "./pages/Courses/Engineering/MTechBuildingScienceTechnology/MTechBuildingScienceTechnology.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.Tech Cyber Security",
    "slug": "mtech-cyber-security",
    "path": "/course/engineering/mtech-cyber-security/",
    "component": "./pages/Courses/Engineering/MTechCyberSecurity/MTechCyberSecurity.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.Tech Data Science",
    "slug": "mtech-data-science",
    "path": "/course/engineering/mtech-data-science/",
    "component": "./pages/Courses/Engineering/MTechDataScience/MTechDataScience.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.Tech Information Technology",
    "slug": "mtech-information-technology",
    "path": "/course/engineering/mtech-information-technology/",
    "component": "./pages/Courses/Engineering/MTechInformationTechnology/MTechInformationTechnology.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.Tech Petroleum Refining & Petrochemicals",
    "slug": "mtech-petroleum-refining-and-petrochemicals",
    "path": "/course/engineering/mtech-petroleum-refining-and-petrochemicals/",
    "component": "./pages/Courses/Engineering/MTechPetroleumRefiningPetrochemicals/MTechPetroleumRefiningPetrochemicals.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.Tech Nano Science & Technology",
    "slug": "mtech-nano-science-and-technology",
    "path": "/course/engineering/mtech-nano-science-and-technology/",
    "component": "./pages/Courses/Engineering/MTechNanoScienceTechnology/MTechNanoScienceTechnology.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.Tech Textile Technology",
    "slug": "mtech-textile-technology",
    "path": "/course/engineering/mtech-textile-technology/",
    "component": "./pages/Courses/Engineering/MTechTextileTechnology/MTechTextileTechnology.jsx"
  },
  {
    "category": "engineering",
    "categoryLabel": "Engineering",
    "level": "",
    "name": "M.Tech Chemical Engineering",
    "slug": "mtech-chemical-engineering",
    "path": "/course/engineering/mtech-chemical-engineering/",
    "component": "./pages/Courses/Engineering/MTechChemicalEngineering/MTechChemicalEngineering.jsx"
  },
  {
    "category": "agriculture",
    "categoryLabel": "Agriculture",
    "level": "UG",
    "name": "B.Sc. (Hons.) Agriculture",
    "slug": "bsc-hons-agriculture",
    "path": "/course/agriculture/bsc-hons-agriculture/",
    "component": "./pages/Courses/Agriculture/BscHonsAgriculture/BscHonsAgriculture.jsx"
  },
  {
    "category": "agriculture",
    "categoryLabel": "Agriculture",
    "level": "UG",
    "name": "B.Sc. Agribusiness Management",
    "slug": "bsc-agribusiness-management",
    "path": "/course/agriculture/bsc-agribusiness-management/",
    "component": "./pages/Courses/Agriculture/BscAgribusinessManagement/BscAgribusinessManagement.jsx"
  },
  {
    "category": "agriculture",
    "categoryLabel": "Agriculture",
    "level": "UG",
    "name": "B.Sc. Food Science and Nutrition",
    "slug": "bsc-food-science-and-nutrition",
    "path": "/course/agriculture/bsc-food-science-and-nutrition/",
    "component": "./pages/Courses/Agriculture/BscFoodScienceAndNutrition/BscFoodScienceAndNutrition.jsx"
  },
  {
    "category": "agriculture",
    "categoryLabel": "Agriculture",
    "level": "UG",
    "name": "B.Sc. Forestry",
    "slug": "bsc-forestry",
    "path": "/course/agriculture/bsc-forestry/",
    "component": "./pages/Courses/Agriculture/BscForestry/BscForestry.jsx"
  },
  {
    "category": "agriculture",
    "categoryLabel": "Agriculture",
    "level": "UG",
    "name": "B.Sc. Horticulture",
    "slug": "bsc-horticulture",
    "path": "/course/agriculture/bsc-horticulture/",
    "component": "./pages/Courses/Agriculture/BscHorticulture/BscHorticulture.jsx"
  },
  {
    "category": "agriculture",
    "categoryLabel": "Agriculture",
    "level": "UG",
    "name": "B.Sc. Sericulture",
    "slug": "bsc-sericulture",
    "path": "/course/agriculture/bsc-sericulture/",
    "component": "./pages/Courses/Agriculture/BscSericulture/BscSericulture.jsx"
  },
  {
    "category": "agriculture",
    "categoryLabel": "Agriculture",
    "level": "UG",
    "name": "B.Tech. Agricultural Engineering",
    "slug": "btech-agricultural-engineering",
    "path": "/course/agriculture/btech-agricultural-engineering/",
    "component": "./pages/Courses/Agriculture/BtechAgriculturalEngineering/BtechAgriculturalEngineering.jsx"
  },
  {
    "category": "agriculture",
    "categoryLabel": "Agriculture",
    "level": "UG",
    "name": "B.Tech. Bioinformatics",
    "slug": "btech-bioinformatics",
    "path": "/course/agriculture/btech-bioinformatics/",
    "component": "./pages/Courses/Agriculture/BtechBioinformatics/BtechBioinformatics.jsx"
  },
  {
    "category": "agriculture",
    "categoryLabel": "Agriculture",
    "level": "UG",
    "name": "B.Tech. Biotechnology (Agri-Biotech related)",
    "slug": "btech-biotechnology-agri-biotech-related",
    "path": "/course/agriculture/btech-biotechnology-agri-biotech-related/",
    "component": "./pages/Courses/Agriculture/BtechBiotechnologyAgriBiotechRelated/BtechBiotechnologyAgriBiotechRelated.jsx"
  },
  {
    "category": "agriculture",
    "categoryLabel": "Agriculture",
    "level": "UG",
    "name": "B.Tech. Food Technology",
    "slug": "btech-food-technology",
    "path": "/course/agriculture/btech-food-technology/",
    "component": "./pages/Courses/Agriculture/BtechFoodTechnology/BtechFoodTechnology.jsx"
  },
  {
    "category": "agriculture",
    "categoryLabel": "Agriculture",
    "level": "PG",
    "name": "MBA (Agri Business Management)",
    "slug": "mba-agri-business-management",
    "path": "/course/agriculture/mba-agri-business-management/",
    "component": "./pages/Courses/Agriculture/MbaAgriBusinessManagement/MbaAgriBusinessManagement.jsx"
  },
  {
    "category": "agriculture",
    "categoryLabel": "Agriculture",
    "level": "PG",
    "name": "M.Sc. (Agri.) Crop Science",
    "slug": "ms-c-agri-crop-science",
    "path": "/course/agriculture/ms-c-agri-crop-science/",
    "component": "./pages/Courses/Agriculture/MsCAgriCropScience/MsCAgriCropScience.jsx"
  },
  {
    "category": "agriculture",
    "categoryLabel": "Agriculture",
    "level": "PG",
    "name": "M.Sc. (Agri.) Soil Science",
    "slug": "ms-c-agri-soil-science",
    "path": "/course/agriculture/ms-c-agri-soil-science/",
    "component": "./pages/Courses/Agriculture/MsCAgriSoilScience/MsCAgriSoilScience.jsx"
  },
  {
    "category": "agriculture",
    "categoryLabel": "Agriculture",
    "level": "PG",
    "name": "M.Sc. (Agri.) Plant Breeding",
    "slug": "ms-c-agri-plant-breeding",
    "path": "/course/agriculture/ms-c-agri-plant-breeding/",
    "component": "./pages/Courses/Agriculture/MsCAgriPlantBreeding/MsCAgriPlantBreeding.jsx"
  },
  {
    "category": "agriculture",
    "categoryLabel": "Agriculture",
    "level": "PG",
    "name": "M.Sc. (Agri.) – Horticulture",
    "slug": "ms-c-agri-horticulture",
    "path": "/course/agriculture/ms-c-agri-horticulture/",
    "component": "./pages/Courses/Agriculture/MsCAgriHorticulture/MsCAgriHorticulture.jsx"
  },
  {
    "category": "agriculture",
    "categoryLabel": "Agriculture",
    "level": "PG",
    "name": "M.Sc. (Agri.) – Entomology",
    "slug": "ms-c-agri-entomology",
    "path": "/course/agriculture/ms-c-agri-entomology/",
    "component": "./pages/Courses/Agriculture/MsCAgriEntomology/MsCAgriEntomology.jsx"
  },
  {
    "category": "agriculture",
    "categoryLabel": "Agriculture",
    "level": "PG",
    "name": "M.Sc. (Agri.) – Agronomy",
    "slug": "ms-c-agri-agronomy",
    "path": "/course/agriculture/ms-c-agri-agronomy/",
    "component": "./pages/Courses/Agriculture/MsCAgriAgronomy/MsCAgriAgronomy.jsx"
  },
  {
    "category": "agriculture",
    "categoryLabel": "Agriculture",
    "level": "PG",
    "name": "M.Tech. (Food Processing)",
    "slug": "mtech-food-processing",
    "path": "/course/agriculture/mtech-food-processing/",
    "component": "./pages/Courses/Agriculture/MtechFoodProcessing/MtechFoodProcessing.jsx"
  },
  {
    "category": "agriculture",
    "categoryLabel": "Agriculture",
    "level": "PG",
    "name": "M.Tech. – Farm Machinery",
    "slug": "mtech-farm-machinery",
    "path": "/course/agriculture/mtech-farm-machinery/",
    "component": "./pages/Courses/Agriculture/MtechFarmMachinery/MtechFarmMachinery.jsx"
  },
  {
    "category": "agriculture",
    "categoryLabel": "Agriculture",
    "level": "PG",
    "name": "M.Tech. Soil & Water Conservation Engineering",
    "slug": "mtech-soil-and-water-conservation-engineering",
    "path": "/course/agriculture/mtech-soil-and-water-conservation-engineering/",
    "component": "./pages/Courses/Agriculture/MtechSoilAndWaterConservationEngineering/MtechSoilAndWaterConservationEngineering.jsx"
  },
  {
    "category": "agriculture",
    "categoryLabel": "Agriculture",
    "level": "PhD",
    "name": "Ph.D. Agriculture",
    "slug": "phd-agriculture",
    "path": "/course/agriculture/phd-agriculture/",
    "component": "./pages/Courses/Agriculture/PhdAgriculture/PhdAgriculture.jsx"
  },
  {
    "category": "agriculture",
    "categoryLabel": "Agriculture",
    "level": "PhD",
    "name": "Ph.D. Agri-Engineering",
    "slug": "phd-agri-engineering",
    "path": "/course/agriculture/phd-agri-engineering/",
    "component": "./pages/Courses/Agriculture/PhdAgriEngineering/PhdAgriEngineering.jsx"
  },
  {
    "category": "agriculture",
    "categoryLabel": "Agriculture",
    "level": "PhD",
    "name": "Ph.D. Biotechnology (Specialisation)",
    "slug": "phd-biotechnology-specialisation",
    "path": "/course/agriculture/phd-biotechnology-specialisation/",
    "component": "./pages/Courses/Agriculture/PhdBiotechnologySpecialisation/PhdBiotechnologySpecialisation.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.A. — Arts & Humanities",
    "slug": "ba-arts-and-humanities",
    "path": "/course/arts-science/ba-arts-and-humanities/",
    "component": "./pages/Courses/ArtsScience/BaArtsAndHumanities/BaArtsAndHumanities.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.A. Tamil",
    "slug": "ba-tamil",
    "path": "/course/arts-science/ba-tamil/",
    "component": "./pages/Courses/ArtsScience/BaTamil/BaTamil.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.A. English",
    "slug": "ba-english",
    "path": "/course/arts-science/ba-english/",
    "component": "./pages/Courses/ArtsScience/BaEnglish/BaEnglish.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.A. History",
    "slug": "ba-history",
    "path": "/course/arts-science/ba-history/",
    "component": "./pages/Courses/ArtsScience/BaHistory/BaHistory.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.A. Economics",
    "slug": "ba-economics",
    "path": "/course/arts-science/ba-economics/",
    "component": "./pages/Courses/ArtsScience/BaEconomics/BaEconomics.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.A. Political Science",
    "slug": "ba-political-science",
    "path": "/course/arts-science/ba-political-science/",
    "component": "./pages/Courses/ArtsScience/BaPoliticalScience/BaPoliticalScience.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.A. Public Administration",
    "slug": "ba-public-administration",
    "path": "/course/arts-science/ba-public-administration/",
    "component": "./pages/Courses/ArtsScience/BaPublicAdministration/BaPublicAdministration.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.A. Sociology",
    "slug": "ba-sociology",
    "path": "/course/arts-science/ba-sociology/",
    "component": "./pages/Courses/ArtsScience/BaSociology/BaSociology.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.A. Philosophy",
    "slug": "ba-philosophy",
    "path": "/course/arts-science/ba-philosophy/",
    "component": "./pages/Courses/ArtsScience/BaPhilosophy/BaPhilosophy.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.A. Journalism & Mass Communication",
    "slug": "ba-journalism-and-mass-communication",
    "path": "/course/arts-science/ba-journalism-and-mass-communication/",
    "component": "./pages/Courses/ArtsScience/BaJournalismAndMassCommunication/BaJournalismAndMassCommunication.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.A. Psychology",
    "slug": "ba-psychology",
    "path": "/course/arts-science/ba-psychology/",
    "component": "./pages/Courses/ArtsScience/BaPsychology/BaPsychology.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.A. Social Work (BSW)",
    "slug": "ba-social-work-bsw",
    "path": "/course/arts-science/ba-social-work-bsw/",
    "component": "./pages/Courses/ArtsScience/BaSocialWorkBsw/BaSocialWorkBsw.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.A. Fine Arts / Music / Bharatanatyam",
    "slug": "ba-fine-arts-music-bharatanatyam",
    "path": "/course/arts-science/ba-fine-arts-music-bharatanatyam/",
    "component": "./pages/Courses/ArtsScience/BaFineArtsMusicBharatanatyam/BaFineArtsMusicBharatanatyam.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. — Science",
    "slug": "bsc-science",
    "path": "/course/arts-science/bsc-science/",
    "component": "./pages/Courses/ArtsScience/BscScience/BscScience.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Physics",
    "slug": "bsc-physics",
    "path": "/course/arts-science/bsc-physics/",
    "component": "./pages/Courses/ArtsScience/BscPhysics/BscPhysics.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Chemistry",
    "slug": "bsc-chemistry",
    "path": "/course/arts-science/bsc-chemistry/",
    "component": "./pages/Courses/ArtsScience/BscChemistry/BscChemistry.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Mathematics",
    "slug": "bsc-mathematics",
    "path": "/course/arts-science/bsc-mathematics/",
    "component": "./pages/Courses/ArtsScience/BscMathematics/BscMathematics.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Computer Science",
    "slug": "bsc-computer-science",
    "path": "/course/arts-science/bsc-computer-science/",
    "component": "./pages/Courses/ArtsScience/BscComputerScience/BscComputerScience.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Information Technology (IT)",
    "slug": "bsc-information-technology-it",
    "path": "/course/arts-science/bsc-information-technology-it/",
    "component": "./pages/Courses/ArtsScience/BscInformationTechnologyIt/BscInformationTechnologyIt.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Electronics & Communication Systems",
    "slug": "bsc-electronics-and-communication-systems",
    "path": "/course/arts-science/bsc-electronics-and-communication-systems/",
    "component": "./pages/Courses/ArtsScience/BScElectronicsCommunicationSystems/BScElectronicsCommunicationSystems.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Biotechnology",
    "slug": "bsc-biotechnology",
    "path": "/course/arts-science/bsc-biotechnology/",
    "component": "./pages/Courses/ArtsScience/BscBiotechnology/BscBiotechnology.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Microbiology",
    "slug": "bsc-microbiology",
    "path": "/course/arts-science/bsc-microbiology/",
    "component": "./pages/Courses/ArtsScience/BscMicrobiology/BscMicrobiology.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Biochemistry",
    "slug": "bsc-biochemistry",
    "path": "/course/arts-science/bsc-biochemistry/",
    "component": "./pages/Courses/ArtsScience/BscBiochemistry/BscBiochemistry.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Botany",
    "slug": "bsc-botany",
    "path": "/course/arts-science/bsc-botany/",
    "component": "./pages/Courses/ArtsScience/BscBotany/BscBotany.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Zoology",
    "slug": "bsc-zoology",
    "path": "/course/arts-science/bsc-zoology/",
    "component": "./pages/Courses/ArtsScience/BscZoology/BscZoology.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Environmental Science",
    "slug": "bsc-environmental-science",
    "path": "/course/arts-science/bsc-environmental-science/",
    "component": "./pages/Courses/ArtsScience/BscEnvironmentalScience/BscEnvironmentalScience.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Nutrition & Dietetics",
    "slug": "bsc-nutrition-and-dietetics",
    "path": "/course/arts-science/bsc-nutrition-and-dietetics/",
    "component": "./pages/Courses/ArtsScience/BscNutritionAndDietetics/BscNutritionAndDietetics.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Psychology",
    "slug": "bsc-psychology",
    "path": "/course/arts-science/bsc-psychology/",
    "component": "./pages/Courses/ArtsScience/BscPsychology/BscPsychology.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Visual Communication",
    "slug": "bsc-visual-communication",
    "path": "/course/arts-science/bsc-visual-communication/",
    "component": "./pages/Courses/ArtsScience/BscVisualCommunication/BscVisualCommunication.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Data Science",
    "slug": "bsc-data-science",
    "path": "/course/arts-science/bsc-data-science/",
    "component": "./pages/Courses/ArtsScience/BscDataScience/BscDataScience.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Artificial Intelligence & Machine Learning (AI-ML)",
    "slug": "bsc-artificial-intelligence-and-machine-learning-ai-ml",
    "path": "/course/arts-science/bsc-artificial-intelligence-and-machine-learning-ai-ml/",
    "component": "./pages/Courses/ArtsScience/BScArtificialIntelligenceMachineLearningAiMl/BScArtificialIntelligenceMachineLearningAiMl.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Forensic Science",
    "slug": "bsc-forensic-science",
    "path": "/course/arts-science/bsc-forensic-science/",
    "component": "./pages/Courses/ArtsScience/BscForensicScience/BscForensicScience.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Fashion Designing / Costume Design & Dress Making",
    "slug": "bsc-fashion-designing-costume-design-and-dress-making",
    "path": "/course/arts-science/bsc-fashion-designing-costume-design-and-dress-making/",
    "component": "./pages/Courses/ArtsScience/BScFashionDesigningCostumeDesignDressMaking/BScFashionDesigningCostumeDesignDressMaking.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Com / Business",
    "slug": "bcom-business",
    "path": "/course/arts-science/bcom-business/",
    "component": "./pages/Courses/ArtsScience/BcomBusiness/BcomBusiness.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Com (General)",
    "slug": "bcom-general",
    "path": "/course/arts-science/bcom-general/",
    "component": "./pages/Courses/ArtsScience/BcomGeneral/BcomGeneral.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Com (Computer Applications)",
    "slug": "bcom-computer-applications",
    "path": "/course/arts-science/bcom-computer-applications/",
    "component": "./pages/Courses/ArtsScience/BcomComputerApplications/BcomComputerApplications.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Com (Accounting & Finance)",
    "slug": "bcom-accounting-and-finance",
    "path": "/course/arts-science/bcom-accounting-and-finance/",
    "component": "./pages/Courses/ArtsScience/BcomAccountingAndFinance/BcomAccountingAndFinance.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Com (Bank Management)",
    "slug": "bcom-bank-management",
    "path": "/course/arts-science/bcom-bank-management/",
    "component": "./pages/Courses/ArtsScience/BcomBankManagement/BcomBankManagement.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Com (Corporate Secretaryship)",
    "slug": "bcom-corporate-secretaryship",
    "path": "/course/arts-science/bcom-corporate-secretaryship/",
    "component": "./pages/Courses/ArtsScience/BcomCorporateSecretaryship/BcomCorporateSecretaryship.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Com (Professional Accounting)",
    "slug": "bcom-professional-accounting",
    "path": "/course/arts-science/bcom-professional-accounting/",
    "component": "./pages/Courses/ArtsScience/BcomProfessionalAccounting/BcomProfessionalAccounting.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "BBA (Bachelor of Business Administration)",
    "slug": "bba-bachelor-of-business-administration",
    "path": "/course/arts-science/bba-bachelor-of-business-administration/",
    "component": "./pages/Courses/ArtsScience/BbaBachelorOfBusinessAdministration/BbaBachelorOfBusinessAdministration.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "BBM (Business Management)",
    "slug": "bbm-business-management",
    "path": "/course/arts-science/bbm-business-management/",
    "component": "./pages/Courses/ArtsScience/BbmBusinessManagement/BbmBusinessManagement.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Com (E-Commerce / Business Analytics)",
    "slug": "bcom-e-commerce-business-analytics",
    "path": "/course/arts-science/bcom-e-commerce-business-analytics/",
    "component": "./pages/Courses/ArtsScience/BcomECommerceBusinessAnalytics/BcomECommerceBusinessAnalytics.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.C.A. (Bachelor of Computer Applications)",
    "slug": "bca-bachelor-of-computer-applications",
    "path": "/course/arts-science/bca-bachelor-of-computer-applications/",
    "component": "./pages/Courses/ArtsScience/BCABachelorOfComputerApplications/BCABachelorOfComputerApplications.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Computer Science / IT / Software Systems",
    "slug": "bsc-computer-science-it-software-systems",
    "path": "/course/arts-science/bsc-computer-science-it-software-systems/",
    "component": "./pages/Courses/ArtsScience/BScComputerScienceItSoftwareSystems/BScComputerScienceItSoftwareSystems.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Data Analytics / Cloud Computing",
    "slug": "bsc-data-analytics-cloud-computing",
    "path": "/course/arts-science/bsc-data-analytics-cloud-computing/",
    "component": "./pages/Courses/ArtsScience/BscDataAnalyticsCloudComputing/BscDataAnalyticsCloudComputing.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Nutrition, Dietetics & Food Service Management",
    "slug": "bsc-nutrition-dietetics-and-food-service-management",
    "path": "/course/arts-science/bsc-nutrition-dietetics-and-food-service-management/",
    "component": "./pages/Courses/ArtsScience/BScNutritionDieteticsFoodServiceManagement/BScNutritionDieteticsFoodServiceManagement.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Electronics & Communication Science",
    "slug": "bsc-electronics-and-communication-science",
    "path": "/course/arts-science/bsc-electronics-and-communication-science/",
    "component": "./pages/Courses/ArtsScience/BScElectronicsCommunicationScience/BScElectronicsCommunicationScience.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Interior Design",
    "slug": "bsc-interior-design",
    "path": "/course/arts-science/bsc-interior-design/",
    "component": "./pages/Courses/ArtsScience/BscInteriorDesign/BscInteriorDesign.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Hotel Management & Catering Science",
    "slug": "bsc-hotel-management-and-catering-science",
    "path": "/course/arts-science/bsc-hotel-management-and-catering-science/",
    "component": "./pages/Courses/ArtsScience/BScHotelManagementCateringScience/BScHotelManagementCateringScience.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Costume Design & Fashion",
    "slug": "bsc-costume-design-and-fashion",
    "path": "/course/arts-science/bsc-costume-design-and-fashion/",
    "component": "./pages/Courses/ArtsScience/BscCostumeDesignAndFashion/BscCostumeDesignAndFashion.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Sc. Physical Education",
    "slug": "bsc-physical-education",
    "path": "/course/arts-science/bsc-physical-education/",
    "component": "./pages/Courses/ArtsScience/BscPhysicalEducation/BscPhysicalEducation.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.A. — Arts & Humanities",
    "slug": "ma-arts-and-humanities",
    "path": "/course/arts-science/ma-arts-and-humanities/",
    "component": "./pages/Courses/ArtsScience/MaArtsAndHumanities/MaArtsAndHumanities.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.A. Tamil",
    "slug": "ma-tamil",
    "path": "/course/arts-science/ma-tamil/",
    "component": "./pages/Courses/ArtsScience/MaTamil/MaTamil.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.A. English",
    "slug": "ma-english",
    "path": "/course/arts-science/ma-english/",
    "component": "./pages/Courses/ArtsScience/MaEnglish/MaEnglish.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.A. History",
    "slug": "ma-history",
    "path": "/course/arts-science/ma-history/",
    "component": "./pages/Courses/ArtsScience/MaHistory/MaHistory.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.A. Economics",
    "slug": "ma-economics",
    "path": "/course/arts-science/ma-economics/",
    "component": "./pages/Courses/ArtsScience/MaEconomics/MaEconomics.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.A. Political Science",
    "slug": "ma-political-science",
    "path": "/course/arts-science/ma-political-science/",
    "component": "./pages/Courses/ArtsScience/MaPoliticalScience/MaPoliticalScience.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.A. Public Administration",
    "slug": "ma-public-administration",
    "path": "/course/arts-science/ma-public-administration/",
    "component": "./pages/Courses/ArtsScience/MaPublicAdministration/MaPublicAdministration.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.A. Sociology",
    "slug": "ma-sociology",
    "path": "/course/arts-science/ma-sociology/",
    "component": "./pages/Courses/ArtsScience/MaSociology/MaSociology.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.A. Journalism & Mass Communication",
    "slug": "ma-journalism-and-mass-communication",
    "path": "/course/arts-science/ma-journalism-and-mass-communication/",
    "component": "./pages/Courses/ArtsScience/MaJournalismAndMassCommunication/MaJournalismAndMassCommunication.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.A. Psychology",
    "slug": "ma-psychology",
    "path": "/course/arts-science/ma-psychology/",
    "component": "./pages/Courses/ArtsScience/MaPsychology/MaPsychology.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.A. Music / Bharatanatyam",
    "slug": "ma-music-bharatanatyam",
    "path": "/course/arts-science/ma-music-bharatanatyam/",
    "component": "./pages/Courses/ArtsScience/MaMusicBharatanatyam/MaMusicBharatanatyam.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.Sc. — Science",
    "slug": "ms-c-science",
    "path": "/course/arts-science/ms-c-science/",
    "component": "./pages/Courses/ArtsScience/MsCScience/MsCScience.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.Sc. Physics",
    "slug": "ms-c-physics",
    "path": "/course/arts-science/ms-c-physics/",
    "component": "./pages/Courses/ArtsScience/MsCPhysics/MsCPhysics.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.Sc. Chemistry",
    "slug": "ms-c-chemistry",
    "path": "/course/arts-science/ms-c-chemistry/",
    "component": "./pages/Courses/ArtsScience/MsCChemistry/MsCChemistry.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.Sc. Mathematics",
    "slug": "ms-c-mathematics",
    "path": "/course/arts-science/ms-c-mathematics/",
    "component": "./pages/Courses/ArtsScience/MsCMathematics/MsCMathematics.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.Sc. Computer Science",
    "slug": "ms-c-computer-science",
    "path": "/course/arts-science/ms-c-computer-science/",
    "component": "./pages/Courses/ArtsScience/MsCComputerScience/MsCComputerScience.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.Sc. Information Technology",
    "slug": "ms-c-information-technology",
    "path": "/course/arts-science/ms-c-information-technology/",
    "component": "./pages/Courses/ArtsScience/MsCInformationTechnology/MsCInformationTechnology.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.Sc. Biotechnology",
    "slug": "ms-c-biotechnology",
    "path": "/course/arts-science/ms-c-biotechnology/",
    "component": "./pages/Courses/ArtsScience/MsCBiotechnology/MsCBiotechnology.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.Sc. Microbiology",
    "slug": "ms-c-microbiology",
    "path": "/course/arts-science/ms-c-microbiology/",
    "component": "./pages/Courses/ArtsScience/MsCMicrobiology/MsCMicrobiology.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.Sc. Biochemistry",
    "slug": "ms-c-biochemistry",
    "path": "/course/arts-science/ms-c-biochemistry/",
    "component": "./pages/Courses/ArtsScience/MsCBiochemistry/MsCBiochemistry.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.Sc. Botany",
    "slug": "ms-c-botany",
    "path": "/course/arts-science/ms-c-botany/",
    "component": "./pages/Courses/ArtsScience/MsCBotany/MsCBotany.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.Sc. Zoology",
    "slug": "ms-c-zoology",
    "path": "/course/arts-science/ms-c-zoology/",
    "component": "./pages/Courses/ArtsScience/MsCZoology/MsCZoology.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.Sc. Environmental Science",
    "slug": "ms-c-environmental-science",
    "path": "/course/arts-science/ms-c-environmental-science/",
    "component": "./pages/Courses/ArtsScience/MsCEnvironmentalScience/MsCEnvironmentalScience.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.Sc. Applied Electronics",
    "slug": "ms-c-applied-electronics",
    "path": "/course/arts-science/ms-c-applied-electronics/",
    "component": "./pages/Courses/ArtsScience/MsCAppliedElectronics/MsCAppliedElectronics.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.Sc. Nutrition & Dietetics",
    "slug": "ms-c-nutrition-and-dietetics",
    "path": "/course/arts-science/ms-c-nutrition-and-dietetics/",
    "component": "./pages/Courses/ArtsScience/MsCNutritionAndDietetics/MsCNutritionAndDietetics.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.Sc. Data Science / AI / Cybersecurity",
    "slug": "ms-c-data-science-ai-cybersecurity",
    "path": "/course/arts-science/ms-c-data-science-ai-cybersecurity/",
    "component": "./pages/Courses/ArtsScience/MsCDataScienceAiCybersecurity/MsCDataScienceAiCybersecurity.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.Com / Management",
    "slug": "mcom-management",
    "path": "/course/arts-science/mcom-management/",
    "component": "./pages/Courses/ArtsScience/McomManagement/McomManagement.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.Com (General)",
    "slug": "mcom-general",
    "path": "/course/arts-science/mcom-general/",
    "component": "./pages/Courses/ArtsScience/McomGeneral/McomGeneral.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.Com (CA / Finance / Corporate Secretaryship)",
    "slug": "mcom-ca-finance-corporate-secretaryship",
    "path": "/course/arts-science/mcom-ca-finance-corporate-secretaryship/",
    "component": "./pages/Courses/ArtsScience/MComCaFinanceCorporateSecretaryship/MComCaFinanceCorporateSecretaryship.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "MBA (Master of Business Administration)",
    "slug": "mba-master-of-business-administration",
    "path": "/course/arts-science/mba-master-of-business-administration/",
    "component": "./pages/Courses/ArtsScience/MbaMasterOfBusinessAdministration/MbaMasterOfBusinessAdministration.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "MHRM (Human Resource Management)",
    "slug": "mhrm-human-resource-management",
    "path": "/course/arts-science/mhrm-human-resource-management/",
    "component": "./pages/Courses/ArtsScience/MhrmHumanResourceManagement/MhrmHumanResourceManagement.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "MFM (Financial Management)",
    "slug": "mfm-financial-management",
    "path": "/course/arts-science/mfm-financial-management/",
    "component": "./pages/Courses/ArtsScience/MfmFinancialManagement/MfmFinancialManagement.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.C.A. (Master of Computer Applications)",
    "slug": "mca-master-of-computer-applications",
    "path": "/course/arts-science/mca-master-of-computer-applications/",
    "component": "./pages/Courses/ArtsScience/McaMasterOfComputerApplications/McaMasterOfComputerApplications.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.Sc. Computer Science / IT / Software Systems",
    "slug": "ms-c-computer-science-it-software-systems",
    "path": "/course/arts-science/ms-c-computer-science-it-software-systems/",
    "component": "./pages/Courses/ArtsScience/MScComputerScienceItSoftwareSystems/MScComputerScienceItSoftwareSystems.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.Sc. Visual Communication",
    "slug": "ms-c-visual-communication",
    "path": "/course/arts-science/ms-c-visual-communication/",
    "component": "./pages/Courses/ArtsScience/MsCVisualCommunication/MsCVisualCommunication.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.Sc. Hotel Management & Catering Science",
    "slug": "ms-c-hotel-management-and-catering-science",
    "path": "/course/arts-science/ms-c-hotel-management-and-catering-science/",
    "component": "./pages/Courses/ArtsScience/MScHotelManagementCateringScience/MScHotelManagementCateringScience.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.Sc. Costume Design & Fashion",
    "slug": "ms-c-costume-design-and-fashion",
    "path": "/course/arts-science/ms-c-costume-design-and-fashion/",
    "component": "./pages/Courses/ArtsScience/MsCCostumeDesignAndFashion/MsCCostumeDesignAndFashion.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "MPhil",
    "name": "M.Phil Tamil / English / History / Economics",
    "slug": "mphil-tamil-english-history-economics",
    "path": "/course/arts-science/mphil-tamil-english-history-economics/",
    "component": "./pages/Courses/ArtsScience/MPhilTamilEnglishHistoryEconomics/MPhilTamilEnglishHistoryEconomics.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "MPhil",
    "name": "M.Phil Mathematics / Physics / Chemistry",
    "slug": "mphil-mathematics-physics-chemistry",
    "path": "/course/arts-science/mphil-mathematics-physics-chemistry/",
    "component": "./pages/Courses/ArtsScience/MphilMathematicsPhysicsChemistry/MphilMathematicsPhysicsChemistry.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "MPhil",
    "name": "M.Phil Computer Science / Biotechnology / Microbiology",
    "slug": "mphil-computer-science-biotechnology-microbiology",
    "path": "/course/arts-science/mphil-computer-science-biotechnology-microbiology/",
    "component": "./pages/Courses/ArtsScience/MPhilComputerScienceBiotechnologyMicrobiology/MPhilComputerScienceBiotechnologyMicrobiology.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "MPhil",
    "name": "M.Phil Commerce / Management / Psychology / Sociology",
    "slug": "mphil-commerce-management-psychology-sociology",
    "path": "/course/arts-science/mphil-commerce-management-psychology-sociology/",
    "component": "./pages/Courses/ArtsScience/MPhilCommerceManagementPsychologySociology/MPhilCommerceManagementPsychologySociology.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PhD",
    "name": "Ph.D in Arts (Tamil, English, Economics, etc.)",
    "slug": "phd-in-arts-tamil-english-economics-etc",
    "path": "/course/arts-science/phd-in-arts-tamil-english-economics-etc/",
    "component": "./pages/Courses/ArtsScience/PhDInArtsTamilEnglishEconomicsEtc/PhDInArtsTamilEnglishEconomicsEtc.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PhD",
    "name": "Ph.D in Science (Physics, Chemistry, Biology, Computer Science, etc.)",
    "slug": "phd-in-science-physics-chemistry-biology-computer-science-etc",
    "path": "/course/arts-science/phd-in-science-physics-chemistry-biology-computer-science-etc/",
    "component": "./pages/Courses/ArtsScience/PhDInSciencePhysicsChemistryBiologyComputerScienceEtc/PhDInSciencePhysicsChemistryBiologyComputerScienceEtc.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PhD",
    "name": "Ph.D in Commerce, Management & Social Sciences",
    "slug": "phd-in-commerce-management-and-social-sciences",
    "path": "/course/arts-science/phd-in-commerce-management-and-social-sciences/",
    "component": "./pages/Courses/ArtsScience/PhDInCommerceManagementSocialSciences/PhDInCommerceManagementSocialSciences.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PhD",
    "name": "Ph.D in Interdisciplinary Studies (Education, Media, Environment)",
    "slug": "phd-in-interdisciplinary-studies-education-media-environment",
    "path": "/course/arts-science/phd-in-interdisciplinary-studies-education-media-environment/",
    "component": "./pages/Courses/ArtsScience/PhDInInterdisciplinaryStudiesEducationMediaEnvironment/PhDInInterdisciplinaryStudiesEducationMediaEnvironment.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "diploma   --->",
    "slug": "diploma",
    "path": "/course/diploma/diploma/",
    "component": "./pages/Courses/Diploma/Diploma/Diploma.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Aeronautical Engineering",
    "slug": "diploma-in-aeronautical-engineering",
    "path": "/course/diploma/diploma-in-aeronautical-engineering/",
    "component": "./pages/Courses/Diploma/DiplomaInAeronauticalEngineering/DiplomaInAeronauticalEngineering.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Agricultural Engineering",
    "slug": "diploma-in-agricultural-engineering",
    "path": "/course/diploma/diploma-in-agricultural-engineering/",
    "component": "./pages/Courses/Diploma/DiplomaInAgriculturalEngineering/DiplomaInAgriculturalEngineering.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Agricultural Technology",
    "slug": "diploma-in-agricultural-technology",
    "path": "/course/diploma/diploma-in-agricultural-technology/",
    "component": "./pages/Courses/Diploma/DiplomaInAgriculturalTechnology/DiplomaInAgriculturalTechnology.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Apparel Technology",
    "slug": "diploma-in-apparel-technology",
    "path": "/course/diploma/diploma-in-apparel-technology/",
    "component": "./pages/Courses/Diploma/DiplomaInApparelTechnology/DiplomaInApparelTechnology.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Architectural Assistantship",
    "slug": "diploma-in-architectural-assistantship",
    "path": "/course/diploma/diploma-in-architectural-assistantship/",
    "component": "./pages/Courses/Diploma/P0051/P0051.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Architecture",
    "slug": "diploma-in-architecture",
    "path": "/course/diploma/diploma-in-architecture/",
    "component": "./pages/Courses/Diploma/DiplomaInArchitecture/DiplomaInArchitecture.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Artificial Intelligence & Data Science",
    "slug": "diploma-in-artificial-intelligence-and-data-science",
    "path": "/course/diploma/diploma-in-artificial-intelligence-and-data-science/",
    "component": "./pages/Courses/Diploma/P0052/P0052.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Automobile Engineering",
    "slug": "diploma-in-automobile-engineering",
    "path": "/course/diploma/diploma-in-automobile-engineering/",
    "component": "./pages/Courses/Diploma/DiplomaInAutomobileEngineering/DiplomaInAutomobileEngineering.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Building Services Engineering",
    "slug": "diploma-in-building-services-engineering",
    "path": "/course/diploma/diploma-in-building-services-engineering/",
    "component": "./pages/Courses/Diploma/P0053/P0053.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Business Management",
    "slug": "diploma-in-business-management",
    "path": "/course/diploma/diploma-in-business-management/",
    "component": "./pages/Courses/Diploma/DiplomaInBusinessManagement/DiplomaInBusinessManagement.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Chemical Engineering",
    "slug": "diploma-in-chemical-engineering",
    "path": "/course/diploma/diploma-in-chemical-engineering/",
    "component": "./pages/Courses/Diploma/DiplomaInChemicalEngineering/DiplomaInChemicalEngineering.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Civil Engineering",
    "slug": "diploma-in-civil-engineering",
    "path": "/course/diploma/diploma-in-civil-engineering/",
    "component": "./pages/Courses/Diploma/DiplomaInCivilEngineering/DiplomaInCivilEngineering.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Cloud Computing",
    "slug": "diploma-in-cloud-computing",
    "path": "/course/diploma/diploma-in-cloud-computing/",
    "component": "./pages/Courses/Diploma/DiplomaInCloudComputing/DiplomaInCloudComputing.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Computer Engineering",
    "slug": "diploma-in-computer-engineering",
    "path": "/course/diploma/diploma-in-computer-engineering/",
    "component": "./pages/Courses/Diploma/DiplomaInComputerEngineering/DiplomaInComputerEngineering.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Computer Technology",
    "slug": "diploma-in-computer-technology",
    "path": "/course/diploma/diploma-in-computer-technology/",
    "component": "./pages/Courses/Diploma/DiplomaInComputerTechnology/DiplomaInComputerTechnology.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Cyber Security",
    "slug": "diploma-in-cyber-security",
    "path": "/course/diploma/diploma-in-cyber-security/",
    "component": "./pages/Courses/Diploma/DiplomaInCyberSecurity/DiplomaInCyberSecurity.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Dairy Technology",
    "slug": "diploma-in-dairy-technology",
    "path": "/course/diploma/diploma-in-dairy-technology/",
    "component": "./pages/Courses/Diploma/DiplomaInDairyTechnology/DiplomaInDairyTechnology.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Data Science",
    "slug": "diploma-in-data-science",
    "path": "/course/diploma/diploma-in-data-science/",
    "component": "./pages/Courses/Diploma/DiplomaInDataScience/DiplomaInDataScience.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Electrical and Electronics Engineering (EEE)",
    "slug": "diploma-in-electrical-and-electronics-engineering-eee",
    "path": "/course/diploma/diploma-in-electrical-and-electronics-engineering-eee/",
    "component": "./pages/Courses/Diploma/P0055/P0055.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Electronics (Robotics)",
    "slug": "diploma-in-electronics-robotics",
    "path": "/course/diploma/diploma-in-electronics-robotics/",
    "component": "./pages/Courses/Diploma/DiplomaInElectronicsRobotics/DiplomaInElectronicsRobotics.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Electronics and Communication Engineering (ECE)",
    "slug": "diploma-in-electronics-and-communication-engineering-ece",
    "path": "/course/diploma/diploma-in-electronics-and-communication-engineering-ece/",
    "component": "./pages/Courses/Diploma/P0056/P0056.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Energy & Sustainability",
    "slug": "diploma-in-energy-and-sustainability",
    "path": "/course/diploma/diploma-in-energy-and-sustainability/",
    "component": "./pages/Courses/Diploma/DiplomaInEnergyAndSustainability/DiplomaInEnergyAndSustainability.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Environmental Engineering",
    "slug": "diploma-in-environmental-engineering",
    "path": "/course/diploma/diploma-in-environmental-engineering/",
    "component": "./pages/Courses/Diploma/DiplomaInEnvironmentalEngineering/DiplomaInEnvironmentalEngineering.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Fabrication Technology and Erection Engineering",
    "slug": "diploma-in-fabrication-technology-and-erection-engineering",
    "path": "/course/diploma/diploma-in-fabrication-technology-and-erection-engineering/",
    "component": "./pages/Courses/Diploma/P0057/P0057.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Fashion Technology",
    "slug": "diploma-in-fashion-technology",
    "path": "/course/diploma/diploma-in-fashion-technology/",
    "component": "./pages/Courses/Diploma/DiplomaInFashionTechnology/DiplomaInFashionTechnology.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Film & Television Technology",
    "slug": "diploma-in-film-and-television-technology",
    "path": "/course/diploma/diploma-in-film-and-television-technology/",
    "component": "./pages/Courses/Diploma/P0058/P0058.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Fisheries Technology",
    "slug": "diploma-in-fisheries-technology",
    "path": "/course/diploma/diploma-in-fisheries-technology/",
    "component": "./pages/Courses/Diploma/DiplomaInFisheriesTechnology/DiplomaInFisheriesTechnology.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Food Technology",
    "slug": "diploma-in-food-technology",
    "path": "/course/diploma/diploma-in-food-technology/",
    "component": "./pages/Courses/Diploma/DiplomaInFoodTechnology/DiplomaInFoodTechnology.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Foundry Technology",
    "slug": "diploma-in-foundry-technology",
    "path": "/course/diploma/diploma-in-foundry-technology/",
    "component": "./pages/Courses/Diploma/DiplomaInFoundryTechnology/DiplomaInFoundryTechnology.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Handloom Technology",
    "slug": "diploma-in-handloom-technology",
    "path": "/course/diploma/diploma-in-handloom-technology/",
    "component": "./pages/Courses/Diploma/DiplomaInHandloomTechnology/DiplomaInHandloomTechnology.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Horticulture Technology",
    "slug": "diploma-in-horticulture-technology",
    "path": "/course/diploma/diploma-in-horticulture-technology/",
    "component": "./pages/Courses/Diploma/DiplomaInHorticultureTechnology/DiplomaInHorticultureTechnology.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Industrial Safety Engineering",
    "slug": "diploma-in-industrial-safety-engineering",
    "path": "/course/diploma/diploma-in-industrial-safety-engineering/",
    "component": "./pages/Courses/Diploma/P0060/P0060.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Information Technology (IT)",
    "slug": "diploma-in-information-technology-it",
    "path": "/course/diploma/diploma-in-information-technology-it/",
    "component": "./pages/Courses/Diploma/DiplomaInInformationTechnologyIt/DiplomaInInformationTechnologyIt.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Instrumentation & Control Engineering",
    "slug": "diploma-in-instrumentation-and-control-engineering",
    "path": "/course/diploma/diploma-in-instrumentation-and-control-engineering/",
    "component": "./pages/Courses/Diploma/P0061/P0061.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Internet of Things (IoT)",
    "slug": "diploma-in-internet-of-things-iot",
    "path": "/course/diploma/diploma-in-internet-of-things-iot/",
    "component": "./pages/Courses/Diploma/DiplomaInInternetOfThingsIot/DiplomaInInternetOfThingsIot.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Journalism",
    "slug": "diploma-in-journalism",
    "path": "/course/diploma/diploma-in-journalism/",
    "component": "./pages/Courses/Diploma/DiplomaInJournalism/DiplomaInJournalism.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Logistics & Supply Chain Management",
    "slug": "diploma-in-logistics-and-supply-chain-management",
    "path": "/course/diploma/diploma-in-logistics-and-supply-chain-management/",
    "component": "./pages/Courses/Diploma/P0062/P0062.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Machine Tool Maintenance and Repair",
    "slug": "diploma-in-machine-tool-maintenance-and-repair",
    "path": "/course/diploma/diploma-in-machine-tool-maintenance-and-repair/",
    "component": "./pages/Courses/Diploma/P0063/P0063.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Manufacturing Engineering",
    "slug": "diploma-in-manufacturing-engineering",
    "path": "/course/diploma/diploma-in-manufacturing-engineering/",
    "component": "./pages/Courses/Diploma/DiplomaInManufacturingEngineering/DiplomaInManufacturingEngineering.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Mechanical Engineering",
    "slug": "diploma-in-mechanical-engineering",
    "path": "/course/diploma/diploma-in-mechanical-engineering/",
    "component": "./pages/Courses/Diploma/DiplomaInMechanicalEngineering/DiplomaInMechanicalEngineering.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Mechatronics Engineering",
    "slug": "diploma-in-mechatronics-engineering",
    "path": "/course/diploma/diploma-in-mechatronics-engineering/",
    "component": "./pages/Courses/Diploma/DiplomaInMechatronicsEngineering/DiplomaInMechatronicsEngineering.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Medical Electronics",
    "slug": "diploma-in-medical-electronics",
    "path": "/course/diploma/diploma-in-medical-electronics/",
    "component": "./pages/Courses/Diploma/DiplomaInMedicalElectronics/DiplomaInMedicalElectronics.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Modern Office Practice",
    "slug": "diploma-in-modern-office-practice",
    "path": "/course/diploma/diploma-in-modern-office-practice/",
    "component": "./pages/Courses/Diploma/DiplomaInModernOfficePractice/DiplomaInModernOfficePractice.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Multimedia and Animation Technology",
    "slug": "diploma-in-multimedia-and-animation-technology",
    "path": "/course/diploma/diploma-in-multimedia-and-animation-technology/",
    "component": "./pages/Courses/Diploma/P0065/P0065.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Nanotechnology",
    "slug": "diploma-in-nanotechnology",
    "path": "/course/diploma/diploma-in-nanotechnology/",
    "component": "./pages/Courses/Diploma/DiplomaInNanotechnology/DiplomaInNanotechnology.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Nursing Assistant",
    "slug": "diploma-in-nursing-assistant",
    "path": "/course/diploma/diploma-in-nursing-assistant/",
    "component": "./pages/Courses/Diploma/DiplomaInNursingAssistant/DiplomaInNursingAssistant.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Optometry",
    "slug": "diploma-in-optometry",
    "path": "/course/diploma/diploma-in-optometry/",
    "component": "./pages/Courses/Diploma/DiplomaInOptometry/DiplomaInOptometry.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Petrochemical Engineering",
    "slug": "diploma-in-petrochemical-engineering",
    "path": "/course/diploma/diploma-in-petrochemical-engineering/",
    "component": "./pages/Courses/Diploma/DiplomaInPetrochemicalEngineering/DiplomaInPetrochemicalEngineering.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Pharmacy (D.Pharm)",
    "slug": "diploma-in-pharmacy-d-pharm",
    "path": "/course/diploma/diploma-in-pharmacy-d-pharm/",
    "component": "./pages/Courses/Diploma/DiplomaInPharmacyDPharm/DiplomaInPharmacyDPharm.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Physiotherapy",
    "slug": "diploma-in-physiotherapy",
    "path": "/course/diploma/diploma-in-physiotherapy/",
    "component": "./pages/Courses/Diploma/DiplomaInPhysiotherapy/DiplomaInPhysiotherapy.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Plastic Technology",
    "slug": "diploma-in-plastic-technology",
    "path": "/course/diploma/diploma-in-plastic-technology/",
    "component": "./pages/Courses/Diploma/DiplomaInPlasticTechnology/DiplomaInPlasticTechnology.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Poultry Production",
    "slug": "diploma-in-poultry-production",
    "path": "/course/diploma/diploma-in-poultry-production/",
    "component": "./pages/Courses/Diploma/DiplomaInPoultryProduction/DiplomaInPoultryProduction.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Polymer Technology",
    "slug": "diploma-in-polymer-technology",
    "path": "/course/diploma/diploma-in-polymer-technology/",
    "component": "./pages/Courses/Diploma/DiplomaInPolymerTechnology/DiplomaInPolymerTechnology.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Printing Technology",
    "slug": "diploma-in-printing-technology",
    "path": "/course/diploma/diploma-in-printing-technology/",
    "component": "./pages/Courses/Diploma/DiplomaInPrintingTechnology/DiplomaInPrintingTechnology.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Production Engineering",
    "slug": "diploma-in-production-engineering",
    "path": "/course/diploma/diploma-in-production-engineering/",
    "component": "./pages/Courses/Diploma/DiplomaInProductionEngineering/DiplomaInProductionEngineering.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Quantity Surveying and Valuation",
    "slug": "diploma-in-quantity-surveying-and-valuation",
    "path": "/course/diploma/diploma-in-quantity-surveying-and-valuation/",
    "component": "./pages/Courses/Diploma/P0066/P0066.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Radiography and Imaging Technology",
    "slug": "diploma-in-radiography-and-imaging-technology",
    "path": "/course/diploma/diploma-in-radiography-and-imaging-technology/",
    "component": "./pages/Courses/Diploma/P0067/P0067.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Refrigeration and Air Conditioning (RAC)",
    "slug": "diploma-in-refrigeration-and-air-conditioning-rac",
    "path": "/course/diploma/diploma-in-refrigeration-and-air-conditioning-rac/",
    "component": "./pages/Courses/Diploma/P0068/P0068.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Renewable Energy Technology",
    "slug": "diploma-in-renewable-energy-technology",
    "path": "/course/diploma/diploma-in-renewable-energy-technology/",
    "component": "./pages/Courses/Diploma/DiplomaInRenewableEnergyTechnology/DiplomaInRenewableEnergyTechnology.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Rubber Technology",
    "slug": "diploma-in-rubber-technology",
    "path": "/course/diploma/diploma-in-rubber-technology/",
    "component": "./pages/Courses/Diploma/DiplomaInRubberTechnology/DiplomaInRubberTechnology.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Software Testing & Development",
    "slug": "diploma-in-software-testing-and-development",
    "path": "/course/diploma/diploma-in-software-testing-and-development/",
    "component": "./pages/Courses/Diploma/P0069/P0069.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Structural Engineering Assistantship",
    "slug": "diploma-in-structural-engineering-assistantship",
    "path": "/course/diploma/diploma-in-structural-engineering-assistantship/",
    "component": "./pages/Courses/Diploma/P0070/P0070.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Textile Technology",
    "slug": "diploma-in-textile-technology",
    "path": "/course/diploma/diploma-in-textile-technology/",
    "component": "./pages/Courses/Diploma/DiplomaInTextileTechnology/DiplomaInTextileTechnology.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Theatre & Acting",
    "slug": "diploma-in-theatre-and-acting",
    "path": "/course/diploma/diploma-in-theatre-and-acting/",
    "component": "./pages/Courses/Diploma/DiplomaInTheatreAndActing/DiplomaInTheatreAndActing.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Tool & Die Engineering",
    "slug": "diploma-in-tool-and-die-engineering",
    "path": "/course/diploma/diploma-in-tool-and-die-engineering/",
    "component": "./pages/Courses/Diploma/DiplomaInToolAndDieEngineering/DiplomaInToolAndDieEngineering.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Tourism & Travel Management",
    "slug": "diploma-in-tourism-and-travel-management",
    "path": "/course/diploma/diploma-in-tourism-and-travel-management/",
    "component": "./pages/Courses/Diploma/P0071/P0071.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Town and Country Planning",
    "slug": "diploma-in-town-and-country-planning",
    "path": "/course/diploma/diploma-in-town-and-country-planning/",
    "component": "./pages/Courses/Diploma/DiplomaInTownAndCountryPlanning/DiplomaInTownAndCountryPlanning.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Visual Communication",
    "slug": "diploma-in-visual-communication",
    "path": "/course/diploma/diploma-in-visual-communication/",
    "component": "./pages/Courses/Diploma/DiplomaInVisualCommunication/DiplomaInVisualCommunication.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Water Resources Engineering",
    "slug": "diploma-in-water-resources-engineering",
    "path": "/course/diploma/diploma-in-water-resources-engineering/",
    "component": "./pages/Courses/Diploma/DiplomaInWaterResourcesEngineering/DiplomaInWaterResourcesEngineering.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in AI & ML",
    "slug": "diploma-in-ai-and-ml",
    "path": "/course/diploma/diploma-in-ai-and-ml/",
    "component": "./pages/Courses/Diploma/DiplomaInAiAndMl/DiplomaInAiAndMl.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Allied Health",
    "slug": "diploma-in-allied-health",
    "path": "/course/diploma/diploma-in-allied-health/",
    "component": "./pages/Courses/Diploma/DiplomaInAlliedHealth/DiplomaInAlliedHealth.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Computer Science & Engineering (CSE)",
    "slug": "diploma-in-computer-science-and-engineering-cse",
    "path": "/course/diploma/diploma-in-computer-science-and-engineering-cse/",
    "component": "./pages/Courses/Diploma/P0054/P0054.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Graphic Design",
    "slug": "diploma-in-graphic-design",
    "path": "/course/diploma/diploma-in-graphic-design/",
    "component": "./pages/Courses/Diploma/DiplomaInGraphicDesign/DiplomaInGraphicDesign.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Hotel Management & Catering Technology",
    "slug": "diploma-in-hotel-management-and-catering-technology",
    "path": "/course/diploma/diploma-in-hotel-management-and-catering-technology/",
    "component": "./pages/Courses/Diploma/P0059/P0059.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Interior Design",
    "slug": "diploma-in-interior-design",
    "path": "/course/diploma/diploma-in-interior-design/",
    "component": "./pages/Courses/Diploma/DiplomaInInteriorDesign/DiplomaInInteriorDesign.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Medical Laboratory Technology",
    "slug": "diploma-in-medical-laboratory-technology",
    "path": "/course/diploma/diploma-in-medical-laboratory-technology/",
    "component": "./pages/Courses/Diploma/P0064/P0064.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Occupational Therapy",
    "slug": "diploma-in-occupational-therapy",
    "path": "/course/diploma/diploma-in-occupational-therapy/",
    "component": "./pages/Courses/Diploma/DiplomaInOccupationalTherapy/DiplomaInOccupationalTherapy.jsx"
  },
  {
    "category": "diploma",
    "categoryLabel": "Diploma",
    "level": "",
    "name": "Diploma in Veterinary Inspector",
    "slug": "diploma-in-veterinary-inspector",
    "path": "/course/diploma/diploma-in-veterinary-inspector/",
    "component": "./pages/Courses/Diploma/DiplomaInVeterinaryInspector/DiplomaInVeterinaryInspector.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "B.Arch. — Bachelor of Architecture",
    "slug": "ba-rch-bachelor-of-architecture",
    "path": "/course/architecture-design/ba-rch-bachelor-of-architecture/",
    "component": "./pages/Courses/ArchitectureDesign/BaRchBachelorOfArchitecture/BaRchBachelorOfArchitecture.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "B.Des. — Bachelor of Design",
    "slug": "bdes-bachelor-of-design",
    "path": "/course/architecture-design/bdes-bachelor-of-design/",
    "component": "./pages/Courses/ArchitectureDesign/BdesBachelorOfDesign/BdesBachelorOfDesign.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "B.Plan. — Bachelor of Planning",
    "slug": "bplan-bachelor-of-planning",
    "path": "/course/architecture-design/bplan-bachelor-of-planning/",
    "component": "./pages/Courses/ArchitectureDesign/BplanBachelorOfPlanning/BplanBachelorOfPlanning.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "B.Sc. Building Technology & Management",
    "slug": "bsc-building-technology-and-management",
    "path": "/course/architecture-design/bsc-building-technology-and-management/",
    "component": "./pages/Courses/ArchitectureDesign/P0011/P0011.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "B.Sc. Interior Design / Space Design",
    "slug": "bsc-interior-design-space-design",
    "path": "/course/architecture-design/bsc-interior-design-space-design/",
    "component": "./pages/Courses/ArchitectureDesign/BscInteriorDesignSpaceDesign/BscInteriorDesignSpaceDesign.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "B.Tech. Building Science & Construction Management",
    "slug": "btech-building-science-and-construction-management",
    "path": "/course/architecture-design/btech-building-science-and-construction-management/",
    "component": "./pages/Courses/ArchitectureDesign/P0012/P0012.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "B.Tech. Fisheries Engineering",
    "slug": "btech-fisheries-engineering",
    "path": "/course/architecture-design/btech-fisheries-engineering/",
    "component": "./pages/Courses/ArchitectureDesign/BtechFisheriesEngineering/BtechFisheriesEngineering.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "M.Arch. (Building Management)",
    "slug": "ma-rch-building-management",
    "path": "/course/architecture-design/ma-rch-building-management/",
    "component": "./pages/Courses/ArchitectureDesign/MaRchBuildingManagement/MaRchBuildingManagement.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "M.Arch. (Construction Project Management)",
    "slug": "ma-rch-construction-project-management",
    "path": "/course/architecture-design/ma-rch-construction-project-management/",
    "component": "./pages/Courses/ArchitectureDesign/P0013/P0013.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "M.Arch. (Digital Architecture)",
    "slug": "ma-rch-digital-architecture",
    "path": "/course/architecture-design/ma-rch-digital-architecture/",
    "component": "./pages/Courses/ArchitectureDesign/MaRchDigitalArchitecture/MaRchDigitalArchitecture.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "M.Arch. (Environmental Architecture)",
    "slug": "ma-rch-environmental-architecture",
    "path": "/course/architecture-design/ma-rch-environmental-architecture/",
    "component": "./pages/Courses/ArchitectureDesign/P0014/P0014.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "M.Arch. (General)",
    "slug": "ma-rch-general",
    "path": "/course/architecture-design/ma-rch-general/",
    "component": "./pages/Courses/ArchitectureDesign/MaRchGeneral/MaRchGeneral.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "M.Arch. (Interior Design)",
    "slug": "ma-rch-interior-design",
    "path": "/course/architecture-design/ma-rch-interior-design/",
    "component": "./pages/Courses/ArchitectureDesign/MaRchInteriorDesign/MaRchInteriorDesign.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "M.Arch. (Landscape Architecture)",
    "slug": "ma-rch-landscape-architecture",
    "path": "/course/architecture-design/ma-rch-landscape-architecture/",
    "component": "./pages/Courses/ArchitectureDesign/MaRchLandscapeArchitecture/MaRchLandscapeArchitecture.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "M.Arch. (Real Estate Development)",
    "slug": "ma-rch-real-estate-development",
    "path": "/course/architecture-design/ma-rch-real-estate-development/",
    "component": "./pages/Courses/ArchitectureDesign/MaRchRealEstateDevelopment/MaRchRealEstateDevelopment.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "M.Arch. (Sustainable Architecture)",
    "slug": "ma-rch-sustainable-architecture",
    "path": "/course/architecture-design/ma-rch-sustainable-architecture/",
    "component": "./pages/Courses/ArchitectureDesign/MaRchSustainableArchitecture/MaRchSustainableArchitecture.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "M.Arch. (Urban Design)",
    "slug": "ma-rch-urban-design",
    "path": "/course/architecture-design/ma-rch-urban-design/",
    "component": "./pages/Courses/ArchitectureDesign/MaRchUrbanDesign/MaRchUrbanDesign.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "M.Plan. — Master of Planning",
    "slug": "mplan-master-of-planning",
    "path": "/course/architecture-design/mplan-master-of-planning/",
    "component": "./pages/Courses/ArchitectureDesign/MplanMasterOfPlanning/MplanMasterOfPlanning.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "M.Tech. Building Science & Technology",
    "slug": "mtech-building-science-and-technology",
    "path": "/course/architecture-design/mtech-building-science-and-technology/",
    "component": "./pages/Courses/ArchitectureDesign/P0016/P0016.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "M.Des. — Master of Design",
    "slug": "md-es-master-of-design",
    "path": "/course/architecture-design/md-es-master-of-design/",
    "component": "./pages/Courses/ArchitectureDesign/MdEsMasterOfDesign/MdEsMasterOfDesign.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "M.Plan. (Town & Country Planning / Regional Planning / Housing)",
    "slug": "mplan-town-and-country-planning-regional-planning-housing",
    "path": "/course/architecture-design/mplan-town-and-country-planning-regional-planning-housing/",
    "component": "./pages/Courses/ArchitectureDesign/P0015/P0015.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "Ph.D. in Architecture",
    "slug": "phd-in-architecture",
    "path": "/course/architecture-design/phd-in-architecture/",
    "component": "./pages/Courses/ArchitectureDesign/PhdInArchitecture/PhdInArchitecture.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "Ph.D. in Digital / Smart City Design",
    "slug": "phd-in-digital-smart-city-design",
    "path": "/course/architecture-design/phd-in-digital-smart-city-design/",
    "component": "./pages/Courses/ArchitectureDesign/PhdInDigitalSmartCityDesign/PhdInDigitalSmartCityDesign.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "Ph.D. in Environmental Design",
    "slug": "phd-in-environmental-design",
    "path": "/course/architecture-design/phd-in-environmental-design/",
    "component": "./pages/Courses/ArchitectureDesign/PhdInEnvironmentalDesign/PhdInEnvironmentalDesign.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "Ph.D. in Sustainable Development",
    "slug": "phd-in-sustainable-development",
    "path": "/course/architecture-design/phd-in-sustainable-development/",
    "component": "./pages/Courses/ArchitectureDesign/PhdInSustainableDevelopment/PhdInSustainableDevelopment.jsx"
  },
  {
    "category": "architecture-design",
    "categoryLabel": "Architecture & Design",
    "level": "",
    "name": "Ph.D. in Urban & Regional Planning",
    "slug": "phd-in-urban-and-regional-planning",
    "path": "/course/architecture-design/phd-in-urban-and-regional-planning/",
    "component": "./pages/Courses/ArchitectureDesign/PhdInUrbanAndRegionalPlanning/PhdInUrbanAndRegionalPlanning.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "UG",
    "name": "B.F.Sc. – Bachelor of Fisheries Science",
    "slug": "bfsc-bachelor-of-fisheries-science",
    "path": "/course/fishery-science/bfsc-bachelor-of-fisheries-science/",
    "component": "./pages/Courses/FisheryScience/BfscBachelorOfFisheriesScience/BfscBachelorOfFisheriesScience.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "UG",
    "name": "B.Sc. Coastal Aquaculture & Mariculture",
    "slug": "bsc-coastal-aquaculture-and-mariculture",
    "path": "/course/fishery-science/bsc-coastal-aquaculture-and-mariculture/",
    "component": "./pages/Courses/FisheryScience/P0085/P0085.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "UG",
    "name": "B.Sc. Fish Genetics and Biotechnology",
    "slug": "bsc-fish-genetics-and-biotechnology",
    "path": "/course/fishery-science/bsc-fish-genetics-and-biotechnology/",
    "component": "./pages/Courses/FisheryScience/BscFishGeneticsAndBiotechnology/BscFishGeneticsAndBiotechnology.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "UG",
    "name": "B.Sc. Fish Processing Technology",
    "slug": "bsc-fish-processing-technology",
    "path": "/course/fishery-science/bsc-fish-processing-technology/",
    "component": "./pages/Courses/FisheryScience/BscFishProcessingTechnology/BscFishProcessingTechnology.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "UG",
    "name": "B.Sc. Fishery Biology & Aquaculture",
    "slug": "bsc-fishery-biology-and-aquaculture",
    "path": "/course/fishery-science/bsc-fishery-biology-and-aquaculture/",
    "component": "./pages/Courses/FisheryScience/BscFisheryBiologyAndAquaculture/BscFisheryBiologyAndAquaculture.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "UG",
    "name": "B.Sc. Marine Biology & Oceanography",
    "slug": "bsc-marine-biology-and-oceanography",
    "path": "/course/fishery-science/bsc-marine-biology-and-oceanography/",
    "component": "./pages/Courses/FisheryScience/BscMarineBiologyAndOceanography/BscMarineBiologyAndOceanography.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "PG",
    "name": "M.F.Sc. – Master of Fisheries Science",
    "slug": "mfsc-master-of-fisheries-science",
    "path": "/course/fishery-science/mfsc-master-of-fisheries-science/",
    "component": "./pages/Courses/FisheryScience/MfscMasterOfFisheriesScience/MfscMasterOfFisheriesScience.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "PG",
    "name": "M.F.Sc. in Aquaculture",
    "slug": "mfsc-in-aquaculture",
    "path": "/course/fishery-science/mfsc-in-aquaculture/",
    "component": "./pages/Courses/FisheryScience/MfscInAquaculture/MfscInAquaculture.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "PG",
    "name": "M.F.Sc. in Aquatic Environment Management",
    "slug": "mfsc-in-aquatic-environment-management",
    "path": "/course/fishery-science/mfsc-in-aquatic-environment-management/",
    "component": "./pages/Courses/FisheryScience/P0090/P0090.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "PG",
    "name": "M.F.Sc. in Fish Genetics & Biotechnology",
    "slug": "mfsc-in-fish-genetics-and-biotechnology",
    "path": "/course/fishery-science/mfsc-in-fish-genetics-and-biotechnology/",
    "component": "./pages/Courses/FisheryScience/P0093/P0093.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "PG",
    "name": "M.F.Sc. in Fish Nutrition & Feed Technology",
    "slug": "mfsc-in-fish-nutrition-and-feed-technology",
    "path": "/course/fishery-science/mfsc-in-fish-nutrition-and-feed-technology/",
    "component": "./pages/Courses/FisheryScience/P0094/P0094.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "PG",
    "name": "M.F.Sc. in Fish Pathology & Health Management",
    "slug": "mfsc-in-fish-pathology-and-health-management",
    "path": "/course/fishery-science/mfsc-in-fish-pathology-and-health-management/",
    "component": "./pages/Courses/FisheryScience/P0095/P0095.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "PG",
    "name": "M.F.Sc. in Fish Processing Technology",
    "slug": "mfsc-in-fish-processing-technology",
    "path": "/course/fishery-science/mfsc-in-fish-processing-technology/",
    "component": "./pages/Courses/FisheryScience/MfscInFishProcessingTechnology/MfscInFishProcessingTechnology.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "PG",
    "name": "M.F.Sc. in Fisheries Economics, Extension & Statistics",
    "slug": "mfsc-in-fisheries-economics-extension-and-statistics",
    "path": "/course/fishery-science/mfsc-in-fisheries-economics-extension-and-statistics/",
    "component": "./pages/Courses/FisheryScience/P0091/P0091.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "PG",
    "name": "M.F.Sc. in Fisheries Resource Management",
    "slug": "mfsc-in-fisheries-resource-management",
    "path": "/course/fishery-science/mfsc-in-fisheries-resource-management/",
    "component": "./pages/Courses/FisheryScience/P0092/P0092.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "PG",
    "name": "M.F.Sc. in Marine Biology & Ocean Studies",
    "slug": "mfsc-in-marine-biology-and-ocean-studies",
    "path": "/course/fishery-science/mfsc-in-marine-biology-and-ocean-studies/",
    "component": "./pages/Courses/FisheryScience/P0096/P0096.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "Diploma",
    "name": "Diploma in Coastal Aquaculture",
    "slug": "diploma-in-coastal-aquaculture",
    "path": "/course/fishery-science/diploma-in-coastal-aquaculture/",
    "component": "./pages/Courses/FisheryScience/DiplomaInCoastalAquaculture/DiplomaInCoastalAquaculture.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "Diploma",
    "name": "Diploma in Aquaculture Technology",
    "slug": "diploma-in-aquaculture-technology",
    "path": "/course/fishery-science/diploma-in-aquaculture-technology/",
    "component": "./pages/Courses/FisheryScience/DiplomaInAquacultureTechnology/DiplomaInAquacultureTechnology.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "Diploma",
    "name": "Diploma in Fish Hatchery Management",
    "slug": "diploma-in-fish-hatchery-management",
    "path": "/course/fishery-science/diploma-in-fish-hatchery-management/",
    "component": "./pages/Courses/FisheryScience/DiplomaInFishHatcheryManagement/DiplomaInFishHatcheryManagement.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "Diploma",
    "name": "Diploma in Fish Processing & Quality Control",
    "slug": "diploma-in-fish-processing-and-quality-control",
    "path": "/course/fishery-science/diploma-in-fish-processing-and-quality-control/",
    "component": "./pages/Courses/FisheryScience/P0087/P0087.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "Diploma",
    "name": "Diploma in Fisheries Extension & Training",
    "slug": "diploma-in-fisheries-extension-and-training",
    "path": "/course/fishery-science/diploma-in-fisheries-extension-and-training/",
    "component": "./pages/Courses/FisheryScience/P0086/P0086.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "Diploma",
    "name": "Diploma in Fisheries Technology",
    "slug": "diploma-in-fisheries-technology",
    "path": "/course/fishery-science/diploma-in-fisheries-technology/",
    "component": "./pages/Courses/FisheryScience/DiplomaInFisheriesTechnology/DiplomaInFisheriesTechnology.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "Diploma",
    "name": "Diploma in Marine Resource Management",
    "slug": "diploma-in-marine-resource-management",
    "path": "/course/fishery-science/diploma-in-marine-resource-management/",
    "component": "./pages/Courses/FisheryScience/P0088/P0088.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "Diploma",
    "name": "Diploma in Ornamental Fish Production",
    "slug": "diploma-in-ornamental-fish-production",
    "path": "/course/fishery-science/diploma-in-ornamental-fish-production/",
    "component": "./pages/Courses/FisheryScience/P0089/P0089.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "Diploma",
    "name": "Diploma in Post-Harvest Technology",
    "slug": "diploma-in-post-harvest-technology",
    "path": "/course/fishery-science/diploma-in-post-harvest-technology/",
    "component": "./pages/Courses/FisheryScience/DiplomaInPostHarvestTechnology/DiplomaInPostHarvestTechnology.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "PhD",
    "name": "Ph.D. in Aquaculture",
    "slug": "phd-in-aquaculture",
    "path": "/course/fishery-science/phd-in-aquaculture/",
    "component": "./pages/Courses/FisheryScience/PhdInAquaculture/PhdInAquaculture.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "PhD",
    "name": "Ph.D. in Aquatic Environment Management",
    "slug": "phd-in-aquatic-environment-management",
    "path": "/course/fishery-science/phd-in-aquatic-environment-management/",
    "component": "./pages/Courses/FisheryScience/P0097/P0097.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "PhD",
    "name": "Ph.D. in Fish Biotechnology",
    "slug": "phd-in-fish-biotechnology",
    "path": "/course/fishery-science/phd-in-fish-biotechnology/",
    "component": "./pages/Courses/FisheryScience/PhdInFishBiotechnology/PhdInFishBiotechnology.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "PhD",
    "name": "Ph.D. in Fish Health Management",
    "slug": "phd-in-fish-health-management",
    "path": "/course/fishery-science/phd-in-fish-health-management/",
    "component": "./pages/Courses/FisheryScience/PhdInFishHealthManagement/PhdInFishHealthManagement.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "PhD",
    "name": "Ph.D. in Fish Nutrition & Feed Technology",
    "slug": "phd-in-fish-nutrition-and-feed-technology",
    "path": "/course/fishery-science/phd-in-fish-nutrition-and-feed-technology/",
    "component": "./pages/Courses/FisheryScience/P0099/P0099.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "PhD",
    "name": "Ph.D. in Fish Processing Technology",
    "slug": "phd-in-fish-processing-technology",
    "path": "/course/fishery-science/phd-in-fish-processing-technology/",
    "component": "./pages/Courses/FisheryScience/PhdInFishProcessingTechnology/PhdInFishProcessingTechnology.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "PhD",
    "name": "Ph.D. in Fisheries Resource Management",
    "slug": "phd-in-fisheries-resource-management",
    "path": "/course/fishery-science/phd-in-fisheries-resource-management/",
    "component": "./pages/Courses/FisheryScience/P0098/P0098.jsx"
  },
  {
    "category": "fishery-science",
    "categoryLabel": "Fishery Science",
    "level": "PhD",
    "name": "Ph.D. in Marine Biology",
    "slug": "phd-in-marine-biology",
    "path": "/course/fishery-science/phd-in-marine-biology/",
    "component": "./pages/Courses/FisheryScience/PhdInMarineBiology/PhdInMarineBiology.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "PG",
    "name": "MBA (Master of Business Administration)",
    "slug": "mba",
    "path": "/course/management-mba/mba/",
    "component": "./pages/Courses/ManagementMba/Mba/Mba.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "B.Com in Business Analytics",
    "slug": "bcom-in-business-analytics",
    "path": "/course/management-mba/bcom-in-business-analytics/",
    "component": "./pages/Courses/ManagementMba/BcomInBusinessAnalytics/BcomInBusinessAnalytics.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "B.Com in Management Accounting",
    "slug": "bcom-in-management-accounting",
    "path": "/course/management-mba/bcom-in-management-accounting/",
    "component": "./pages/Courses/ManagementMba/BcomInManagementAccounting/BcomInManagementAccounting.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "B.Com in Corporate Secretaryship",
    "slug": "bcom-in-corporate-secretaryship",
    "path": "/course/management-mba/bcom-in-corporate-secretaryship/",
    "component": "./pages/Courses/ManagementMba/BcomInCorporateSecretaryship/BcomInCorporateSecretaryship.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "BBA – Bachelor of Business Administration",
    "slug": "bba-bachelor-of-business-administration",
    "path": "/course/management-mba/bba-bachelor-of-business-administration/",
    "component": "./pages/Courses/ManagementMba/P0112/P0112.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "BBA in General Management",
    "slug": "bba-in-general-management",
    "path": "/course/management-mba/bba-in-general-management/",
    "component": "./pages/Courses/ManagementMba/BbaInGeneralManagement/BbaInGeneralManagement.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "BBA in Aviation Management",
    "slug": "bba-in-aviation-management",
    "path": "/course/management-mba/bba-in-aviation-management/",
    "component": "./pages/Courses/ManagementMba/BbaInAviationManagement/BbaInAviationManagement.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "BBA in Business Analytics",
    "slug": "bba-in-business-analytics",
    "path": "/course/management-mba/bba-in-business-analytics/",
    "component": "./pages/Courses/ManagementMba/BbaInBusinessAnalytics/BbaInBusinessAnalytics.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "BBA in Digital Marketing",
    "slug": "bba-in-digital-marketing",
    "path": "/course/management-mba/bba-in-digital-marketing/",
    "component": "./pages/Courses/ManagementMba/BbaInDigitalMarketing/BbaInDigitalMarketing.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "BBA in Entrepreneurship",
    "slug": "bba-in-entrepreneurship",
    "path": "/course/management-mba/bba-in-entrepreneurship/",
    "component": "./pages/Courses/ManagementMba/BbaInEntrepreneurship/BbaInEntrepreneurship.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "BBA in Finance",
    "slug": "bba-in-finance",
    "path": "/course/management-mba/bba-in-finance/",
    "component": "./pages/Courses/ManagementMba/BbaInFinance/BbaInFinance.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "BBA in Human Resource Management",
    "slug": "bba-in-human-resource-management",
    "path": "/course/management-mba/bba-in-human-resource-management/",
    "component": "./pages/Courses/ManagementMba/BbaInHumanResourceManagement/BbaInHumanResourceManagement.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "BBA in International Business",
    "slug": "bba-in-international-business",
    "path": "/course/management-mba/bba-in-international-business/",
    "component": "./pages/Courses/ManagementMba/BbaInInternationalBusiness/BbaInInternationalBusiness.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "BBA in Logistics & Supply Chain Management",
    "slug": "bba-in-logistics-and-supply-chain-management",
    "path": "/course/management-mba/bba-in-logistics-and-supply-chain-management/",
    "component": "./pages/Courses/ManagementMba/P0113/P0113.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "BBA Marketing",
    "slug": "bba-marketing",
    "path": "/course/management-mba/bba-marketing/",
    "component": "./pages/Courses/ManagementMba/BbaMarketing/BbaMarketing.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "BBA in Retail Management",
    "slug": "bba-in-retail-management",
    "path": "/course/management-mba/bba-in-retail-management/",
    "component": "./pages/Courses/ManagementMba/BbaInRetailManagement/BbaInRetailManagement.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "BBA in Tourism & Hospitality",
    "slug": "bba-in-tourism-and-hospitality",
    "path": "/course/management-mba/bba-in-tourism-and-hospitality/",
    "component": "./pages/Courses/ManagementMba/BbaInTourismAndHospitality/BbaInTourismAndHospitality.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA (Agri Business Management)",
    "slug": "mba-agri-business-management",
    "path": "/course/management-mba/mba-agri-business-management/",
    "component": "./pages/Courses/ManagementMba/MbaAgriBusinessManagement/MbaAgriBusinessManagement.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA Aviation Management",
    "slug": "mba-aviation-management",
    "path": "/course/management-mba/mba-aviation-management/",
    "component": "./pages/Courses/ManagementMba/MbaAviationManagement/MbaAviationManagement.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA Business Analytics",
    "slug": "mba-business-analytics",
    "path": "/course/management-mba/mba-business-analytics/",
    "component": "./pages/Courses/ManagementMba/MbaBusinessAnalytics/MbaBusinessAnalytics.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA Digital Business / E-Commerce",
    "slug": "mba-digital-business-e-commerce",
    "path": "/course/management-mba/mba-digital-business-e-commerce/",
    "component": "./pages/Courses/ManagementMba/MbaDigitalBusinessECommerce/MbaDigitalBusinessECommerce.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA Entrepreneurship & Startup Management",
    "slug": "mba-entrepreneurship-and-startup-management",
    "path": "/course/management-mba/mba-entrepreneurship-and-startup-management/",
    "component": "./pages/Courses/ManagementMba/P0114/P0114.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA Event Management",
    "slug": "mba-event-management",
    "path": "/course/management-mba/mba-event-management/",
    "component": "./pages/Courses/ManagementMba/MbaEventManagement/MbaEventManagement.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA Finance",
    "slug": "mba-finance",
    "path": "/course/management-mba/mba-finance/",
    "component": "./pages/Courses/ManagementMba/MbaFinance/MbaFinance.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA General Management",
    "slug": "mba-general-management",
    "path": "/course/management-mba/mba-general-management/",
    "component": "./pages/Courses/ManagementMba/MbaGeneralManagement/MbaGeneralManagement.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA Hospital & Healthcare Management",
    "slug": "mba-hospital-and-healthcare-management",
    "path": "/course/management-mba/mba-hospital-and-healthcare-management/",
    "component": "./pages/Courses/ManagementMba/P0115/P0115.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA Human Resource Management",
    "slug": "mba-human-resource-management",
    "path": "/course/management-mba/mba-human-resource-management/",
    "component": "./pages/Courses/ManagementMba/MbaHumanResourceManagement/MbaHumanResourceManagement.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA International Business",
    "slug": "mba-international-business",
    "path": "/course/management-mba/mba-international-business/",
    "component": "./pages/Courses/ManagementMba/MbaInternationalBusiness/MbaInternationalBusiness.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA Logistics & Supply Chain Management",
    "slug": "mba-logistics-and-supply-chain-management",
    "path": "/course/management-mba/mba-logistics-and-supply-chain-management/",
    "component": "./pages/Courses/ManagementMba/P0116/P0116.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA Marketing",
    "slug": "mba-marketing",
    "path": "/course/management-mba/mba-marketing/",
    "component": "./pages/Courses/ManagementMba/MbaMarketing/MbaMarketing.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA Media & Entertainment Management",
    "slug": "mba-media-and-entertainment-management",
    "path": "/course/management-mba/mba-media-and-entertainment-management/",
    "component": "./pages/Courses/ManagementMba/P0119/P0119.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA Operations Management",
    "slug": "mba-operations-management",
    "path": "/course/management-mba/mba-operations-management/",
    "component": "./pages/Courses/ManagementMba/MbaOperationsManagement/MbaOperationsManagement.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA Real Estate Management",
    "slug": "mba-real-estate-management",
    "path": "/course/management-mba/mba-real-estate-management/",
    "component": "./pages/Courses/ManagementMba/MbaRealEstateManagement/MbaRealEstateManagement.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA Retail Management",
    "slug": "mba-retail-management",
    "path": "/course/management-mba/mba-retail-management/",
    "component": "./pages/Courses/ManagementMba/MbaRetailManagement/MbaRetailManagement.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA Shipping & Port Management",
    "slug": "mba-shipping-and-port-management",
    "path": "/course/management-mba/mba-shipping-and-port-management/",
    "component": "./pages/Courses/ManagementMba/MbaShippingAndPortManagement/MbaShippingAndPortManagement.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA Sports Management",
    "slug": "mba-sports-management",
    "path": "/course/management-mba/mba-sports-management/",
    "component": "./pages/Courses/ManagementMba/MbaSportsManagement/MbaSportsManagement.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA Systems & IT Management",
    "slug": "mba-systems-and-it-management",
    "path": "/course/management-mba/mba-systems-and-it-management/",
    "component": "./pages/Courses/ManagementMba/MbaSystemsAndItManagement/MbaSystemsAndItManagement.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA Tourism & Hospitality Management",
    "slug": "mba-tourism-and-hospitality-management",
    "path": "/course/management-mba/mba-tourism-and-hospitality-management/",
    "component": "./pages/Courses/ManagementMba/P0120/P0120.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA Master of Management Studies",
    "slug": "mba-master-of-management-studies",
    "path": "/course/management-mba/mba-master-of-management-studies/",
    "component": "./pages/Courses/ManagementMba/MbaMasterOfManagementStudies/MbaMasterOfManagementStudies.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA Master of Management Studies (Logistics)",
    "slug": "mba-master-of-management-studies-logistics",
    "path": "/course/management-mba/mba-master-of-management-studies-logistics/",
    "component": "./pages/Courses/ManagementMba/P0118/P0118.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "MBA Master of Management Studies (Human Resource Development)",
    "slug": "mba-master-of-management-studies-human-resource-development",
    "path": "/course/management-mba/mba-master-of-management-studies-human-resource-development/",
    "component": "./pages/Courses/ManagementMba/P0117/P0117.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "BBA + MBA — Integrated 5 Years",
    "slug": "bba-mba-integrated-5-years",
    "path": "/course/management-mba/bba-mba-integrated-5-years/",
    "component": "./pages/Courses/ManagementMba/BbaMbaIntegrated5Years/BbaMbaIntegrated5Years.jsx"
  },
  {
    "category": "management-mba",
    "categoryLabel": "Management & MBA",
    "level": "",
    "name": "B.Com + MBA — Integrated 5 Years",
    "slug": "bcom-mba-integrated-5-years",
    "path": "/course/management-mba/bcom-mba-integrated-5-years/",
    "component": "./pages/Courses/ManagementMba/BcomMbaIntegrated5Years/BcomMbaIntegrated5Years.jsx"
  },
  {
    "category": "bds",
    "categoryLabel": "BDS",
    "level": "",
    "name": "Bachelor of Dental Surgery (BDS)",
    "slug": "bachelor-of-dental-surgery-bds",
    "path": "/course/bds/bachelor-of-dental-surgery-bds/",
    "component": "./pages/Courses/Bds/BachelorOfDentalSurgeryBds/BachelorOfDentalSurgeryBds.jsx"
  },
  {
    "category": "bds",
    "categoryLabel": "BDS",
    "level": "",
    "name": "MDS – Conservative Dentistry & Endodontics",
    "slug": "md-s-conservative-dentistry-and-endodontics",
    "path": "/course/bds/md-s-conservative-dentistry-and-endodontics/",
    "component": "./pages/Courses/Bds/P0040/P0040.jsx"
  },
  {
    "category": "bds",
    "categoryLabel": "BDS",
    "level": "",
    "name": "MDS – Oral & Maxillofacial Surgery",
    "slug": "md-s-oral-and-maxillofacial-surgery",
    "path": "/course/bds/md-s-oral-and-maxillofacial-surgery/",
    "component": "./pages/Courses/Bds/MdSOralAndMaxillofacialSurgery/MdSOralAndMaxillofacialSurgery.jsx"
  },
  {
    "category": "bds",
    "categoryLabel": "BDS",
    "level": "",
    "name": "MDS – Oral Medicine & Radiology",
    "slug": "md-s-oral-medicine-and-radiology",
    "path": "/course/bds/md-s-oral-medicine-and-radiology/",
    "component": "./pages/Courses/Bds/MdSOralMedicineAndRadiology/MdSOralMedicineAndRadiology.jsx"
  },
  {
    "category": "bds",
    "categoryLabel": "BDS",
    "level": "",
    "name": "MDS – Oral Pathology & Microbiology",
    "slug": "md-s-oral-pathology-and-microbiology",
    "path": "/course/bds/md-s-oral-pathology-and-microbiology/",
    "component": "./pages/Courses/Bds/MdSOralPathologyAndMicrobiology/MdSOralPathologyAndMicrobiology.jsx"
  },
  {
    "category": "bds",
    "categoryLabel": "BDS",
    "level": "",
    "name": "MDS – Orthodontics & Dentofacial Orthopaedics",
    "slug": "md-s-orthodontics-and-dentofacial-orthopaedics",
    "path": "/course/bds/md-s-orthodontics-and-dentofacial-orthopaedics/",
    "component": "./pages/Courses/Bds/P0041/P0041.jsx"
  },
  {
    "category": "bds",
    "categoryLabel": "BDS",
    "level": "",
    "name": "MDS – Pedodontics & Preventive Dentistry",
    "slug": "md-s-pedodontics-and-preventive-dentistry",
    "path": "/course/bds/md-s-pedodontics-and-preventive-dentistry/",
    "component": "./pages/Courses/Bds/MdSPedodonticsAndPreventiveDentistry/MdSPedodonticsAndPreventiveDentistry.jsx"
  },
  {
    "category": "bds",
    "categoryLabel": "BDS",
    "level": "",
    "name": "MDS – Periodontology",
    "slug": "md-s-periodontology",
    "path": "/course/bds/md-s-periodontology/",
    "component": "./pages/Courses/Bds/MdSPeriodontology/MdSPeriodontology.jsx"
  },
  {
    "category": "bds",
    "categoryLabel": "BDS",
    "level": "",
    "name": "MDS – Prosthodontics",
    "slug": "md-s-prosthodontics",
    "path": "/course/bds/md-s-prosthodontics/",
    "component": "./pages/Courses/Bds/MdSProsthodontics/MdSProsthodontics.jsx"
  },
  {
    "category": "bds",
    "categoryLabel": "BDS",
    "level": "",
    "name": "MDS – Public Health Dentistry",
    "slug": "md-s-public-health-dentistry",
    "path": "/course/bds/md-s-public-health-dentistry/",
    "component": "./pages/Courses/Bds/MdSPublicHealthDentistry/MdSPublicHealthDentistry.jsx"
  },
  {
    "category": "mbbs",
    "categoryLabel": "MBBS & Medical",
    "level": "",
    "name": "MD – Doctor of Medicine",
    "slug": "md-doctor-of-medicine",
    "path": "/course/mbbs/md-doctor-of-medicine/",
    "component": "./pages/Courses/Mbbs/MdDoctorOfMedicine/MdDoctorOfMedicine.jsx"
  },
  {
    "category": "mbbs",
    "categoryLabel": "MBBS & Medical",
    "level": "",
    "name": "MS – Master of Surgery",
    "slug": "ms-master-of-surgery",
    "path": "/course/mbbs/ms-master-of-surgery/",
    "component": "./pages/Courses/Mbbs/MsMasterOfSurgery/MsMasterOfSurgery.jsx"
  },
  {
    "category": "mbbs",
    "categoryLabel": "MBBS & Medical",
    "level": "",
    "name": "DNB – Diplomate of National Board",
    "slug": "dnb-diplomate-of-national-board",
    "path": "/course/mbbs/dnb-diplomate-of-national-board/",
    "component": "./pages/Courses/Mbbs/DnbDiplomateOfNationalBoard/DnbDiplomateOfNationalBoard.jsx"
  },
  {
    "category": "mbbs",
    "categoryLabel": "MBBS & Medical",
    "level": "",
    "name": "Cardiology",
    "slug": "cardiology",
    "path": "/course/mbbs/cardiology/",
    "component": "./pages/Courses/Mbbs/Cardiology/Cardiology.jsx"
  },
  {
    "category": "mbbs",
    "categoryLabel": "MBBS & Medical",
    "level": "",
    "name": "B.Sc Critical Care Technology",
    "slug": "bsc-critical-care-technology",
    "path": "/course/mbbs/bsc-critical-care-technology/",
    "component": "./pages/Courses/Mbbs/BscCriticalCareTechnology/BscCriticalCareTechnology.jsx"
  },
  {
    "category": "mbbs",
    "categoryLabel": "MBBS & Medical",
    "level": "",
    "name": "Diabetology",
    "slug": "diabetology",
    "path": "/course/mbbs/diabetology/",
    "component": "./pages/Courses/Mbbs/Diabetology/Diabetology.jsx"
  },
  {
    "category": "mbbs",
    "categoryLabel": "MBBS & Medical",
    "level": "",
    "name": "Emergency Medicine",
    "slug": "emergency-medicine",
    "path": "/course/mbbs/emergency-medicine/",
    "component": "./pages/Courses/Mbbs/EmergencyMedicine/EmergencyMedicine.jsx"
  },
  {
    "category": "mbbs",
    "categoryLabel": "MBBS & Medical",
    "level": "",
    "name": "Neurology",
    "slug": "neurology",
    "path": "/course/mbbs/neurology/",
    "component": "./pages/Courses/Mbbs/Neurology/Neurology.jsx"
  },
  {
    "category": "mbbs",
    "categoryLabel": "MBBS & Medical",
    "level": "",
    "name": "Oncology",
    "slug": "oncology",
    "path": "/course/mbbs/oncology/",
    "component": "./pages/Courses/Mbbs/Oncology/Oncology.jsx"
  },
  {
    "category": "mbbs",
    "categoryLabel": "MBBS & Medical",
    "level": "",
    "name": "Pediatrics",
    "slug": "pediatrics",
    "path": "/course/mbbs/pediatrics/",
    "component": "./pages/Courses/Mbbs/Pediatrics/Pediatrics.jsx"
  },
  {
    "category": "mbbs",
    "categoryLabel": "MBBS & Medical",
    "level": "",
    "name": "Ph.D in Medical Sciences",
    "slug": "phd-in-medical-sciences",
    "path": "/course/mbbs/phd-in-medical-sciences/",
    "component": "./pages/Courses/Mbbs/PhdInMedicalSciences/PhdInMedicalSciences.jsx"
  },
  {
    "category": "mbbs",
    "categoryLabel": "MBBS & Medical",
    "level": "",
    "name": "Medical Research Studies / Clinical Research",
    "slug": "medical-research-studies-clinical-research",
    "path": "/course/mbbs/medical-research-studies-clinical-research/",
    "component": "./pages/Courses/Mbbs/P0124/P0124.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Pharm — Bachelor of Pharmacy",
    "slug": "bpharm-bachelor-of-pharmacy",
    "path": "/course/allied-health-science/bpharm-bachelor-of-pharmacy/",
    "component": "./pages/Courses/AlliedHealthScience/BpharmBachelorOfPharmacy/BpharmBachelorOfPharmacy.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Anatomy",
    "slug": "bsc-anatomy",
    "path": "/course/allied-health-science/bsc-anatomy/",
    "component": "./pages/Courses/AlliedHealthScience/BscAnatomy/BscAnatomy.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Biomedical Science",
    "slug": "bsc-biomedical-science",
    "path": "/course/allied-health-science/bsc-biomedical-science/",
    "component": "./pages/Courses/AlliedHealthScience/BscBiomedicalScience/BscBiomedicalScience.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Biotechnology",
    "slug": "bsc-biotechnology",
    "path": "/course/allied-health-science/bsc-biotechnology/",
    "component": "./pages/Courses/AlliedHealthScience/BscBiotechnology/BscBiotechnology.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Dialysis Technology",
    "slug": "bsc-dialysis-technology",
    "path": "/course/allied-health-science/bsc-dialysis-technology/",
    "component": "./pages/Courses/AlliedHealthScience/BscDialysisTechnology/BscDialysisTechnology.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Medical Laboratory Technology (MLT)",
    "slug": "bsc-medical-laboratory-technology-mlt",
    "path": "/course/allied-health-science/bsc-medical-laboratory-technology-mlt/",
    "component": "./pages/Courses/AlliedHealthScience/P0007/P0007.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Medical Records Technology",
    "slug": "bsc-medical-records-technology",
    "path": "/course/allied-health-science/bsc-medical-records-technology/",
    "component": "./pages/Courses/AlliedHealthScience/BscMedicalRecordsTechnology/BscMedicalRecordsTechnology.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Microbiology",
    "slug": "bsc-microbiology",
    "path": "/course/allied-health-science/bsc-microbiology/",
    "component": "./pages/Courses/AlliedHealthScience/BscMicrobiology/BscMicrobiology.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Neuro Science Technology",
    "slug": "bsc-neuro-science-technology",
    "path": "/course/allied-health-science/bsc-neuro-science-technology/",
    "component": "./pages/Courses/AlliedHealthScience/BscNeuroScienceTechnology/BscNeuroScienceTechnology.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Operation Theatre & Anaesthesia Technology",
    "slug": "bsc-operation-theatre-and-anaesthesia-technology",
    "path": "/course/allied-health-science/bsc-operation-theatre-and-anaesthesia-technology/",
    "component": "./pages/Courses/AlliedHealthScience/P0008/P0008.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Optometry",
    "slug": "bsc-optometry",
    "path": "/course/allied-health-science/bsc-optometry/",
    "component": "./pages/Courses/AlliedHealthScience/BscOptometry/BscOptometry.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Biochemistry",
    "slug": "bsc-biochemistry",
    "path": "/course/allied-health-science/bsc-biochemistry/",
    "component": "./pages/Courses/AlliedHealthScience/BscBiochemistry/BscBiochemistry.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Cardiac Technology",
    "slug": "bsc-cardiac-technology",
    "path": "/course/allied-health-science/bsc-cardiac-technology/",
    "component": "./pages/Courses/AlliedHealthScience/BscCardiacTechnology/BscCardiacTechnology.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Critical Care Technology",
    "slug": "bsc-critical-care-technology",
    "path": "/course/allied-health-science/bsc-critical-care-technology/",
    "component": "./pages/Courses/AlliedHealthScience/BscCriticalCareTechnology/BscCriticalCareTechnology.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Dental Hygiene",
    "slug": "bsc-dental-hygiene",
    "path": "/course/allied-health-science/bsc-dental-hygiene/",
    "component": "./pages/Courses/AlliedHealthScience/BscDentalHygiene/BscDentalHygiene.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Dental Technology",
    "slug": "bsc-dental-technology",
    "path": "/course/allied-health-science/bsc-dental-technology/",
    "component": "./pages/Courses/AlliedHealthScience/BscDentalTechnology/BscDentalTechnology.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Forensic Science",
    "slug": "bsc-forensic-science",
    "path": "/course/allied-health-science/bsc-forensic-science/",
    "component": "./pages/Courses/AlliedHealthScience/BscForensicScience/BscForensicScience.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Health Information Management",
    "slug": "bsc-health-information-management",
    "path": "/course/allied-health-science/bsc-health-information-management/",
    "component": "./pages/Courses/AlliedHealthScience/P0005/P0005.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Hospital & Healthcare Management",
    "slug": "bsc-hospital-and-healthcare-management",
    "path": "/course/allied-health-science/bsc-hospital-and-healthcare-management/",
    "component": "./pages/Courses/AlliedHealthScience/P0006/P0006.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Ophthalmic Technology",
    "slug": "bsc-ophthalmic-technology",
    "path": "/course/allied-health-science/bsc-ophthalmic-technology/",
    "component": "./pages/Courses/AlliedHealthScience/BscOphthalmicTechnology/BscOphthalmicTechnology.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Perfusion Technology",
    "slug": "bsc-perfusion-technology",
    "path": "/course/allied-health-science/bsc-perfusion-technology/",
    "component": "./pages/Courses/AlliedHealthScience/BscPerfusionTechnology/BscPerfusionTechnology.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Physiology",
    "slug": "bsc-physiology",
    "path": "/course/allied-health-science/bsc-physiology/",
    "component": "./pages/Courses/AlliedHealthScience/BscPhysiology/BscPhysiology.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Public Health",
    "slug": "bsc-public-health",
    "path": "/course/allied-health-science/bsc-public-health/",
    "component": "./pages/Courses/AlliedHealthScience/BscPublicHealth/BscPublicHealth.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Radiology & Imaging Technology",
    "slug": "bsc-radiology-and-imaging-technology",
    "path": "/course/allied-health-science/bsc-radiology-and-imaging-technology/",
    "component": "./pages/Courses/AlliedHealthScience/P0009/P0009.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Renal Dialysis Technology",
    "slug": "bsc-renal-dialysis-technology",
    "path": "/course/allied-health-science/bsc-renal-dialysis-technology/",
    "component": "./pages/Courses/AlliedHealthScience/BscRenalDialysisTechnology/BscRenalDialysisTechnology.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "B.Sc. Respiratory Therapy",
    "slug": "bsc-respiratory-therapy",
    "path": "/course/allied-health-science/bsc-respiratory-therapy/",
    "component": "./pages/Courses/AlliedHealthScience/BscRespiratoryTherapy/BscRespiratoryTherapy.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "BASLP — Bachelor of Audiology & Speech Language Pathology",
    "slug": "baslp-bachelor-of-audiology-and-speech-language-pathology",
    "path": "/course/allied-health-science/baslp-bachelor-of-audiology-and-speech-language-pathology/",
    "component": "./pages/Courses/AlliedHealthScience/P0003/P0003.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "BOT — Bachelor of Occupational Therapy",
    "slug": "bot-bachelor-of-occupational-therapy",
    "path": "/course/allied-health-science/bot-bachelor-of-occupational-therapy/",
    "component": "./pages/Courses/AlliedHealthScience/P0004/P0004.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "M.Sc. Epidemiology & Biostatistics",
    "slug": "ms-c-epidemiology-and-biostatistics",
    "path": "/course/allied-health-science/ms-c-epidemiology-and-biostatistics/",
    "component": "./pages/Courses/AlliedHealthScience/P0010/P0010.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "M.Sc. Medical Lab Technology",
    "slug": "ms-c-medical-lab-technology",
    "path": "/course/allied-health-science/ms-c-medical-lab-technology/",
    "component": "./pages/Courses/AlliedHealthScience/MsCMedicalLabTechnology/MsCMedicalLabTechnology.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "M.Sc. Medical Microbiology",
    "slug": "ms-c-medical-microbiology",
    "path": "/course/allied-health-science/ms-c-medical-microbiology/",
    "component": "./pages/Courses/AlliedHealthScience/MsCMedicalMicrobiology/MsCMedicalMicrobiology.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "M.Sc. Anatomy",
    "slug": "ms-c-anatomy",
    "path": "/course/allied-health-science/ms-c-anatomy/",
    "component": "./pages/Courses/AlliedHealthScience/MsCAnatomy/MsCAnatomy.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "M.Sc. Biochemistry",
    "slug": "ms-c-biochemistry",
    "path": "/course/allied-health-science/ms-c-biochemistry/",
    "component": "./pages/Courses/AlliedHealthScience/MsCBiochemistry/MsCBiochemistry.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "M.Sc. Bioinformatics",
    "slug": "ms-c-bioinformatics",
    "path": "/course/allied-health-science/ms-c-bioinformatics/",
    "component": "./pages/Courses/AlliedHealthScience/MsCBioinformatics/MsCBioinformatics.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "M.Sc. Clinical Research",
    "slug": "ms-c-clinical-research",
    "path": "/course/allied-health-science/ms-c-clinical-research/",
    "component": "./pages/Courses/AlliedHealthScience/MsCClinicalResearch/MsCClinicalResearch.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "M.Sc. Medical Biotechnology",
    "slug": "ms-c-medical-biotechnology",
    "path": "/course/allied-health-science/ms-c-medical-biotechnology/",
    "component": "./pages/Courses/AlliedHealthScience/MsCMedicalBiotechnology/MsCMedicalBiotechnology.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "M.Sc. Neuroscience",
    "slug": "ms-c-neuroscience",
    "path": "/course/allied-health-science/ms-c-neuroscience/",
    "component": "./pages/Courses/AlliedHealthScience/MsCNeuroscience/MsCNeuroscience.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "M.Sc. Nutrition & Dietetics",
    "slug": "ms-c-nutrition-and-dietetics",
    "path": "/course/allied-health-science/ms-c-nutrition-and-dietetics/",
    "component": "./pages/Courses/AlliedHealthScience/MsCNutritionAndDietetics/MsCNutritionAndDietetics.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "M.Sc. Physiology",
    "slug": "ms-c-physiology",
    "path": "/course/allied-health-science/ms-c-physiology/",
    "component": "./pages/Courses/AlliedHealthScience/MsCPhysiology/MsCPhysiology.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "M.Sc. Public Health",
    "slug": "ms-c-public-health",
    "path": "/course/allied-health-science/ms-c-public-health/",
    "component": "./pages/Courses/AlliedHealthScience/MsCPublicHealth/MsCPublicHealth.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "M.Sc. Radiology / Imaging",
    "slug": "ms-c-radiology-imaging",
    "path": "/course/allied-health-science/ms-c-radiology-imaging/",
    "component": "./pages/Courses/AlliedHealthScience/MsCRadiologyImaging/MsCRadiologyImaging.jsx"
  },
  {
    "category": "allied-health-science",
    "categoryLabel": "Allied Health Science",
    "level": "",
    "name": "MPT — Master of Physiotherapy",
    "slug": "mpt-master-of-physiotherapy",
    "path": "/course/allied-health-science/mpt-master-of-physiotherapy/",
    "component": "./pages/Courses/AlliedHealthScience/MptMasterOfPhysiotherapy/MptMasterOfPhysiotherapy.jsx"
  },
  {
    "category": "veterinary-science",
    "categoryLabel": "Veterinary Science",
    "level": "",
    "name": "Bachelor of Veterinary Science & Animal Husbandry",
    "slug": "bachelor-of-veterinary-science-and-animal-husbandry",
    "path": "/course/veterinary-science/bachelor-of-veterinary-science-and-animal-husbandry/",
    "component": "./pages/Courses/VeterinaryScience/P0150/P0150.jsx"
  },
  {
    "category": "veterinary-science",
    "categoryLabel": "Veterinary Science",
    "level": "",
    "name": "M.V.Sc in Veterinary Science",
    "slug": "mvsc-in-veterinary-science",
    "path": "/course/veterinary-science/mvsc-in-veterinary-science/",
    "component": "./pages/Courses/VeterinaryScience/MvscInVeterinaryScience/MvscInVeterinaryScience.jsx"
  },
  {
    "category": "veterinary-science",
    "categoryLabel": "Veterinary Science",
    "level": "",
    "name": "M.V.Sc. in Animal Nutrition",
    "slug": "mvsc-in-animal-nutrition",
    "path": "/course/veterinary-science/mvsc-in-animal-nutrition/",
    "component": "./pages/Courses/VeterinaryScience/MvscInAnimalNutrition/MvscInAnimalNutrition.jsx"
  },
  {
    "category": "veterinary-science",
    "categoryLabel": "Veterinary Science",
    "level": "",
    "name": "M.V.Sc. in Pharmacology",
    "slug": "mvsc-in-pharmacology",
    "path": "/course/veterinary-science/mvsc-in-pharmacology/",
    "component": "./pages/Courses/VeterinaryScience/MvscInPharmacology/MvscInPharmacology.jsx"
  },
  {
    "category": "veterinary-science",
    "categoryLabel": "Veterinary Science",
    "level": "",
    "name": "M.V.Sc. in Surgery & Radiology",
    "slug": "mvsc-in-surgery-and-radiology",
    "path": "/course/veterinary-science/mvsc-in-surgery-and-radiology/",
    "component": "./pages/Courses/VeterinaryScience/MvscInSurgeryAndRadiology/MvscInSurgeryAndRadiology.jsx"
  },
  {
    "category": "veterinary-science",
    "categoryLabel": "Veterinary Science",
    "level": "",
    "name": "M.V.Sc. in Veterinary Microbiology",
    "slug": "mvsc-in-veterinary-microbiology",
    "path": "/course/veterinary-science/mvsc-in-veterinary-microbiology/",
    "component": "./pages/Courses/VeterinaryScience/MvscInVeterinaryMicrobiology/MvscInVeterinaryMicrobiology.jsx"
  },
  {
    "category": "veterinary-science",
    "categoryLabel": "Veterinary Science",
    "level": "",
    "name": "M.V.Sc. in Veterinary Pathology",
    "slug": "mvsc-in-veterinary-pathology",
    "path": "/course/veterinary-science/mvsc-in-veterinary-pathology/",
    "component": "./pages/Courses/VeterinaryScience/MvscInVeterinaryPathology/MvscInVeterinaryPathology.jsx"
  },
  {
    "category": "veterinary-science",
    "categoryLabel": "Veterinary Science",
    "level": "",
    "name": "Diploma in Animal Husbandry",
    "slug": "diploma-in-animal-husbandry",
    "path": "/course/veterinary-science/diploma-in-animal-husbandry/",
    "component": "./pages/Courses/VeterinaryScience/DiplomaInAnimalHusbandry/DiplomaInAnimalHusbandry.jsx"
  },
  {
    "category": "veterinary-science",
    "categoryLabel": "Veterinary Science",
    "level": "",
    "name": "Diploma in Dairy Farming / Dairy Technology",
    "slug": "diploma-in-dairy-farming-dairy-technology",
    "path": "/course/veterinary-science/diploma-in-dairy-farming-dairy-technology/",
    "component": "./pages/Courses/VeterinaryScience/P0151/P0151.jsx"
  },
  {
    "category": "veterinary-science",
    "categoryLabel": "Veterinary Science",
    "level": "",
    "name": "Diploma in Livestock Development Assistant",
    "slug": "diploma-in-livestock-development-assistant",
    "path": "/course/veterinary-science/diploma-in-livestock-development-assistant/",
    "component": "./pages/Courses/VeterinaryScience/P0152/P0152.jsx"
  },
  {
    "category": "veterinary-science",
    "categoryLabel": "Veterinary Science",
    "level": "",
    "name": "Diploma in Veterinary Lab Technician",
    "slug": "diploma-in-veterinary-lab-technician",
    "path": "/course/veterinary-science/diploma-in-veterinary-lab-technician/",
    "component": "./pages/Courses/VeterinaryScience/P0153/P0153.jsx"
  },
  {
    "category": "veterinary-science",
    "categoryLabel": "Veterinary Science",
    "level": "",
    "name": "Diploma in Veterinary Pharmacy",
    "slug": "diploma-in-veterinary-pharmacy",
    "path": "/course/veterinary-science/diploma-in-veterinary-pharmacy/",
    "component": "./pages/Courses/VeterinaryScience/DiplomaInVeterinaryPharmacy/DiplomaInVeterinaryPharmacy.jsx"
  },
  {
    "category": "veterinary-science",
    "categoryLabel": "Veterinary Science",
    "level": "",
    "name": "Diploma in Veterinary Inspector",
    "slug": "diploma-in-veterinary-inspector",
    "path": "/course/veterinary-science/diploma-in-veterinary-inspector/",
    "component": "./pages/Courses/VeterinaryScience/DiplomaInVeterinaryInspector/DiplomaInVeterinaryInspector.jsx"
  },
  {
    "category": "veterinary-science",
    "categoryLabel": "Veterinary Science",
    "level": "",
    "name": "M.Phil in Animal Biotechnology",
    "slug": "mphil-in-animal-biotechnology",
    "path": "/course/veterinary-science/mphil-in-animal-biotechnology/",
    "component": "./pages/Courses/VeterinaryScience/MphilInAnimalBiotechnology/MphilInAnimalBiotechnology.jsx"
  },
  {
    "category": "veterinary-science",
    "categoryLabel": "Veterinary Science",
    "level": "",
    "name": "M.Phil in Epidemiology",
    "slug": "mphil-in-epidemiology",
    "path": "/course/veterinary-science/mphil-in-epidemiology/",
    "component": "./pages/Courses/VeterinaryScience/MphilInEpidemiology/MphilInEpidemiology.jsx"
  },
  {
    "category": "veterinary-science",
    "categoryLabel": "Veterinary Science",
    "level": "",
    "name": "M.Phil in Livestock Production",
    "slug": "mphil-in-livestock-production",
    "path": "/course/veterinary-science/mphil-in-livestock-production/",
    "component": "./pages/Courses/VeterinaryScience/MphilInLivestockProduction/MphilInLivestockProduction.jsx"
  },
  {
    "category": "veterinary-science",
    "categoryLabel": "Veterinary Science",
    "level": "",
    "name": "M.Phil in Veterinary Medicine",
    "slug": "mphil-in-veterinary-medicine",
    "path": "/course/veterinary-science/mphil-in-veterinary-medicine/",
    "component": "./pages/Courses/VeterinaryScience/MphilInVeterinaryMedicine/MphilInVeterinaryMedicine.jsx"
  },
  {
    "category": "pharmacy",
    "categoryLabel": "Pharmacy",
    "level": "",
    "name": "B.Pharm — Bachelor of Pharmacy",
    "slug": "bpharm-bachelor-of-pharmacy",
    "path": "/course/pharmacy/bpharm-bachelor-of-pharmacy/",
    "component": "./pages/Courses/Pharmacy/BpharmBachelorOfPharmacy/BpharmBachelorOfPharmacy.jsx"
  },
  {
    "category": "pharmacy",
    "categoryLabel": "Pharmacy",
    "level": "",
    "name": "B.Pharm in Lateral Entry",
    "slug": "bpharm-in-lateral-entry",
    "path": "/course/pharmacy/bpharm-in-lateral-entry/",
    "component": "./pages/Courses/Pharmacy/BpharmInLateralEntry/BpharmInLateralEntry.jsx"
  },
  {
    "category": "pharmacy",
    "categoryLabel": "Pharmacy",
    "level": "",
    "name": "B.Sc in Pharmaceutical Analysis",
    "slug": "bsc-in-pharmaceutical-analysis",
    "path": "/course/pharmacy/bsc-in-pharmaceutical-analysis/",
    "component": "./pages/Courses/Pharmacy/BscInPharmaceuticalAnalysis/BscInPharmaceuticalAnalysis.jsx"
  },
  {
    "category": "pharmacy",
    "categoryLabel": "Pharmacy",
    "level": "",
    "name": "B.Sc / B.Tech in Pharmaceutical Biotechnology",
    "slug": "bsc-b-tech-in-pharmaceutical-biotechnology",
    "path": "/course/pharmacy/bsc-b-tech-in-pharmaceutical-biotechnology/",
    "component": "./pages/Courses/Pharmacy/P0143/P0143.jsx"
  },
  {
    "category": "pharmacy",
    "categoryLabel": "Pharmacy",
    "level": "",
    "name": "B.Sc. in Pharmaceutical Chemistry",
    "slug": "bsc-in-pharmaceutical-chemistry",
    "path": "/course/pharmacy/bsc-in-pharmaceutical-chemistry/",
    "component": "./pages/Courses/Pharmacy/BscInPharmaceuticalChemistry/BscInPharmaceuticalChemistry.jsx"
  },
  {
    "category": "pharmacy",
    "categoryLabel": "Pharmacy",
    "level": "",
    "name": "B.Pharm in Pharmaceutics",
    "slug": "bpharm-in-pharmaceutics",
    "path": "/course/pharmacy/bpharm-in-pharmaceutics/",
    "component": "./pages/Courses/Pharmacy/BpharmInPharmaceutics/BpharmInPharmaceutics.jsx"
  },
  {
    "category": "pharmacy",
    "categoryLabel": "Pharmacy",
    "level": "",
    "name": "B.Pharm in Pharmacognosy",
    "slug": "bpharm-in-pharmacognosy",
    "path": "/course/pharmacy/bpharm-in-pharmacognosy/",
    "component": "./pages/Courses/Pharmacy/BpharmInPharmacognosy/BpharmInPharmacognosy.jsx"
  },
  {
    "category": "pharmacy",
    "categoryLabel": "Pharmacy",
    "level": "",
    "name": "B.Pharm / B.Sc in Pharmacology",
    "slug": "bpharm-b-sc-in-pharmacology",
    "path": "/course/pharmacy/bpharm-b-sc-in-pharmacology/",
    "component": "./pages/Courses/Pharmacy/BpharmBScInPharmacology/BpharmBScInPharmacology.jsx"
  },
  {
    "category": "pharmacy",
    "categoryLabel": "Pharmacy",
    "level": "",
    "name": "B.Pharm in Pharmacy Practice",
    "slug": "bpharm-in-pharmacy-practice",
    "path": "/course/pharmacy/bpharm-in-pharmacy-practice/",
    "component": "./pages/Courses/Pharmacy/BpharmInPharmacyPractice/BpharmInPharmacyPractice.jsx"
  },
  {
    "category": "pharmacy",
    "categoryLabel": "Pharmacy",
    "level": "",
    "name": "M.Pharm (Quality Assurance (QA))",
    "slug": "mpharm-quality-assurance-qa",
    "path": "/course/pharmacy/mpharm-quality-assurance-qa/",
    "component": "./pages/Courses/Pharmacy/MpharmQualityAssuranceQa/MpharmQualityAssuranceQa.jsx"
  },
  {
    "category": "pharmacy",
    "categoryLabel": "Pharmacy",
    "level": "",
    "name": "M.Pharm in Pharmaceutical Biotechnology",
    "slug": "mpharm-in-pharmaceutical-biotechnology",
    "path": "/course/pharmacy/mpharm-in-pharmaceutical-biotechnology/",
    "component": "./pages/Courses/Pharmacy/P0144/P0144.jsx"
  },
  {
    "category": "pharmacy",
    "categoryLabel": "Pharmacy",
    "level": "",
    "name": "M.Pharm (Pharmaceutical Analysis)",
    "slug": "mpharm-pharmaceutical-analysis",
    "path": "/course/pharmacy/mpharm-pharmaceutical-analysis/",
    "component": "./pages/Courses/Pharmacy/MpharmPharmaceuticalAnalysis/MpharmPharmaceuticalAnalysis.jsx"
  },
  {
    "category": "pharmacy",
    "categoryLabel": "Pharmacy",
    "level": "",
    "name": "M.Pharm Pharmaceutical Chemistry",
    "slug": "mpharm-pharmaceutical-chemistry",
    "path": "/course/pharmacy/mpharm-pharmaceutical-chemistry/",
    "component": "./pages/Courses/Pharmacy/MpharmPharmaceuticalChemistry/MpharmPharmaceuticalChemistry.jsx"
  },
  {
    "category": "pharmacy",
    "categoryLabel": "Pharmacy",
    "level": "",
    "name": "M.Pharm in Pharmaceutics",
    "slug": "mpharm-in-pharmaceutics",
    "path": "/course/pharmacy/mpharm-in-pharmaceutics/",
    "component": "./pages/Courses/Pharmacy/MpharmInPharmaceutics/MpharmInPharmaceutics.jsx"
  },
  {
    "category": "pharmacy",
    "categoryLabel": "Pharmacy",
    "level": "",
    "name": "M.Pharm in Pharmacognosy",
    "slug": "mpharm-in-pharmacognosy",
    "path": "/course/pharmacy/mpharm-in-pharmacognosy/",
    "component": "./pages/Courses/Pharmacy/MpharmInPharmacognosy/MpharmInPharmacognosy.jsx"
  },
  {
    "category": "pharmacy",
    "categoryLabel": "Pharmacy",
    "level": "",
    "name": "M.Pharm in Pharmacology",
    "slug": "mpharm-in-pharmacology",
    "path": "/course/pharmacy/mpharm-in-pharmacology/",
    "component": "./pages/Courses/Pharmacy/MpharmInPharmacology/MpharmInPharmacology.jsx"
  },
  {
    "category": "pharmacy",
    "categoryLabel": "Pharmacy",
    "level": "",
    "name": "M.Pharm in Pharmacy Practice",
    "slug": "mpharm-in-pharmacy-practice",
    "path": "/course/pharmacy/mpharm-in-pharmacy-practice/",
    "component": "./pages/Courses/Pharmacy/MpharmInPharmacyPractice/MpharmInPharmacyPractice.jsx"
  },
  {
    "category": "pharmacy",
    "categoryLabel": "Pharmacy",
    "level": "",
    "name": "D.Pharm in Diploma in Pharmacy",
    "slug": "dpharm-in-diploma-in-pharmacy",
    "path": "/course/pharmacy/dpharm-in-diploma-in-pharmacy/",
    "component": "./pages/Courses/Pharmacy/DpharmInDiplomaInPharmacy/DpharmInDiplomaInPharmacy.jsx"
  },
  {
    "category": "pharmacy",
    "categoryLabel": "Pharmacy",
    "level": "",
    "name": "Pharm.D (PB) — Post-Baccalaureate",
    "slug": "pharmd-pb-post-baccalaureate",
    "path": "/course/pharmacy/pharmd-pb-post-baccalaureate/",
    "component": "./pages/Courses/Pharmacy/PharmdPbPostBaccalaureate/PharmdPbPostBaccalaureate.jsx"
  },
  {
    "category": "pharmacy",
    "categoryLabel": "Pharmacy",
    "level": "",
    "name": "Pharm.D — Doctor of Pharmacy",
    "slug": "pharmd-doctor-of-pharmacy",
    "path": "/course/pharmacy/pharmd-doctor-of-pharmacy/",
    "component": "./pages/Courses/Pharmacy/PharmdDoctorOfPharmacy/PharmdDoctorOfPharmacy.jsx"
  },
  {
    "category": "pharmacy",
    "categoryLabel": "Pharmacy",
    "level": "",
    "name": "Ph.D in Pharmacy / Pharmaceutical Sciences",
    "slug": "phd-in-pharmacy-pharmaceutical-sciences",
    "path": "/course/pharmacy/phd-in-pharmacy-pharmaceutical-sciences/",
    "component": "./pages/Courses/Pharmacy/P0145/P0145.jsx"
  },
  {
    "category": "nursing",
    "categoryLabel": "Nursing",
    "level": "",
    "name": "B.Sc Nursing",
    "slug": "bsc-nursing",
    "path": "/course/nursing/bsc-nursing/",
    "component": "./pages/Courses/Nursing/BscNursing/BscNursing.jsx"
  },
  {
    "category": "nursing",
    "categoryLabel": "Nursing",
    "level": "",
    "name": "B.Sc Nursing (Post Basic Lateral Entry)",
    "slug": "bsc-nursing-post-basic-lateral-entry",
    "path": "/course/nursing/bsc-nursing-post-basic-lateral-entry/",
    "component": "./pages/Courses/Nursing/BscNursingPostBasicLateralEntry/BscNursingPostBasicLateralEntry.jsx"
  },
  {
    "category": "nursing",
    "categoryLabel": "Nursing",
    "level": "",
    "name": "B.Sc. Pediatric Nursing",
    "slug": "bsc-pediatric-nursing",
    "path": "/course/nursing/bsc-pediatric-nursing/",
    "component": "./pages/Courses/Nursing/BscPediatricNursing/BscPediatricNursing.jsx"
  },
  {
    "category": "nursing",
    "categoryLabel": "Nursing",
    "level": "",
    "name": "B.Sc Psychiatric / Mental Health Nursing",
    "slug": "bsc-psychiatric-mental-health-nursing",
    "path": "/course/nursing/bsc-psychiatric-mental-health-nursing/",
    "component": "./pages/Courses/Nursing/BscPsychiatricMentalHealthNursing/BscPsychiatricMentalHealthNursing.jsx"
  },
  {
    "category": "nursing",
    "categoryLabel": "Nursing",
    "level": "",
    "name": "B.Sc. Public Health Nursing",
    "slug": "bsc-public-health-nursing",
    "path": "/course/nursing/bsc-public-health-nursing/",
    "component": "./pages/Courses/Nursing/BscPublicHealthNursing/BscPublicHealthNursing.jsx"
  },
  {
    "category": "nursing",
    "categoryLabel": "Nursing",
    "level": "",
    "name": "M.Sc Mental Health Nursing",
    "slug": "ms-c-mental-health-nursing",
    "path": "/course/nursing/ms-c-mental-health-nursing/",
    "component": "./pages/Courses/Nursing/MsCMentalHealthNursing/MsCMentalHealthNursing.jsx"
  },
  {
    "category": "nursing",
    "categoryLabel": "Nursing",
    "level": "",
    "name": "M.Sc Nursing",
    "slug": "ms-c-nursing",
    "path": "/course/nursing/ms-c-nursing/",
    "component": "./pages/Courses/Nursing/MsCNursing/MsCNursing.jsx"
  },
  {
    "category": "nursing",
    "categoryLabel": "Nursing",
    "level": "",
    "name": "M.Sc. Community Health Nursing",
    "slug": "ms-c-community-health-nursing",
    "path": "/course/nursing/ms-c-community-health-nursing/",
    "component": "./pages/Courses/Nursing/MsCCommunityHealthNursing/MsCCommunityHealthNursing.jsx"
  },
  {
    "category": "nursing",
    "categoryLabel": "Nursing",
    "level": "",
    "name": "M.Sc. Obstetrics & Gynecology Nursing",
    "slug": "ms-c-obstetrics-and-gynecology-nursing",
    "path": "/course/nursing/ms-c-obstetrics-and-gynecology-nursing/",
    "component": "./pages/Courses/Nursing/MsCObstetricsAndGynecologyNursing/MsCObstetricsAndGynecologyNursing.jsx"
  },
  {
    "category": "nursing",
    "categoryLabel": "Nursing",
    "level": "",
    "name": "M.Sc. Pediatric Nursing",
    "slug": "ms-c-pediatric-nursing",
    "path": "/course/nursing/ms-c-pediatric-nursing/",
    "component": "./pages/Courses/Nursing/MsCPediatricNursing/MsCPediatricNursing.jsx"
  },
  {
    "category": "nursing",
    "categoryLabel": "Nursing",
    "level": "",
    "name": "M.Sc. Surgical Nursing",
    "slug": "ms-c-surgical-nursing",
    "path": "/course/nursing/ms-c-surgical-nursing/",
    "component": "./pages/Courses/Nursing/MsCSurgicalNursing/MsCSurgicalNursing.jsx"
  },
  {
    "category": "nursing",
    "categoryLabel": "Nursing",
    "level": "",
    "name": "Ph.D in Nursing",
    "slug": "phd-in-nursing",
    "path": "/course/nursing/phd-in-nursing/",
    "component": "./pages/Courses/Nursing/PhdInNursing/PhdInNursing.jsx"
  },
  {
    "category": "nursing",
    "categoryLabel": "Nursing",
    "level": "Diploma",
    "name": "General Nursing & Midwifery (GNM)",
    "slug": "general-nursing-midwifery",
    "path": "/course/nursing/general-nursing-midwifery/",
    "component": "./pages/Courses/Nursing/GeneralNursingMidwifery/GeneralNursingMidwifery.jsx"
  },
  {
    "category": "nursing",
    "categoryLabel": "Nursing",
    "level": "Certificate / Diploma",
    "name": "Auxiliary Nurse Midwife (ANM)",
    "slug": "auxiliary-nurse-midwife-anm",
    "path": "/course/nursing/auxiliary-nurse-midwife-anm/",
    "component": "./pages/Courses/Nursing/AuxiliaryNurseMidwifeAnm/AuxiliaryNurseMidwifeAnm.jsx"
  },
  {
    "category": "nursing",
    "categoryLabel": "Nursing",
    "level": "Certificate / Diploma",
    "name": "Psychiatric Nursing Assistant",
    "slug": "psychiatric-nursing-assistant",
    "path": "/course/nursing/psychiatric-nursing-assistant/",
    "component": "./pages/Courses/Nursing/PsychiatricNursingAssistant/PsychiatricNursingAssistant.jsx"
  },
  {
    "category": "physiotherapy",
    "categoryLabel": "Physiotherapy",
    "level": "Undergraduate",
    "name": "BPT – Bachelor of Physiotherapy",
    "slug": "bpt-bachelor-of-physiotherapy",
    "path": "/course/physiotherapy/bpt-bachelor-of-physiotherapy/",
    "component": "./pages/Courses/Physiotherapy/BptBachelorOfPhysiotherapy/BptBachelorOfPhysiotherapy.jsx"
  },
  {
    "category": "physiotherapy",
    "categoryLabel": "Physiotherapy",
    "level": "",
    "name": "MPT – Master of Physiotherapy",
    "slug": "mpt-master-of-physiotherapy",
    "path": "/course/physiotherapy/mpt-master-of-physiotherapy/",
    "component": "./pages/Courses/Physiotherapy/MptMasterOfPhysiotherapy/MptMasterOfPhysiotherapy.jsx"
  },
  {
    "category": "physiotherapy",
    "categoryLabel": "Physiotherapy",
    "level": "",
    "name": "MPT in Neurology",
    "slug": "mpt-in-neurology",
    "path": "/course/physiotherapy/mpt-in-neurology/",
    "component": "./pages/Courses/Physiotherapy/MptInNeurology/MptInNeurology.jsx"
  },
  {
    "category": "physiotherapy",
    "categoryLabel": "Physiotherapy",
    "level": "",
    "name": "MPT in Orthopedics & Sports",
    "slug": "mpt-in-orthopedics-and-sports",
    "path": "/course/physiotherapy/mpt-in-orthopedics-and-sports/",
    "component": "./pages/Courses/Physiotherapy/MptInOrthopedicsAndSports/MptInOrthopedicsAndSports.jsx"
  },
  {
    "category": "physiotherapy",
    "categoryLabel": "Physiotherapy",
    "level": "",
    "name": "MPT in Pediatrics",
    "slug": "mpt-in-pediatrics",
    "path": "/course/physiotherapy/mpt-in-pediatrics/",
    "component": "./pages/Courses/Physiotherapy/MptInPediatrics/MptInPediatrics.jsx"
  },
  {
    "category": "physiotherapy",
    "categoryLabel": "Physiotherapy",
    "level": "",
    "name": "MPT in Cardio-Pulmonary",
    "slug": "mpt-in-cardio-pulmonary",
    "path": "/course/physiotherapy/mpt-in-cardio-pulmonary/",
    "component": "./pages/Courses/Physiotherapy/MptInCardioPulmonary/MptInCardioPulmonary.jsx"
  },
  {
    "category": "physiotherapy",
    "categoryLabel": "Physiotherapy",
    "level": "",
    "name": "MPT in Geriatrics – Elderly Care Physiotherapy",
    "slug": "mpt-in-geriatrics-elderly-care-physiotherapy",
    "path": "/course/physiotherapy/mpt-in-geriatrics-elderly-care-physiotherapy/",
    "component": "./pages/Courses/Physiotherapy/P0146/P0146.jsx"
  },
  {
    "category": "physiotherapy",
    "categoryLabel": "Physiotherapy",
    "level": "",
    "name": "MPT in Obstetrics & Gynecology",
    "slug": "mpt-in-obstetrics-and-gynecology",
    "path": "/course/physiotherapy/mpt-in-obstetrics-and-gynecology/",
    "component": "./pages/Courses/Physiotherapy/MptInObstetricsAndGynecology/MptInObstetricsAndGynecology.jsx"
  },
  {
    "category": "physiotherapy",
    "categoryLabel": "Physiotherapy",
    "level": "",
    "name": "MPT in Community Physiotherapy",
    "slug": "mpt-in-community-physiotherapy",
    "path": "/course/physiotherapy/mpt-in-community-physiotherapy/",
    "component": "./pages/Courses/Physiotherapy/MptInCommunityPhysiotherapy/MptInCommunityPhysiotherapy.jsx"
  },
  {
    "category": "physiotherapy",
    "categoryLabel": "Physiotherapy",
    "level": "",
    "name": "MPT in Hand Therapy",
    "slug": "mpt-in-hand-therapy",
    "path": "/course/physiotherapy/mpt-in-hand-therapy/",
    "component": "./pages/Courses/Physiotherapy/MptInHandTherapy/MptInHandTherapy.jsx"
  },
  {
    "category": "physiotherapy",
    "categoryLabel": "Physiotherapy",
    "level": "",
    "name": "M.Phil in Physiotherapy",
    "slug": "mphil-in-physiotherapy",
    "path": "/course/physiotherapy/mphil-in-physiotherapy/",
    "component": "./pages/Courses/Physiotherapy/MphilInPhysiotherapy/MphilInPhysiotherapy.jsx"
  },
  {
    "category": "physiotherapy",
    "categoryLabel": "Physiotherapy",
    "level": "",
    "name": "Ph.D. Physiotherapy",
    "slug": "phd-physiotherapy",
    "path": "/course/physiotherapy/phd-physiotherapy/",
    "component": "./pages/Courses/Physiotherapy/PhdPhysiotherapy/PhdPhysiotherapy.jsx"
  },
  {
    "category": "occupational-therapy",
    "categoryLabel": "Occupational Therapy",
    "level": "",
    "name": "B.O.T / B.O.Th — Bachelor of Occupational Therapy",
    "slug": "bot-b-o-th-bachelor-of-occupational-therapy",
    "path": "/course/occupational-therapy/bot-b-o-th-bachelor-of-occupational-therapy/",
    "component": "./pages/Courses/OccupationalTherapy/P0140/P0140.jsx"
  },
  {
    "category": "occupational-therapy",
    "categoryLabel": "Occupational Therapy",
    "level": "",
    "name": "M.O.T — Master of Occupational Therapy",
    "slug": "mot-master-of-occupational-therapy",
    "path": "/course/occupational-therapy/mot-master-of-occupational-therapy/",
    "component": "./pages/Courses/OccupationalTherapy/P0141/P0141.jsx"
  },
  {
    "category": "occupational-therapy",
    "categoryLabel": "Occupational Therapy",
    "level": "",
    "name": "Ph.D. in Occupational Therapy / Rehabilitation Sciences",
    "slug": "phd-in-occupational-therapy-rehabilitation-sciences",
    "path": "/course/occupational-therapy/phd-in-occupational-therapy-rehabilitation-sciences/",
    "component": "./pages/Courses/OccupationalTherapy/P0142/P0142.jsx"
  },
  {
    "category": "ayurveda",
    "categoryLabel": "Ayurveda",
    "level": "ug",
    "name": "BAMS – Bachelor of Ayurvedic Medicine & Surgery",
    "slug": "bams-bachelor-of-ayurvedic-medicine-and-surgery",
    "path": "/course/ayurveda/bams-bachelor-of-ayurvedic-medicine-and-surgery/",
    "component": "./pages/Courses/Ayurveda/P0038/P0038.jsx"
  },
  {
    "category": "ayurveda",
    "categoryLabel": "Ayurveda",
    "level": "ug",
    "name": "MD (Ayurveda) – Agad Tantra",
    "slug": "md-ayurveda-agad-tantra",
    "path": "/course/ayurveda/md-ayurveda-agad-tantra/",
    "component": "./pages/Courses/Ayurveda/MdAyurvedaAgadTantra/MdAyurvedaAgadTantra.jsx"
  },
  {
    "category": "ayurveda",
    "categoryLabel": "Ayurveda",
    "level": "ug",
    "name": "MD (Ayurveda) – Dravyaguna Vijnanam",
    "slug": "md-ayurveda-dravyaguna-vijnanam",
    "path": "/course/ayurveda/md-ayurveda-dravyaguna-vijnanam/",
    "component": "./pages/Courses/Ayurveda/MdAyurvedaDravyagunaVijnanam/MdAyurvedaDravyagunaVijnanam.jsx"
  },
  {
    "category": "ayurveda",
    "categoryLabel": "Ayurveda",
    "level": "ug",
    "name": "MD (Ayurveda) – Kaumarabhritya",
    "slug": "md-ayurveda-kaumarabhritya",
    "path": "/course/ayurveda/md-ayurveda-kaumarabhritya/",
    "component": "./pages/Courses/Ayurveda/MdAyurvedaKaumarabhritya/MdAyurvedaKaumarabhritya.jsx"
  },
  {
    "category": "ayurveda",
    "categoryLabel": "Ayurveda",
    "level": "ug",
    "name": "MD (Ayurveda) – Kayachikitsa",
    "slug": "md-ayurveda-kayachikitsa",
    "path": "/course/ayurveda/md-ayurveda-kayachikitsa/",
    "component": "./pages/Courses/Ayurveda/MdAyurvedaKayachikitsa/MdAyurvedaKayachikitsa.jsx"
  },
  {
    "category": "ayurveda",
    "categoryLabel": "Ayurveda",
    "level": "ug",
    "name": "MD (Ayurveda) – Panchakarma",
    "slug": "md-ayurveda-panchakarma",
    "path": "/course/ayurveda/md-ayurveda-panchakarma/",
    "component": "./pages/Courses/Ayurveda/MdAyurvedaPanchakarma/MdAyurvedaPanchakarma.jsx"
  },
  {
    "category": "ayurveda",
    "categoryLabel": "Ayurveda",
    "level": "ug",
    "name": "MD (Ayurveda) – Prasuti & Stree Roga",
    "slug": "md-ayurveda-prasuti-and-stree-roga",
    "path": "/course/ayurveda/md-ayurveda-prasuti-and-stree-roga/",
    "component": "./pages/Courses/Ayurveda/MdAyurvedaPrasutiAndStreeRoga/MdAyurvedaPrasutiAndStreeRoga.jsx"
  },
  {
    "category": "ayurveda",
    "categoryLabel": "Ayurveda",
    "level": "ug",
    "name": "MD (Ayurveda) – Rasashastra & Bhaishajya Kalpana",
    "slug": "md-ayurveda-rasashastra-and-bhaishajya-kalpana",
    "path": "/course/ayurveda/md-ayurveda-rasashastra-and-bhaishajya-kalpana/",
    "component": "./pages/Courses/Ayurveda/P0039/P0039.jsx"
  },
  {
    "category": "ayurveda",
    "categoryLabel": "Ayurveda",
    "level": "ug",
    "name": "MD (Ayurveda) – Samhita & Siddhanta",
    "slug": "md-ayurveda-samhita-and-siddhanta",
    "path": "/course/ayurveda/md-ayurveda-samhita-and-siddhanta/",
    "component": "./pages/Courses/Ayurveda/MdAyurvedaSamhitaAndSiddhanta/MdAyurvedaSamhitaAndSiddhanta.jsx"
  },
  {
    "category": "ayurveda",
    "categoryLabel": "Ayurveda",
    "level": "ug",
    "name": "MD (Ayurveda) – Sharira Kriya",
    "slug": "md-ayurveda-sharira-kriya",
    "path": "/course/ayurveda/md-ayurveda-sharira-kriya/",
    "component": "./pages/Courses/Ayurveda/MdAyurvedaShariraKriya/MdAyurvedaShariraKriya.jsx"
  },
  {
    "category": "ayurveda",
    "categoryLabel": "Ayurveda",
    "level": "ug",
    "name": "MD (Ayurveda) – Sharira Rachana",
    "slug": "md-ayurveda-sharira-rachana",
    "path": "/course/ayurveda/md-ayurveda-sharira-rachana/",
    "component": "./pages/Courses/Ayurveda/MdAyurvedaShariraRachana/MdAyurvedaShariraRachana.jsx"
  },
  {
    "category": "ayurveda",
    "categoryLabel": "Ayurveda",
    "level": "ug",
    "name": "MD (Ayurveda) – Swasthavritta & Yoga",
    "slug": "md-ayurveda-swasthavritta-and-yoga",
    "path": "/course/ayurveda/md-ayurveda-swasthavritta-and-yoga/",
    "component": "./pages/Courses/Ayurveda/MdAyurvedaSwasthavrittaAndYoga/MdAyurvedaSwasthavrittaAndYoga.jsx"
  },
  {
    "category": "ayurveda",
    "categoryLabel": "Ayurveda",
    "level": "ug",
    "name": "MS (Ayurveda) – Shalakya Tantra",
    "slug": "ms-ayurveda-shalakya-tantra",
    "path": "/course/ayurveda/ms-ayurveda-shalakya-tantra/",
    "component": "./pages/Courses/Ayurveda/MsAyurvedaShalakyaTantra/MsAyurvedaShalakyaTantra.jsx"
  },
  {
    "category": "ayurveda",
    "categoryLabel": "Ayurveda",
    "level": "ug",
    "name": "MS (Ayurveda) – Shalya Tantra",
    "slug": "ms-ayurveda-shalya-tantra",
    "path": "/course/ayurveda/ms-ayurveda-shalya-tantra/",
    "component": "./pages/Courses/Ayurveda/MsAyurvedaShalyaTantra/MsAyurvedaShalyaTantra.jsx"
  },
  {
    "category": "homeopathy",
    "categoryLabel": "Homeopathy",
    "level": "UG",
    "name": "Bachelor of Homoepathic Medicine (BHMS)",
    "slug": "bachelor-of-homoepathic-medicine-bhms",
    "path": "/course/homeopathy/bachelor-of-homoepathic-medicine-bhms/",
    "component": "./pages/Courses/Homeopathy/BachelorOfHomoepathicMedicineBhms/BachelorOfHomoepathicMedicineBhms.jsx"
  },
  {
    "category": "homeopathy",
    "categoryLabel": "Homeopathy",
    "level": "PG",
    "name": "MD (Homoeopathy) – Surgery",
    "slug": "md-homoeopathy-surgery",
    "path": "/course/homeopathy/md-homoeopathy-surgery/",
    "component": "./pages/Courses/Homeopathy/MdHomoeopathySurgery/MdHomoeopathySurgery.jsx"
  },
  {
    "category": "homeopathy",
    "categoryLabel": "Homeopathy",
    "level": "PG",
    "name": "MD Homeopathy – Anatomy",
    "slug": "md-homeopathy-anatomy",
    "path": "/course/homeopathy/md-homeopathy-anatomy/",
    "component": "./pages/Courses/Homeopathy/MdHomeopathyAnatomy/MdHomeopathyAnatomy.jsx"
  },
  {
    "category": "homeopathy",
    "categoryLabel": "Homeopathy",
    "level": "PG",
    "name": "MD Homeopathy – Community Medicine",
    "slug": "md-homeopathy-community-medicine",
    "path": "/course/homeopathy/md-homeopathy-community-medicine/",
    "component": "./pages/Courses/Homeopathy/MdHomeopathyCommunityMedicine/MdHomeopathyCommunityMedicine.jsx"
  },
  {
    "category": "homeopathy",
    "categoryLabel": "Homeopathy",
    "level": "PG",
    "name": "MD Homeopathy – Gynaecology & Obstetrics",
    "slug": "md-homeopathy-gynaecology-and-obstetrics",
    "path": "/course/homeopathy/md-homeopathy-gynaecology-and-obstetrics/",
    "component": "./pages/Courses/Homeopathy/MdHomeopathyGynaecologyAndObstetrics/MdHomeopathyGynaecologyAndObstetrics.jsx"
  },
  {
    "category": "homeopathy",
    "categoryLabel": "Homeopathy",
    "level": "PG",
    "name": "MD Homeopathy – Materia Medica",
    "slug": "md-homeopathy-materia-medica",
    "path": "/course/homeopathy/md-homeopathy-materia-medica/",
    "component": "./pages/Courses/Homeopathy/MdHomeopathyMateriaMedica/MdHomeopathyMateriaMedica.jsx"
  },
  {
    "category": "homeopathy",
    "categoryLabel": "Homeopathy",
    "level": "PG",
    "name": "MD Homeopathy – Organon of Medicine",
    "slug": "md-homeopathy-organon-of-medicine",
    "path": "/course/homeopathy/md-homeopathy-organon-of-medicine/",
    "component": "./pages/Courses/Homeopathy/MdHomeopathyOrganonOfMedicine/MdHomeopathyOrganonOfMedicine.jsx"
  },
  {
    "category": "homeopathy",
    "categoryLabel": "Homeopathy",
    "level": "PG",
    "name": "MD Homeopathy – Paediatrics",
    "slug": "md-homeopathy-paediatrics",
    "path": "/course/homeopathy/md-homeopathy-paediatrics/",
    "component": "./pages/Courses/Homeopathy/MdHomeopathyPaediatrics/MdHomeopathyPaediatrics.jsx"
  },
  {
    "category": "homeopathy",
    "categoryLabel": "Homeopathy",
    "level": "PG",
    "name": "MD Homeopathy – Pathology & Microbiology",
    "slug": "md-homeopathy-pathology-and-microbiology",
    "path": "/course/homeopathy/md-homeopathy-pathology-and-microbiology/",
    "component": "./pages/Courses/Homeopathy/MdHomeopathyPathologyAndMicrobiology/MdHomeopathyPathologyAndMicrobiology.jsx"
  },
  {
    "category": "homeopathy",
    "categoryLabel": "Homeopathy",
    "level": "PG",
    "name": "MD Homeopathy – Pharmacy",
    "slug": "md-homeopathy-pharmacy",
    "path": "/course/homeopathy/md-homeopathy-pharmacy/",
    "component": "./pages/Courses/Homeopathy/MdHomeopathyPharmacy/MdHomeopathyPharmacy.jsx"
  },
  {
    "category": "homeopathy",
    "categoryLabel": "Homeopathy",
    "level": "PG",
    "name": "MD Homeopathy – Physiology",
    "slug": "md-homeopathy-physiology",
    "path": "/course/homeopathy/md-homeopathy-physiology/",
    "component": "./pages/Courses/Homeopathy/MdHomeopathyPhysiology/MdHomeopathyPhysiology.jsx"
  },
  {
    "category": "homeopathy",
    "categoryLabel": "Homeopathy",
    "level": "PG",
    "name": "MD Homeopathy – Practice of Medicine",
    "slug": "md-homeopathy-practice-of-medicine",
    "path": "/course/homeopathy/md-homeopathy-practice-of-medicine/",
    "component": "./pages/Courses/Homeopathy/MdHomeopathyPracticeOfMedicine/MdHomeopathyPracticeOfMedicine.jsx"
  },
  {
    "category": "homeopathy",
    "categoryLabel": "Homeopathy",
    "level": "PG",
    "name": "MD Homeopathy – Psychiatry",
    "slug": "md-homeopathy-psychiatry",
    "path": "/course/homeopathy/md-homeopathy-psychiatry/",
    "component": "./pages/Courses/Homeopathy/MdHomeopathyPsychiatry/MdHomeopathyPsychiatry.jsx"
  },
  {
    "category": "homeopathy",
    "categoryLabel": "Homeopathy",
    "level": "PG",
    "name": "MD Homeopathy – Repertory",
    "slug": "md-homeopathy-repertory",
    "path": "/course/homeopathy/md-homeopathy-repertory/",
    "component": "./pages/Courses/Homeopathy/MdHomeopathyRepertory/MdHomeopathyRepertory.jsx"
  },
  {
    "category": "homeopathy",
    "categoryLabel": "Homeopathy",
    "level": "PG",
    "name": "MD Homeopathy – Forensic Medicine",
    "slug": "md-homeopathy-forensic-medicine",
    "path": "/course/homeopathy/md-homeopathy-forensic-medicine/",
    "component": "./pages/Courses/Homeopathy/MdHomeopathyForensicMedicine/MdHomeopathyForensicMedicine.jsx"
  },
  {
    "category": "homeopathy",
    "categoryLabel": "Homeopathy",
    "level": "PG",
    "name": "MD Homeopathy – Biochemistry",
    "slug": "md-homeopathy-biochemistry",
    "path": "/course/homeopathy/md-homeopathy-biochemistry/",
    "component": "./pages/Courses/Homeopathy/MdHomeopathyBiochemistry/MdHomeopathyBiochemistry.jsx"
  },
  {
    "category": "homeopathy",
    "categoryLabel": "Homeopathy",
    "level": "Diploma",
    "name": "Diploma in Homeopathy Assistant",
    "slug": "diploma-in-homeopathy-assistant",
    "path": "/course/homeopathy/diploma-in-homeopathy-assistant/",
    "component": "./pages/Courses/Homeopathy/DiplomaInHomeopathyAssistant/DiplomaInHomeopathyAssistant.jsx"
  },
  {
    "category": "homeopathy",
    "categoryLabel": "Homeopathy",
    "level": "Diploma",
    "name": "Diploma in Homeopathy Nursing",
    "slug": "diploma-in-homeopathy-nursing",
    "path": "/course/homeopathy/diploma-in-homeopathy-nursing/",
    "component": "./pages/Courses/Homeopathy/DiplomaInHomeopathyNursing/DiplomaInHomeopathyNursing.jsx"
  },
  {
    "category": "homeopathy",
    "categoryLabel": "Homeopathy",
    "level": "Diploma",
    "name": "Diploma in Homeopathy Pharmacy",
    "slug": "diploma-in-homeopathy-pharmacy",
    "path": "/course/homeopathy/diploma-in-homeopathy-pharmacy/",
    "component": "./pages/Courses/Homeopathy/DiplomaInHomeopathyPharmacy/DiplomaInHomeopathyPharmacy.jsx"
  },
  {
    "category": "homeopathy",
    "categoryLabel": "Homeopathy",
    "level": "Diploma",
    "name": "Diploma in Homoeopathic Medicine & Surgery",
    "slug": "diploma-in-homoeopathic-medicine-and-surgery",
    "path": "/course/homeopathy/diploma-in-homoeopathic-medicine-and-surgery/",
    "component": "./pages/Courses/Homeopathy/DiplomaInHomoeopathicMedicineAndSurgery/DiplomaInHomoeopathicMedicineAndSurgery.jsx"
  },
  {
    "category": "homeopathy",
    "categoryLabel": "Homeopathy",
    "level": "PhD",
    "name": "Ph.D in Homeopathy",
    "slug": "phd-in-homeopathy",
    "path": "/course/homeopathy/phd-in-homeopathy/",
    "component": "./pages/Courses/Homeopathy/PhdInHomeopathy/PhdInHomeopathy.jsx"
  },
  {
    "category": "unani",
    "categoryLabel": "Unani Medicine",
    "level": "UG",
    "name": "BUMS – Bachelor of Unani Medicine and Surgery",
    "slug": "bums-bachelor-of-unani-medicine-and-surgery",
    "path": "/course/unani/bums-bachelor-of-unani-medicine-and-surgery/",
    "component": "./pages/Courses/Unani/P0149/P0149.jsx"
  },
  {
    "category": "unani",
    "categoryLabel": "Unani Medicine",
    "level": "PG",
    "name": "MD (Unani) with Some Specialisation",
    "slug": "md-unani-with-some-specialisation",
    "path": "/course/unani/md-unani-with-some-specialisation/",
    "component": "./pages/Courses/Unani/MdUnaniWithSomeSpecialisation/MdUnaniWithSomeSpecialisation.jsx"
  },
  {
    "category": "unani",
    "categoryLabel": "Unani Medicine",
    "level": "Diploma",
    "name": "Diploma in Unani Assistant",
    "slug": "diploma-in-unani-assistant",
    "path": "/course/unani/diploma-in-unani-assistant/",
    "component": "./pages/Courses/Unani/DiplomaInUnaniAssistant/DiplomaInUnaniAssistant.jsx"
  },
  {
    "category": "unani",
    "categoryLabel": "Unani Medicine",
    "level": "Diploma",
    "name": "Diploma in Unani Medicine",
    "slug": "diploma-in-unani-medicine",
    "path": "/course/unani/diploma-in-unani-medicine/",
    "component": "./pages/Courses/Unani/DiplomaInUnaniMedicine/DiplomaInUnaniMedicine.jsx"
  },
  {
    "category": "unani",
    "categoryLabel": "Unani Medicine",
    "level": "Diploma",
    "name": "Diploma in Unani Pharmacy",
    "slug": "diploma-in-unani-pharmacy",
    "path": "/course/unani/diploma-in-unani-pharmacy/",
    "component": "./pages/Courses/Unani/DiplomaInUnaniPharmacy/DiplomaInUnaniPharmacy.jsx"
  },
  {
    "category": "unani",
    "categoryLabel": "Unani Medicine",
    "level": "Diploma",
    "name": "Diploma in Unani Science",
    "slug": "diploma-in-unani-science",
    "path": "/course/unani/diploma-in-unani-science/",
    "component": "./pages/Courses/Unani/DiplomaInUnaniScience/DiplomaInUnaniScience.jsx"
  },
  {
    "category": "unani",
    "categoryLabel": "Unani Medicine",
    "level": "Diploma",
    "name": "Diploma in Unani Therapy",
    "slug": "diploma-in-unani-therapy",
    "path": "/course/unani/diploma-in-unani-therapy/",
    "component": "./pages/Courses/Unani/DiplomaInUnaniTherapy/DiplomaInUnaniTherapy.jsx"
  },
  {
    "category": "teacher-education",
    "categoryLabel": "Teacher Education",
    "level": "UG",
    "name": "B.Ed – Bachelor of Education",
    "slug": "be-d-bachelor-of-education",
    "path": "/course/teacher-education/be-d-bachelor-of-education/",
    "component": "./pages/Courses/TeacherEducation/BeDBachelorOfEducation/BeDBachelorOfEducation.jsx"
  },
  {
    "category": "teacher-education",
    "categoryLabel": "Teacher Education",
    "level": "UG",
    "name": "B.Ed Special Education",
    "slug": "be-d-special-education",
    "path": "/course/teacher-education/be-d-special-education/",
    "component": "./pages/Courses/TeacherEducation/BeDSpecialEducation/BeDSpecialEducation.jsx"
  },
  {
    "category": "teacher-education",
    "categoryLabel": "Teacher Education",
    "level": "UG",
    "name": "B.A B.Ed (Integrated)",
    "slug": "ba-b-ed-integrated",
    "path": "/course/teacher-education/ba-b-ed-integrated/",
    "component": "./pages/Courses/TeacherEducation/BaBEdIntegrated/BaBEdIntegrated.jsx"
  },
  {
    "category": "teacher-education",
    "categoryLabel": "Teacher Education",
    "level": "UG",
    "name": "B.Sc B.Ed (Integrated Program)",
    "slug": "bsc-b-ed-integrated-program",
    "path": "/course/teacher-education/bsc-b-ed-integrated-program/",
    "component": "./pages/Courses/TeacherEducation/BscBEdIntegratedProgram/BscBEdIntegratedProgram.jsx"
  },
  {
    "category": "teacher-education",
    "categoryLabel": "Teacher Education",
    "level": "PG",
    "name": "M.Ed. – Master of Education",
    "slug": "me-d-master-of-education",
    "path": "/course/teacher-education/me-d-master-of-education/",
    "component": "./pages/Courses/TeacherEducation/MeDMasterOfEducation/MeDMasterOfEducation.jsx"
  },
  {
    "category": "teacher-education",
    "categoryLabel": "Teacher Education",
    "level": "PG",
    "name": "M.Ed. Special Education",
    "slug": "me-d-special-education",
    "path": "/course/teacher-education/me-d-special-education/",
    "component": "./pages/Courses/TeacherEducation/MeDSpecialEducation/MeDSpecialEducation.jsx"
  },
  {
    "category": "teacher-education",
    "categoryLabel": "Teacher Education",
    "level": "Diploma",
    "name": "D.El.Ed / D.Ed – Diploma in Elementary Education",
    "slug": "deled-diploma-in-elementary-education",
    "path": "/course/teacher-education/deled-diploma-in-elementary-education/",
    "component": "./pages/Courses/TeacherEducation/P0148/P0148.jsx"
  },
  {
    "category": "teacher-education",
    "categoryLabel": "Teacher Education",
    "level": "PhD",
    "name": "Ph.D. in Education",
    "slug": "phd-in-education",
    "path": "/course/teacher-education/phd-in-education/",
    "component": "./pages/Courses/TeacherEducation/PhdInEducation/PhdInEducation.jsx"
  },
  {
    "category": "marine-nautical",
    "categoryLabel": "Marine & Nautical",
    "level": "",
    "name": "Marine & Nautical Courses — >",
    "slug": "marine-and-nautical-courses",
    "path": "/course/marine-nautical/marine-and-nautical-courses/",
    "component": "./pages/Courses/MarineNautical/MarineAndNauticalCourses/MarineAndNauticalCourses.jsx"
  },
  {
    "category": "marine-nautical",
    "categoryLabel": "Marine & Nautical",
    "level": "UG",
    "name": "B.E / B.Tech Naval Architecture & Offshore Engineering",
    "slug": "be-b-tech-naval-architecture-and-offshore-engineering",
    "path": "/course/marine-nautical/be-b-tech-naval-architecture-and-offshore-engineering/",
    "component": "./pages/Courses/MarineNautical/P0121/P0121.jsx"
  },
  {
    "category": "marine-nautical",
    "categoryLabel": "Marine & Nautical",
    "level": "UG",
    "name": "B.Sc. Marine Biology / Oceanography",
    "slug": "bsc-marine-biology-oceanography",
    "path": "/course/marine-nautical/bsc-marine-biology-oceanography/",
    "component": "./pages/Courses/MarineNautical/BscMarineBiologyOceanography/BscMarineBiologyOceanography.jsx"
  },
  {
    "category": "marine-nautical",
    "categoryLabel": "Marine & Nautical",
    "level": "UG",
    "name": "B.Sc. Nautical Science",
    "slug": "bsc-nautical-science",
    "path": "/course/marine-nautical/bsc-nautical-science/",
    "component": "./pages/Courses/MarineNautical/BscNauticalScience/BscNauticalScience.jsx"
  },
  {
    "category": "marine-nautical",
    "categoryLabel": "Marine & Nautical",
    "level": "UG",
    "name": "B.Tech / B.E Marine Engineering",
    "slug": "btech-b-e-marine-engineering",
    "path": "/course/marine-nautical/btech-b-e-marine-engineering/",
    "component": "./pages/Courses/MarineNautical/BtechBEMarineEngineering/BtechBEMarineEngineering.jsx"
  },
  {
    "category": "marine-nautical",
    "categoryLabel": "Marine & Nautical",
    "level": "PG",
    "name": "M.Sc in Marine Science / Oceanography",
    "slug": "ms-c-in-marine-science-oceanography",
    "path": "/course/marine-nautical/ms-c-in-marine-science-oceanography/",
    "component": "./pages/Courses/MarineNautical/MsCInMarineScienceOceanography/MsCInMarineScienceOceanography.jsx"
  },
  {
    "category": "marine-nautical",
    "categoryLabel": "Marine & Nautical",
    "level": "PG",
    "name": "M.Tech / M.E in Marine Engineering",
    "slug": "mtech-m-e-in-marine-engineering",
    "path": "/course/marine-nautical/mtech-m-e-in-marine-engineering/",
    "component": "./pages/Courses/MarineNautical/MtechMEInMarineEngineering/MtechMEInMarineEngineering.jsx"
  },
  {
    "category": "marine-nautical",
    "categoryLabel": "Marine & Nautical",
    "level": "PG",
    "name": "M.Tech / M.E in Naval Architecture / Offshore Engineering",
    "slug": "mtech-m-e-in-naval-architecture-offshore-engineering",
    "path": "/course/marine-nautical/mtech-m-e-in-naval-architecture-offshore-engineering/",
    "component": "./pages/Courses/MarineNautical/P0123/P0123.jsx"
  },
  {
    "category": "marine-nautical",
    "categoryLabel": "Marine & Nautical",
    "level": "PG",
    "name": "MBA in Shipping / Port / Logistics / Maritime Management",
    "slug": "mba-in-shipping-port-logistics-maritime-management",
    "path": "/course/marine-nautical/mba-in-shipping-port-logistics-maritime-management/",
    "component": "./pages/Courses/MarineNautical/P0122/P0122.jsx"
  },
  {
    "category": "marine-nautical",
    "categoryLabel": "Marine & Nautical",
    "level": "Diploma",
    "name": "Diploma in Engine Room Rating (ERR)",
    "slug": "diploma-in-engine-room-rating-err",
    "path": "/course/marine-nautical/diploma-in-engine-room-rating-err/",
    "component": "./pages/Courses/MarineNautical/DiplomaInEngineRoomRatingErr/DiplomaInEngineRoomRatingErr.jsx"
  },
  {
    "category": "marine-nautical",
    "categoryLabel": "Marine & Nautical",
    "level": "Diploma",
    "name": "Diploma in GP Rating",
    "slug": "diploma-in-gp-rating",
    "path": "/course/marine-nautical/diploma-in-gp-rating/",
    "component": "./pages/Courses/MarineNautical/DiplomaInGpRating/DiplomaInGpRating.jsx"
  },
  {
    "category": "marine-nautical",
    "categoryLabel": "Marine & Nautical",
    "level": "Diploma",
    "name": "Diploma in Nautical Science (DNS)",
    "slug": "diploma-in-nautical-science-dns",
    "path": "/course/marine-nautical/diploma-in-nautical-science-dns/",
    "component": "./pages/Courses/MarineNautical/DiplomaInNauticalScienceDns/DiplomaInNauticalScienceDns.jsx"
  },
  {
    "category": "marine-nautical",
    "categoryLabel": "Marine & Nautical",
    "level": "Diploma",
    "name": "Diploma in Saloon Rating",
    "slug": "diploma-in-saloon-rating",
    "path": "/course/marine-nautical/diploma-in-saloon-rating/",
    "component": "./pages/Courses/MarineNautical/DiplomaInSaloonRating/DiplomaInSaloonRating.jsx"
  },
  {
    "category": "marine-nautical",
    "categoryLabel": "Marine & Nautical",
    "level": "Diploma",
    "name": "Diploma in STCW Basic Safety",
    "slug": "diploma-in-stcw-basic-safety",
    "path": "/course/marine-nautical/diploma-in-stcw-basic-safety/",
    "component": "./pages/Courses/MarineNautical/DiplomaInStcwBasicSafety/DiplomaInStcwBasicSafety.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "B.A in Tourism & Hotel Management",
    "slug": "ba-in-tourism-and-hotel-management",
    "path": "/course/hotel-management/ba-in-tourism-and-hotel-management/",
    "component": "./pages/Courses/HotelManagement/BaInTourismAndHotelManagement/BaInTourismAndHotelManagement.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "B.Sc Airline Catering & Hospitality Management",
    "slug": "bsc-airline-catering-and-hospitality-management",
    "path": "/course/hotel-management/bsc-airline-catering-and-hospitality-management/",
    "component": "./pages/Courses/HotelManagement/P0103/P0103.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "B.Sc in Culinary Arts",
    "slug": "bsc-in-culinary-arts",
    "path": "/course/hotel-management/bsc-in-culinary-arts/",
    "component": "./pages/Courses/HotelManagement/BscInCulinaryArts/BscInCulinaryArts.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "B.Sc Hospitality & Hotel Administration",
    "slug": "bsc-hospitality-and-hotel-administration",
    "path": "/course/hotel-management/bsc-hospitality-and-hotel-administration/",
    "component": "./pages/Courses/HotelManagement/P0106/P0106.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "B.Sc Hotel Management",
    "slug": "bsc-hotel-management",
    "path": "/course/hotel-management/bsc-hotel-management/",
    "component": "./pages/Courses/HotelManagement/BscHotelManagement/BscHotelManagement.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "B.Sc Tourism & Hospitality Management",
    "slug": "bsc-tourism-and-hospitality-management",
    "path": "/course/hotel-management/bsc-tourism-and-hospitality-management/",
    "component": "./pages/Courses/HotelManagement/P0107/P0107.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "BBA Hospitality Management",
    "slug": "bba-hospitality-management",
    "path": "/course/hotel-management/bba-hospitality-management/",
    "component": "./pages/Courses/HotelManagement/BbaHospitalityManagement/BbaHospitalityManagement.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "BBA Hotel Management",
    "slug": "bba-hotel-management",
    "path": "/course/hotel-management/bba-hotel-management/",
    "component": "./pages/Courses/HotelManagement/BbaHotelManagement/BbaHotelManagement.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "BBA Tourism & Hotel Management",
    "slug": "bba-tourism-and-hotel-management",
    "path": "/course/hotel-management/bba-tourism-and-hotel-management/",
    "component": "./pages/Courses/HotelManagement/BbaTourismAndHotelManagement/BbaTourismAndHotelManagement.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "B.Sc. Fishery Economics & Management",
    "slug": "bsc-fishery-economics-and-management",
    "path": "/course/hotel-management/bsc-fishery-economics-and-management/",
    "component": "./pages/Courses/HotelManagement/P0105/P0105.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "B.Sc. Catering Science & Hospital Management",
    "slug": "bsc-catering-science-and-hospital-management",
    "path": "/course/hotel-management/bsc-catering-science-and-hospital-management/",
    "component": "./pages/Courses/HotelManagement/P0104/P0104.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "M.Sc. in Culinary Arts",
    "slug": "ms-c-in-culinary-arts",
    "path": "/course/hotel-management/ms-c-in-culinary-arts/",
    "component": "./pages/Courses/HotelManagement/MsCInCulinaryArts/MsCInCulinaryArts.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "M.Sc. in Hospitality Management",
    "slug": "ms-c-in-hospitality-management",
    "path": "/course/hotel-management/ms-c-in-hospitality-management/",
    "component": "./pages/Courses/HotelManagement/MsCInHospitalityManagement/MsCInHospitalityManagement.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "M.Sc. in Hotel Management",
    "slug": "ms-c-in-hotel-management",
    "path": "/course/hotel-management/ms-c-in-hotel-management/",
    "component": "./pages/Courses/HotelManagement/MsCInHotelManagement/MsCInHotelManagement.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "M.Sc. in Tourism Management",
    "slug": "ms-c-in-tourism-management",
    "path": "/course/hotel-management/ms-c-in-tourism-management/",
    "component": "./pages/Courses/HotelManagement/MsCInTourismManagement/MsCInTourismManagement.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "MBA in Hospitality Management",
    "slug": "mba-in-hospitality-management",
    "path": "/course/hotel-management/mba-in-hospitality-management/",
    "component": "./pages/Courses/HotelManagement/MbaInHospitalityManagement/MbaInHospitalityManagement.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "MBA in Hotel Management",
    "slug": "mba-in-hotel-management",
    "path": "/course/hotel-management/mba-in-hotel-management/",
    "component": "./pages/Courses/HotelManagement/MbaInHotelManagement/MbaInHotelManagement.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "MBA in Tourism & Travel Management",
    "slug": "mba-in-tourism-and-travel-management",
    "path": "/course/hotel-management/mba-in-tourism-and-travel-management/",
    "component": "./pages/Courses/HotelManagement/P0111/P0111.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "Diploma in Airline Catering",
    "slug": "diploma-in-airline-catering",
    "path": "/course/hotel-management/diploma-in-airline-catering/",
    "component": "./pages/Courses/HotelManagement/DiplomaInAirlineCatering/DiplomaInAirlineCatering.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "Diploma in Bakery & Confectionery",
    "slug": "diploma-in-bakery-and-confectionery",
    "path": "/course/hotel-management/diploma-in-bakery-and-confectionery/",
    "component": "./pages/Courses/HotelManagement/P0108/P0108.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "Diploma in Catering Technology",
    "slug": "diploma-in-catering-technology",
    "path": "/course/hotel-management/diploma-in-catering-technology/",
    "component": "./pages/Courses/HotelManagement/DiplomaInCateringTechnology/DiplomaInCateringTechnology.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "Diploma in Cruise Hospitality",
    "slug": "diploma-in-cruise-hospitality",
    "path": "/course/hotel-management/diploma-in-cruise-hospitality/",
    "component": "./pages/Courses/HotelManagement/DiplomaInCruiseHospitality/DiplomaInCruiseHospitality.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "Diploma in Food & Beverage Service",
    "slug": "diploma-in-food-and-beverage-service",
    "path": "/course/hotel-management/diploma-in-food-and-beverage-service/",
    "component": "./pages/Courses/HotelManagement/P0109/P0109.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "Diploma in Front Office Management",
    "slug": "diploma-in-front-office-management",
    "path": "/course/hotel-management/diploma-in-front-office-management/",
    "component": "./pages/Courses/HotelManagement/DiplomaInFrontOfficeManagement/DiplomaInFrontOfficeManagement.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "Diploma in Hospitality Management",
    "slug": "diploma-in-hospitality-management",
    "path": "/course/hotel-management/diploma-in-hospitality-management/",
    "component": "./pages/Courses/HotelManagement/DiplomaInHospitalityManagement/DiplomaInHospitalityManagement.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "Diploma in Hotel Management",
    "slug": "diploma-in-hotel-management",
    "path": "/course/hotel-management/diploma-in-hotel-management/",
    "component": "./pages/Courses/HotelManagement/DiplomaInHotelManagement/DiplomaInHotelManagement.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "Diploma in Housekeeping Management",
    "slug": "diploma-in-housekeeping-management",
    "path": "/course/hotel-management/diploma-in-housekeeping-management/",
    "component": "./pages/Courses/HotelManagement/P0110/P0110.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "Diploma in Tourism Management",
    "slug": "diploma-in-tourism-management",
    "path": "/course/hotel-management/diploma-in-tourism-management/",
    "component": "./pages/Courses/HotelManagement/DiplomaInTourismManagement/DiplomaInTourismManagement.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "B.Com LLB (Commerce + Law)",
    "slug": "bcom-llb-commerce-law",
    "path": "/course/law/bcom-llb-commerce-law/",
    "component": "./pages/Courses/Law/BcomLlbCommerceLaw/BcomLlbCommerceLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "BA LLB (Arts + Law)",
    "slug": "ba-llb-arts-law",
    "path": "/course/law/ba-llb-arts-law/",
    "component": "./pages/Courses/Law/BaLlbArtsLaw/BaLlbArtsLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "BBA LLB (Management + Law)",
    "slug": "bba-llb-management-law",
    "path": "/course/law/bba-llb-management-law/",
    "component": "./pages/Courses/Law/BbaLlbManagementLaw/BbaLlbManagementLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "LLM in Human Rights",
    "slug": "llm-in-human-rights",
    "path": "/course/law/llm-in-human-rights/",
    "component": "./pages/Courses/Law/LlmInHumanRights/LlmInHumanRights.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "LLM in Constitutional Law",
    "slug": "llm-in-constitutional-law",
    "path": "/course/law/llm-in-constitutional-law/",
    "component": "./pages/Courses/Law/LlmInConstitutionalLaw/LlmInConstitutionalLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "LLM in Corporate Law",
    "slug": "llm-in-corporate-law",
    "path": "/course/law/llm-in-corporate-law/",
    "component": "./pages/Courses/Law/LlmInCorporateLaw/LlmInCorporateLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "LLM in Criminal Law",
    "slug": "llm-in-criminal-law",
    "path": "/course/law/llm-in-criminal-law/",
    "component": "./pages/Courses/Law/LlmInCriminalLaw/LlmInCriminalLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "LLM in Cyber Law",
    "slug": "llm-in-cyber-law",
    "path": "/course/law/llm-in-cyber-law/",
    "component": "./pages/Courses/Law/LlmInCyberLaw/LlmInCyberLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "LLM in Environmental Law",
    "slug": "llm-in-environmental-law",
    "path": "/course/law/llm-in-environmental-law/",
    "component": "./pages/Courses/Law/LlmInEnvironmentalLaw/LlmInEnvironmentalLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "LLM in Family Law",
    "slug": "llm-in-family-law",
    "path": "/course/law/llm-in-family-law/",
    "component": "./pages/Courses/Law/LlmInFamilyLaw/LlmInFamilyLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "LLM in International Law",
    "slug": "llm-in-international-law",
    "path": "/course/law/llm-in-international-law/",
    "component": "./pages/Courses/Law/LlmInInternationalLaw/LlmInInternationalLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "LLM in IPR – Intellectual Property Rights",
    "slug": "llm-in-ipr-intellectual-property-rights",
    "path": "/course/law/llm-in-ipr-intellectual-property-rights/",
    "component": "./pages/Courses/Law/LlmInIprIntellectualPropertyRights/LlmInIprIntellectualPropertyRights.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "LLM in Labour Law",
    "slug": "llm-in-labour-law",
    "path": "/course/law/llm-in-labour-law/",
    "component": "./pages/Courses/Law/LlmInLabourLaw/LlmInLabourLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "LLM in Taxation Law",
    "slug": "llm-in-taxation-law",
    "path": "/course/law/llm-in-taxation-law/",
    "component": "./pages/Courses/Law/LlmInTaxationLaw/LlmInTaxationLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "Diplomas in Banking Law",
    "slug": "diplomas-in-banking-law",
    "path": "/course/law/diplomas-in-banking-law/",
    "component": "./pages/Courses/Law/DiplomasInBankingLaw/DiplomasInBankingLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "Diploma in Consumer Protection Law",
    "slug": "diploma-in-consumer-protection-law",
    "path": "/course/law/diploma-in-consumer-protection-law/",
    "component": "./pages/Courses/Law/DiplomaInConsumerProtectionLaw/DiplomaInConsumerProtectionLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "Diploma in Corporate Law",
    "slug": "diploma-in-corporate-law",
    "path": "/course/law/diploma-in-corporate-law/",
    "component": "./pages/Courses/Law/DiplomaInCorporateLaw/DiplomaInCorporateLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "Diploma in Criminal Law",
    "slug": "diploma-in-criminal-law",
    "path": "/course/law/diploma-in-criminal-law/",
    "component": "./pages/Courses/Law/DiplomaInCriminalLaw/DiplomaInCriminalLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "Diploma in Cyber Law",
    "slug": "diploma-in-cyber-law",
    "path": "/course/law/diploma-in-cyber-law/",
    "component": "./pages/Courses/Law/DiplomaInCyberLaw/DiplomaInCyberLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "Diploma in Environmental Law",
    "slug": "diploma-in-environmental-law",
    "path": "/course/law/diploma-in-environmental-law/",
    "component": "./pages/Courses/Law/DiplomaInEnvironmentalLaw/DiplomaInEnvironmentalLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "Diploma in Human Rights",
    "slug": "diploma-in-human-rights",
    "path": "/course/law/diploma-in-human-rights/",
    "component": "./pages/Courses/Law/DiplomaInHumanRights/DiplomaInHumanRights.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "Diploma in IT Law",
    "slug": "diploma-in-it-law",
    "path": "/course/law/diploma-in-it-law/",
    "component": "./pages/Courses/Law/DiplomaInItLaw/DiplomaInItLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "Diploma in Labour Law",
    "slug": "diploma-in-labour-law",
    "path": "/course/law/diploma-in-labour-law/",
    "component": "./pages/Courses/Law/DiplomaInLabourLaw/DiplomaInLabourLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "Diploma in IPR Law",
    "slug": "diploma-in-ipr-law",
    "path": "/course/law/diploma-in-ipr-law/",
    "component": "./pages/Courses/Law/DiplomaInIprLaw/DiplomaInIprLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "Diploma in Media Law",
    "slug": "diploma-in-media-law",
    "path": "/course/law/diploma-in-media-law/",
    "component": "./pages/Courses/Law/DiplomaInMediaLaw/DiplomaInMediaLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "Diploma in Real Estate Law",
    "slug": "diploma-in-real-estate-law",
    "path": "/course/law/diploma-in-real-estate-law/",
    "component": "./pages/Courses/Law/DiplomaInRealEstateLaw/DiplomaInRealEstateLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "M.Phil in Law",
    "slug": "mphil-in-law",
    "path": "/course/law/mphil-in-law/",
    "component": "./pages/Courses/Law/MphilInLaw/MphilInLaw.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "Ph.D in Law",
    "slug": "phd-in-law",
    "path": "/course/law/phd-in-law/",
    "component": "./pages/Courses/Law/PhdInLaw/PhdInLaw.jsx"
  },
  {
    "category": "psychology",
    "categoryLabel": "Psychology",
    "level": "",
    "name": "B.A. Psychology",
    "slug": "ba-psychology",
    "path": "/course/psychology/ba-psychology/",
    "component": "./pages/Courses/Psychology/BaPsychology/BaPsychology.jsx"
  },
  {
    "category": "psychology",
    "categoryLabel": "Psychology",
    "level": "",
    "name": "B.Sc. Behavioral Science",
    "slug": "bsc-behavioral-science",
    "path": "/course/psychology/bsc-behavioral-science/",
    "component": "./pages/Courses/Psychology/BscBehavioralScience/BscBehavioralScience.jsx"
  },
  {
    "category": "psychology",
    "categoryLabel": "Psychology",
    "level": "",
    "name": "B.Sc. Child Psychology",
    "slug": "bsc-child-psychology",
    "path": "/course/psychology/bsc-child-psychology/",
    "component": "./pages/Courses/Psychology/BscChildPsychology/BscChildPsychology.jsx"
  },
  {
    "category": "psychology",
    "categoryLabel": "Psychology",
    "level": "",
    "name": "B.Sc. Clinical Psychology",
    "slug": "bsc-clinical-psychology",
    "path": "/course/psychology/bsc-clinical-psychology/",
    "component": "./pages/Courses/Psychology/BscClinicalPsychology/BscClinicalPsychology.jsx"
  },
  {
    "category": "psychology",
    "categoryLabel": "Psychology",
    "level": "",
    "name": "B.Sc. Counselling Psychology",
    "slug": "bsc-counselling-psychology",
    "path": "/course/psychology/bsc-counselling-psychology/",
    "component": "./pages/Courses/Psychology/BscCounsellingPsychology/BscCounsellingPsychology.jsx"
  },
  {
    "category": "psychology",
    "categoryLabel": "Psychology",
    "level": "",
    "name": "B.Sc. Industrial Psychology",
    "slug": "bsc-industrial-psychology",
    "path": "/course/psychology/bsc-industrial-psychology/",
    "component": "./pages/Courses/Psychology/BscIndustrialPsychology/BscIndustrialPsychology.jsx"
  },
  {
    "category": "psychology",
    "categoryLabel": "Psychology",
    "level": "",
    "name": "B.Sc. Psychology",
    "slug": "bsc-psychology",
    "path": "/course/psychology/bsc-psychology/",
    "component": "./pages/Courses/Psychology/BscPsychology/BscPsychology.jsx"
  },
  {
    "category": "psychology",
    "categoryLabel": "Psychology",
    "level": "",
    "name": "M.A. Psychology",
    "slug": "ma-psychology",
    "path": "/course/psychology/ma-psychology/",
    "component": "./pages/Courses/Psychology/MaPsychology/MaPsychology.jsx"
  },
  {
    "category": "psychology",
    "categoryLabel": "Psychology",
    "level": "",
    "name": "M.Sc. Applied Psychology",
    "slug": "ms-c-applied-psychology",
    "path": "/course/psychology/ms-c-applied-psychology/",
    "component": "./pages/Courses/Psychology/MsCAppliedPsychology/MsCAppliedPsychology.jsx"
  },
  {
    "category": "psychology",
    "categoryLabel": "Psychology",
    "level": "",
    "name": "M.Sc. Counselling Psychology",
    "slug": "ms-c-counselling-psychology",
    "path": "/course/psychology/ms-c-counselling-psychology/",
    "component": "./pages/Courses/Psychology/MsCCounsellingPsychology/MsCCounsellingPsychology.jsx"
  },
  {
    "category": "psychology",
    "categoryLabel": "Psychology",
    "level": "",
    "name": "M.Sc. Educational Psychology",
    "slug": "ms-c-educational-psychology",
    "path": "/course/psychology/ms-c-educational-psychology/",
    "component": "./pages/Courses/Psychology/MsCEducationalPsychology/MsCEducationalPsychology.jsx"
  },
  {
    "category": "psychology",
    "categoryLabel": "Psychology",
    "level": "",
    "name": "M.Sc. Forensic Psychology",
    "slug": "ms-c-forensic-psychology",
    "path": "/course/psychology/ms-c-forensic-psychology/",
    "component": "./pages/Courses/Psychology/MsCForensicPsychology/MsCForensicPsychology.jsx"
  },
  {
    "category": "psychology",
    "categoryLabel": "Psychology",
    "level": "",
    "name": "M.Sc. Health Psychology",
    "slug": "ms-c-health-psychology",
    "path": "/course/psychology/ms-c-health-psychology/",
    "component": "./pages/Courses/Psychology/MsCHealthPsychology/MsCHealthPsychology.jsx"
  },
  {
    "category": "psychology",
    "categoryLabel": "Psychology",
    "level": "",
    "name": "M.Sc. Psychology",
    "slug": "ms-c-psychology",
    "path": "/course/psychology/ms-c-psychology/",
    "component": "./pages/Courses/Psychology/MsCPsychology/MsCPsychology.jsx"
  },
  {
    "category": "psychology",
    "categoryLabel": "Psychology",
    "level": "",
    "name": "Ph.D Clinical Psychology",
    "slug": "phd-clinical-psychology",
    "path": "/course/psychology/phd-clinical-psychology/",
    "component": "./pages/Courses/Psychology/PhdClinicalPsychology/PhdClinicalPsychology.jsx"
  },
  {
    "category": "psychology",
    "categoryLabel": "Psychology",
    "level": "",
    "name": "Ph.D. Applied Psychology",
    "slug": "phd-applied-psychology",
    "path": "/course/psychology/phd-applied-psychology/",
    "component": "./pages/Courses/Psychology/PhdAppliedPsychology/PhdAppliedPsychology.jsx"
  },
  {
    "category": "psychology",
    "categoryLabel": "Psychology",
    "level": "",
    "name": "Ph.D. Behavioral Science",
    "slug": "phd-behavioral-science",
    "path": "/course/psychology/phd-behavioral-science/",
    "component": "./pages/Courses/Psychology/PhdBehavioralScience/PhdBehavioralScience.jsx"
  },
  {
    "category": "psychology",
    "categoryLabel": "Psychology",
    "level": "",
    "name": "Ph.D. Psychology",
    "slug": "phd-psychology",
    "path": "/course/psychology/phd-psychology/",
    "component": "./pages/Courses/Psychology/PhdPsychology/PhdPsychology.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "B.Sc. in Air Traffic Management",
    "slug": "bsc-in-air-traffic-management",
    "path": "/course/aviation/bsc-in-air-traffic-management/",
    "component": "./pages/Courses/Aviation/BscInAirTrafficManagement/BscInAirTrafficManagement.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "B.Sc in Aircraft Maintenance",
    "slug": "bsc-in-aircraft-maintenance",
    "path": "/course/aviation/bsc-in-aircraft-maintenance/",
    "component": "./pages/Courses/Aviation/BscInAircraftMaintenance/BscInAircraftMaintenance.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "B.Sc. in Airport Management",
    "slug": "bsc-in-airport-management",
    "path": "/course/aviation/bsc-in-airport-management/",
    "component": "./pages/Courses/Aviation/BscInAirportManagement/BscInAirportManagement.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "B.Sc. in Aviation",
    "slug": "bsc-in-aviation",
    "path": "/course/aviation/bsc-in-aviation/",
    "component": "./pages/Courses/Aviation/BscInAviation/BscInAviation.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "B.Tech in Aeronautical Engineering",
    "slug": "btech-in-aeronautical-engineering",
    "path": "/course/aviation/btech-in-aeronautical-engineering/",
    "component": "./pages/Courses/Aviation/BtechInAeronauticalEngineering/BtechInAeronauticalEngineering.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "B.Tech in Aerospace Engineering",
    "slug": "btech-in-aerospace-engineering",
    "path": "/course/aviation/btech-in-aerospace-engineering/",
    "component": "./pages/Courses/Aviation/BtechInAerospaceEngineering/BtechInAerospaceEngineering.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "BBA in Airport Operations",
    "slug": "bba-in-airport-operations",
    "path": "/course/aviation/bba-in-airport-operations/",
    "component": "./pages/Courses/Aviation/BbaInAirportOperations/BbaInAirportOperations.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "BBA in Aviation",
    "slug": "bba-in-aviation",
    "path": "/course/aviation/bba-in-aviation/",
    "component": "./pages/Courses/Aviation/BbaInAviation/BbaInAviation.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "M.Sc. Airport Management",
    "slug": "ms-c-airport-management",
    "path": "/course/aviation/ms-c-airport-management/",
    "component": "./pages/Courses/Aviation/MsCAirportManagement/MsCAirportManagement.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "M.Sc. Aviation",
    "slug": "ms-c-aviation",
    "path": "/course/aviation/ms-c-aviation/",
    "component": "./pages/Courses/Aviation/MsCAviation/MsCAviation.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "M.Tech Aeronautical Engineering",
    "slug": "mtech-aeronautical-engineering",
    "path": "/course/aviation/mtech-aeronautical-engineering/",
    "component": "./pages/Courses/Aviation/MtechAeronauticalEngineering/MtechAeronauticalEngineering.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "M.Tech Aerospace Engineering",
    "slug": "mtech-aerospace-engineering",
    "path": "/course/aviation/mtech-aerospace-engineering/",
    "component": "./pages/Courses/Aviation/MtechAerospaceEngineering/MtechAerospaceEngineering.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "MBA Aviation Management",
    "slug": "mba-aviation-management",
    "path": "/course/aviation/mba-aviation-management/",
    "component": "./pages/Courses/Aviation/MbaAviationManagement/MbaAviationManagement.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "Diploma in Aircraft Maintenance",
    "slug": "diploma-in-aircraft-maintenance",
    "path": "/course/aviation/diploma-in-aircraft-maintenance/",
    "component": "./pages/Courses/Aviation/DiplomaInAircraftMaintenance/DiplomaInAircraftMaintenance.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "Diploma in Airline & Travel Management",
    "slug": "diploma-in-airline-and-travel-management",
    "path": "/course/aviation/diploma-in-airline-and-travel-management/",
    "component": "./pages/Courses/Aviation/P0037/P0037.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "Diploma in Airport Ground Handling",
    "slug": "diploma-in-airport-ground-handling",
    "path": "/course/aviation/diploma-in-airport-ground-handling/",
    "component": "./pages/Courses/Aviation/DiplomaInAirportGroundHandling/DiplomaInAirportGroundHandling.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "Diploma in Airport Operations",
    "slug": "diploma-in-airport-operations",
    "path": "/course/aviation/diploma-in-airport-operations/",
    "component": "./pages/Courses/Aviation/DiplomaInAirportOperations/DiplomaInAirportOperations.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "Diploma in Aviation Hospitality",
    "slug": "diploma-in-aviation-hospitality",
    "path": "/course/aviation/diploma-in-aviation-hospitality/",
    "component": "./pages/Courses/Aviation/DiplomaInAviationHospitality/DiplomaInAviationHospitality.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "Diploma in Cabin Crew Training",
    "slug": "diploma-in-cabin-crew-training",
    "path": "/course/aviation/diploma-in-cabin-crew-training/",
    "component": "./pages/Courses/Aviation/DiplomaInCabinCrewTraining/DiplomaInCabinCrewTraining.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "AME – Aircraft Maintenance Engineering",
    "slug": "ame-aircraft-maintenance-engineering",
    "path": "/course/aviation/ame-aircraft-maintenance-engineering/",
    "component": "./pages/Courses/Aviation/AmeAircraftMaintenanceEngineering/AmeAircraftMaintenanceEngineering.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "B.Sc Aircraft Maintenance",
    "slug": "bsc-aircraft-maintenance",
    "path": "/course/aviation/bsc-aircraft-maintenance/",
    "component": "./pages/Courses/Aviation/BscAircraftMaintenance/BscAircraftMaintenance.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "SPL – Student Pilot License",
    "slug": "spl-student-pilot-license",
    "path": "/course/aviation/spl-student-pilot-license/",
    "component": "./pages/Courses/Aviation/SplStudentPilotLicense/SplStudentPilotLicense.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "PPL – Private Pilot License",
    "slug": "ppl-private-pilot-license",
    "path": "/course/aviation/ppl-private-pilot-license/",
    "component": "./pages/Courses/Aviation/PplPrivatePilotLicense/PplPrivatePilotLicense.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "CPL – Commercial Pilot License",
    "slug": "cpl-commercial-pilot-license",
    "path": "/course/aviation/cpl-commercial-pilot-license/",
    "component": "./pages/Courses/Aviation/CplCommercialPilotLicense/CplCommercialPilotLicense.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "Type Rating (A320 / B737 etc.)",
    "slug": "type-rating-a320-b737-etc",
    "path": "/course/aviation/type-rating-a320-b737-etc/",
    "component": "./pages/Courses/Aviation/TypeRatingA320B737Etc/TypeRatingA320B737Etc.jsx"
  },
  {
    "category": "aviation",
    "categoryLabel": "Aviation",
    "level": "",
    "name": "FIR – Flight Instructor Rating",
    "slug": "fir-flight-instructor-rating",
    "path": "/course/aviation/fir-flight-instructor-rating/",
    "component": "./pages/Courses/Aviation/FirFlightInstructorRating/FirFlightInstructorRating.jsx"
  },
  {
    "category": "sports-physical-education",
    "categoryLabel": "Sports & Physical Education",
    "level": "",
    "name": "B.Sc Physical Education",
    "slug": "bsc-physical-education",
    "path": "/course/sports-physical-education/bsc-physical-education/",
    "component": "./pages/Courses/SportsPhysicalEducation/BscPhysicalEducation/BscPhysicalEducation.jsx"
  },
  {
    "category": "sports-physical-education",
    "categoryLabel": "Sports & Physical Education",
    "level": "",
    "name": "B.Sc. Sports Coaching",
    "slug": "bsc-sports-coaching",
    "path": "/course/sports-physical-education/bsc-sports-coaching/",
    "component": "./pages/Courses/SportsPhysicalEducation/BscSportsCoaching/BscSportsCoaching.jsx"
  },
  {
    "category": "sports-physical-education",
    "categoryLabel": "Sports & Physical Education",
    "level": "",
    "name": "B.Sc. Sports Science",
    "slug": "bsc-sports-science",
    "path": "/course/sports-physical-education/bsc-sports-science/",
    "component": "./pages/Courses/SportsPhysicalEducation/BscSportsScience/BscSportsScience.jsx"
  },
  {
    "category": "sports-physical-education",
    "categoryLabel": "Sports & Physical Education",
    "level": "",
    "name": "M.Sc. Sports Nutrition",
    "slug": "ms-c-sports-nutrition",
    "path": "/course/sports-physical-education/ms-c-sports-nutrition/",
    "component": "./pages/Courses/SportsPhysicalEducation/MsCSportsNutrition/MsCSportsNutrition.jsx"
  },
  {
    "category": "sports-physical-education",
    "categoryLabel": "Sports & Physical Education",
    "level": "",
    "name": "M.Sc. Sports Psychology",
    "slug": "ms-c-sports-psychology",
    "path": "/course/sports-physical-education/ms-c-sports-psychology/",
    "component": "./pages/Courses/SportsPhysicalEducation/MsCSportsPsychology/MsCSportsPsychology.jsx"
  },
  {
    "category": "sports-physical-education",
    "categoryLabel": "Sports & Physical Education",
    "level": "",
    "name": "M.Sc. Sports Science",
    "slug": "ms-c-sports-science",
    "path": "/course/sports-physical-education/ms-c-sports-science/",
    "component": "./pages/Courses/SportsPhysicalEducation/MsCSportsScience/MsCSportsScience.jsx"
  },
  {
    "category": "sports-physical-education",
    "categoryLabel": "Sports & Physical Education",
    "level": "",
    "name": "MBA Sports Management",
    "slug": "mba-sports-management",
    "path": "/course/sports-physical-education/mba-sports-management/",
    "component": "./pages/Courses/SportsPhysicalEducation/MbaSportsManagement/MbaSportsManagement.jsx"
  },
  {
    "category": "sports-physical-education",
    "categoryLabel": "Sports & Physical Education",
    "level": "",
    "name": "Diploma in Physical Education (D.P.Ed)",
    "slug": "diploma-in-physical-education-d-p-ed",
    "path": "/course/sports-physical-education/diploma-in-physical-education-d-p-ed/",
    "component": "./pages/Courses/SportsPhysicalEducation/P0147/P0147.jsx"
  },
  {
    "category": "sports-physical-education",
    "categoryLabel": "Sports & Physical Education",
    "level": "",
    "name": "Diploma in Sports Coaching",
    "slug": "diploma-in-sports-coaching",
    "path": "/course/sports-physical-education/diploma-in-sports-coaching/",
    "component": "./pages/Courses/SportsPhysicalEducation/DiplomaInSportsCoaching/DiplomaInSportsCoaching.jsx"
  },
  {
    "category": "sports-physical-education",
    "categoryLabel": "Sports & Physical Education",
    "level": "",
    "name": "Ph.D in Physical Education",
    "slug": "phd-in-physical-education",
    "path": "/course/sports-physical-education/phd-in-physical-education/",
    "component": "./pages/Courses/SportsPhysicalEducation/PhdInPhysicalEducation/PhdInPhysicalEducation.jsx"
  },
  {
    "category": "sports-physical-education",
    "categoryLabel": "Sports & Physical Education",
    "level": "",
    "name": "Ph.D Sports Science",
    "slug": "phd-sports-science",
    "path": "/course/sports-physical-education/phd-sports-science/",
    "component": "./pages/Courses/SportsPhysicalEducation/PhdSportsScience/PhdSportsScience.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "B.A. Economics",
    "slug": "ba-economics",
    "path": "/course/commerce-finance-accounting/ba-economics/",
    "component": "./pages/Courses/CommerceFinanceAccounting/BaEconomics/BaEconomics.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "B.Com (General)",
    "slug": "bcom-general",
    "path": "/course/commerce-finance-accounting/bcom-general/",
    "component": "./pages/Courses/CommerceFinanceAccounting/BcomGeneral/BcomGeneral.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "B.Com (Accounting & Finance)",
    "slug": "bcom-accounting-and-finance",
    "path": "/course/commerce-finance-accounting/bcom-accounting-and-finance/",
    "component": "./pages/Courses/CommerceFinanceAccounting/BcomAccountingAndFinance/BcomAccountingAndFinance.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "B.Com (Bank Management)",
    "slug": "bcom-bank-management",
    "path": "/course/commerce-finance-accounting/bcom-bank-management/",
    "component": "./pages/Courses/CommerceFinanceAccounting/BcomBankManagement/BcomBankManagement.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "B.Com Business Administration",
    "slug": "bcom-business-administration",
    "path": "/course/commerce-finance-accounting/bcom-business-administration/",
    "component": "./pages/Courses/CommerceFinanceAccounting/P0042/P0042.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "B.Com (Computer Applications)",
    "slug": "bcom-computer-applications",
    "path": "/course/commerce-finance-accounting/bcom-computer-applications/",
    "component": "./pages/Courses/CommerceFinanceAccounting/BcomComputerApplications/BcomComputerApplications.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "B.Com in Corporate Secretaryship",
    "slug": "bcom-in-corporate-secretaryship",
    "path": "/course/commerce-finance-accounting/bcom-in-corporate-secretaryship/",
    "component": "./pages/Courses/CommerceFinanceAccounting/P0044/P0044.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "B.Com (E-Commerce / Business Analytics)",
    "slug": "bcom-e-commerce-business-analytics",
    "path": "/course/commerce-finance-accounting/bcom-e-commerce-business-analytics/",
    "component": "./pages/Courses/CommerceFinanceAccounting/P0043/P0043.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "B.Com Financial Accounting",
    "slug": "bcom-financial-accounting",
    "path": "/course/commerce-finance-accounting/bcom-financial-accounting/",
    "component": "./pages/Courses/CommerceFinanceAccounting/BcomFinancialAccounting/BcomFinancialAccounting.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "B.Com Honours (Hons)",
    "slug": "bcom-honours-hons",
    "path": "/course/commerce-finance-accounting/bcom-honours-hons/",
    "component": "./pages/Courses/CommerceFinanceAccounting/BcomHonoursHons/BcomHonoursHons.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "B.Com Information Systems Management",
    "slug": "bcom-information-systems-management",
    "path": "/course/commerce-finance-accounting/bcom-information-systems-management/",
    "component": "./pages/Courses/CommerceFinanceAccounting/P0045/P0045.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "B.Com Management (Computer oriented)",
    "slug": "bcom-management-computer-oriented",
    "path": "/course/commerce-finance-accounting/bcom-management-computer-oriented/",
    "component": "./pages/Courses/CommerceFinanceAccounting/P0046/P0046.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "B.Com Marketing Management",
    "slug": "bcom-marketing-management",
    "path": "/course/commerce-finance-accounting/bcom-marketing-management/",
    "component": "./pages/Courses/CommerceFinanceAccounting/BcomMarketingManagement/BcomMarketingManagement.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "B.Com (Professional Accounting)",
    "slug": "bcom-professional-accounting",
    "path": "/course/commerce-finance-accounting/bcom-professional-accounting/",
    "component": "./pages/Courses/CommerceFinanceAccounting/P0047/P0047.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "B.Com Retail Management",
    "slug": "bcom-retail-management",
    "path": "/course/commerce-finance-accounting/bcom-retail-management/",
    "component": "./pages/Courses/CommerceFinanceAccounting/BcomRetailManagement/BcomRetailManagement.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "B.Com Taxation",
    "slug": "bcom-taxation",
    "path": "/course/commerce-finance-accounting/bcom-taxation/",
    "component": "./pages/Courses/CommerceFinanceAccounting/BcomTaxation/BcomTaxation.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "B.Sc Accountancy",
    "slug": "bsc-accountancy",
    "path": "/course/commerce-finance-accounting/bsc-accountancy/",
    "component": "./pages/Courses/CommerceFinanceAccounting/BscAccountancy/BscAccountancy.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "B.Sc. Finance",
    "slug": "bsc-finance",
    "path": "/course/commerce-finance-accounting/bsc-finance/",
    "component": "./pages/Courses/CommerceFinanceAccounting/BscFinance/BscFinance.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "BBA in Finance",
    "slug": "bba-in-finance",
    "path": "/course/commerce-finance-accounting/bba-in-finance/",
    "component": "./pages/Courses/CommerceFinanceAccounting/BbaInFinance/BbaInFinance.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "M.Com (CA / Finance / Corporate Secretaryship)",
    "slug": "mcom-ca-finance-corporate-secretaryship",
    "path": "/course/commerce-finance-accounting/mcom-ca-finance-corporate-secretaryship/",
    "component": "./pages/Courses/CommerceFinanceAccounting/P0049/P0049.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "M.Com International Business",
    "slug": "mcom-international-business",
    "path": "/course/commerce-finance-accounting/mcom-international-business/",
    "component": "./pages/Courses/CommerceFinanceAccounting/McomInternationalBusiness/McomInternationalBusiness.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "M.Com Professional Accounting",
    "slug": "mcom-professional-accounting",
    "path": "/course/commerce-finance-accounting/mcom-professional-accounting/",
    "component": "./pages/Courses/CommerceFinanceAccounting/P0050/P0050.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "M.Com Taxation",
    "slug": "mcom-taxation",
    "path": "/course/commerce-finance-accounting/mcom-taxation/",
    "component": "./pages/Courses/CommerceFinanceAccounting/McomTaxation/McomTaxation.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "M.Sc Accountancy",
    "slug": "ms-c-accountancy",
    "path": "/course/commerce-finance-accounting/ms-c-accountancy/",
    "component": "./pages/Courses/CommerceFinanceAccounting/MsCAccountancy/MsCAccountancy.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "M.Sc Finance",
    "slug": "ms-c-finance",
    "path": "/course/commerce-finance-accounting/ms-c-finance/",
    "component": "./pages/Courses/CommerceFinanceAccounting/MsCFinance/MsCFinance.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "MBA Accounting",
    "slug": "mba-accounting",
    "path": "/course/commerce-finance-accounting/mba-accounting/",
    "component": "./pages/Courses/CommerceFinanceAccounting/MbaAccounting/MbaAccounting.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "MBA Banking & Insurance",
    "slug": "mba-banking-and-insurance",
    "path": "/course/commerce-finance-accounting/mba-banking-and-insurance/",
    "component": "./pages/Courses/CommerceFinanceAccounting/MbaBankingAndInsurance/MbaBankingAndInsurance.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "MBA Finance",
    "slug": "mba-finance",
    "path": "/course/commerce-finance-accounting/mba-finance/",
    "component": "./pages/Courses/CommerceFinanceAccounting/MbaFinance/MbaFinance.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "MBA Financial Management",
    "slug": "mba-financial-management",
    "path": "/course/commerce-finance-accounting/mba-financial-management/",
    "component": "./pages/Courses/CommerceFinanceAccounting/MbaFinancialManagement/MbaFinancialManagement.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "MBA Logistics International Business",
    "slug": "mba-logistics-international-business",
    "path": "/course/commerce-finance-accounting/mba-logistics-international-business/",
    "component": "./pages/Courses/CommerceFinanceAccounting/P0048/P0048.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "M.Com (General)",
    "slug": "mcom-general",
    "path": "/course/commerce-finance-accounting/mcom-general/",
    "component": "./pages/Courses/CommerceFinanceAccounting/McomGeneral/McomGeneral.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "M.Com (Banking & Finance)",
    "slug": "mcom-banking-and-finance",
    "path": "/course/commerce-finance-accounting/mcom-banking-and-finance/",
    "component": "./pages/Courses/CommerceFinanceAccounting/McomBankingAndFinance/McomBankingAndFinance.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "M.Com (Accounting & Finance)",
    "slug": "mcom-accounting-and-finance",
    "path": "/course/commerce-finance-accounting/mcom-accounting-and-finance/",
    "component": "./pages/Courses/CommerceFinanceAccounting/McomAccountingAndFinance/McomAccountingAndFinance.jsx"
  },
  {
    "category": "commerce-finance-accounting",
    "categoryLabel": "Commerce, Finance & Accounting",
    "level": "",
    "name": "M.A. Economics",
    "slug": "ma-economics",
    "path": "/course/commerce-finance-accounting/ma-economics/",
    "component": "./pages/Courses/CommerceFinanceAccounting/MaEconomics/MaEconomics.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "",
    "name": "Media, Journalism & Visual Communication  - >",
    "slug": "media-journalism-and-visual-communication",
    "path": "/course/media-journalism-visual-communication/media-journalism-and-visual-communication/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/P0137/P0137.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "ug",
    "name": "B.A. Journalism & Mass Communication",
    "slug": "ba-journalism-and-mass-communication",
    "path": "/course/media-journalism-visual-communication/ba-journalism-and-mass-communication/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/P0126/P0126.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "ug",
    "name": "B.A in Journalism",
    "slug": "ba-in-journalism",
    "path": "/course/media-journalism-visual-communication/ba-in-journalism/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/BaInJournalism/BaInJournalism.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "ug",
    "name": "B.A in Multimedia / Media Studies / Media Science",
    "slug": "ba-in-multimedia-media-studies-media-science",
    "path": "/course/media-journalism-visual-communication/ba-in-multimedia-media-studies-media-science/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/P0125/P0125.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "ug",
    "name": "B.Sc. in Digital Media / New Media",
    "slug": "bsc-in-digital-media-new-media",
    "path": "/course/media-journalism-visual-communication/bsc-in-digital-media-new-media/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/P0127/P0127.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "ug",
    "name": "B.Sc in Electronic Media",
    "slug": "bsc-in-electronic-media",
    "path": "/course/media-journalism-visual-communication/bsc-in-electronic-media/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/BscInElectronicMedia/BscInElectronicMedia.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "ug",
    "name": "B.Sc in Mass Communication",
    "slug": "bsc-in-mass-communication",
    "path": "/course/media-journalism-visual-communication/bsc-in-mass-communication/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/P0128/P0128.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "ug",
    "name": "B.Sc. in Visual Communication",
    "slug": "bsc-in-visual-communication",
    "path": "/course/media-journalism-visual-communication/bsc-in-visual-communication/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/P0129/P0129.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "pg",
    "name": "M.A in Journalism",
    "slug": "ma-in-journalism",
    "path": "/course/media-journalism-visual-communication/ma-in-journalism/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/MaInJournalism/MaInJournalism.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "pg",
    "name": "M.A in Mass Communication",
    "slug": "ma-in-mass-communication",
    "path": "/course/media-journalism-visual-communication/ma-in-mass-communication/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/MaInMassCommunication/MaInMassCommunication.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "pg",
    "name": "M.A in Media Studies / Communication",
    "slug": "ma-in-media-studies-communication",
    "path": "/course/media-journalism-visual-communication/ma-in-media-studies-communication/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/P0135/P0135.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "pg",
    "name": "M.Sc Electronic Media",
    "slug": "ms-c-electronic-media",
    "path": "/course/media-journalism-visual-communication/ms-c-electronic-media/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/MsCElectronicMedia/MsCElectronicMedia.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "pg",
    "name": "M.Sc. in Visual Communication",
    "slug": "ms-c-in-visual-communication",
    "path": "/course/media-journalism-visual-communication/ms-c-in-visual-communication/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/P0138/P0138.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "pg",
    "name": "MBA in Media Management",
    "slug": "mba-in-media-management",
    "path": "/course/media-journalism-visual-communication/mba-in-media-management/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/MbaInMediaManagement/MbaInMediaManagement.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "pg",
    "name": "M.A. Journalism & Mass Communication",
    "slug": "ma-journalism-and-mass-communication",
    "path": "/course/media-journalism-visual-communication/ma-journalism-and-mass-communication/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/P0136/P0136.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "diploma",
    "name": "Diploma in Animation & VFX",
    "slug": "diploma-in-animation-and-vfx",
    "path": "/course/media-journalism-visual-communication/diploma-in-animation-and-vfx/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/P0130/P0130.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "diploma",
    "name": "Diploma in Digital Media",
    "slug": "diploma-in-digital-media",
    "path": "/course/media-journalism-visual-communication/diploma-in-digital-media/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/DiplomaInDigitalMedia/DiplomaInDigitalMedia.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "diploma",
    "name": "Diploma in Electronic Media",
    "slug": "diploma-in-electronic-media",
    "path": "/course/media-journalism-visual-communication/diploma-in-electronic-media/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/P0131/P0131.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "diploma",
    "name": "Diploma in Film & TV Production",
    "slug": "diploma-in-film-and-tv-production",
    "path": "/course/media-journalism-visual-communication/diploma-in-film-and-tv-production/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/P0132/P0132.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "diploma",
    "name": "Diploma in Graphic Design",
    "slug": "diploma-in-graphic-design",
    "path": "/course/media-journalism-visual-communication/diploma-in-graphic-design/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/P0133/P0133.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "diploma",
    "name": "Diploma in Journalism",
    "slug": "diploma-in-journalism",
    "path": "/course/media-journalism-visual-communication/diploma-in-journalism/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/DiplomaInJournalism/DiplomaInJournalism.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "diploma",
    "name": "Diploma in Photography",
    "slug": "diploma-in-photography",
    "path": "/course/media-journalism-visual-communication/diploma-in-photography/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/DiplomaInPhotography/DiplomaInPhotography.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "diploma",
    "name": "Diploma in Visual Communication",
    "slug": "diploma-in-visual-communication",
    "path": "/course/media-journalism-visual-communication/diploma-in-visual-communication/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/P0134/P0134.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "phd",
    "name": "Ph.D in Journalism",
    "slug": "phd-in-journalism",
    "path": "/course/media-journalism-visual-communication/phd-in-journalism/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/PhdInJournalism/PhdInJournalism.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "phd",
    "name": "Ph.D in Mass Communication",
    "slug": "phd-in-mass-communication",
    "path": "/course/media-journalism-visual-communication/phd-in-mass-communication/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/P0139/P0139.jsx"
  },
  {
    "category": "media-journalism-visual-communication",
    "categoryLabel": "Media, Journalism & Visual Communication",
    "level": "phd",
    "name": "Ph.D in Visual Media",
    "slug": "phd-in-visual-media",
    "path": "/course/media-journalism-visual-communication/phd-in-visual-media/",
    "component": "./pages/Courses/MediaJournalismVisualCommunication/PhdInVisualMedia/PhdInVisualMedia.jsx"
  },
  {
    "category": "fine-arts-performing-arts",
    "categoryLabel": "Fine Arts & Performing Arts",
    "level": "ug",
    "name": "B.A Acting",
    "slug": "ba-acting",
    "path": "/course/fine-arts-performing-arts/ba-acting/",
    "component": "./pages/Courses/FineArtsPerformingArts/BaActing/BaActing.jsx"
  },
  {
    "category": "fine-arts-performing-arts",
    "categoryLabel": "Fine Arts & Performing Arts",
    "level": "ug",
    "name": "B.A in Dance",
    "slug": "ba-in-dance",
    "path": "/course/fine-arts-performing-arts/ba-in-dance/",
    "component": "./pages/Courses/FineArtsPerformingArts/BaInDance/BaInDance.jsx"
  },
  {
    "category": "fine-arts-performing-arts",
    "categoryLabel": "Fine Arts & Performing Arts",
    "level": "ug",
    "name": "B.A in Music",
    "slug": "ba-in-music",
    "path": "/course/fine-arts-performing-arts/ba-in-music/",
    "component": "./pages/Courses/FineArtsPerformingArts/BaInMusic/BaInMusic.jsx"
  },
  {
    "category": "fine-arts-performing-arts",
    "categoryLabel": "Fine Arts & Performing Arts",
    "level": "ug",
    "name": "B.A in Theatre Arts / Drama",
    "slug": "ba-in-theatre-arts-drama",
    "path": "/course/fine-arts-performing-arts/ba-in-theatre-arts-drama/",
    "component": "./pages/Courses/FineArtsPerformingArts/BaInTheatreArtsDrama/BaInTheatreArtsDrama.jsx"
  },
  {
    "category": "fine-arts-performing-arts",
    "categoryLabel": "Fine Arts & Performing Arts",
    "level": "ug",
    "name": "B.Music in Bachelor of Music",
    "slug": "b-music-in-bachelor-of-music",
    "path": "/course/fine-arts-performing-arts/b-music-in-bachelor-of-music/",
    "component": "./pages/Courses/FineArtsPerformingArts/BMusicInBachelorOfMusic/BMusicInBachelorOfMusic.jsx"
  },
  {
    "category": "fine-arts-performing-arts",
    "categoryLabel": "Fine Arts & Performing Arts",
    "level": "ug",
    "name": "B.Sc. in Dance",
    "slug": "bsc-in-dance",
    "path": "/course/fine-arts-performing-arts/bsc-in-dance/",
    "component": "./pages/Courses/FineArtsPerformingArts/BscInDance/BscInDance.jsx"
  },
  {
    "category": "fine-arts-performing-arts",
    "categoryLabel": "Fine Arts & Performing Arts",
    "level": "ug",
    "name": "B.Sc in Music",
    "slug": "bsc-in-music",
    "path": "/course/fine-arts-performing-arts/bsc-in-music/",
    "component": "./pages/Courses/FineArtsPerformingArts/BscInMusic/BscInMusic.jsx"
  },
  {
    "category": "fine-arts-performing-arts",
    "categoryLabel": "Fine Arts & Performing Arts",
    "level": "ug",
    "name": "BPA in Performing Arts (Dance)",
    "slug": "bpa-in-performing-arts-dance",
    "path": "/course/fine-arts-performing-arts/bpa-in-performing-arts-dance/",
    "component": "./pages/Courses/FineArtsPerformingArts/BpaInPerformingArtsDance/BpaInPerformingArtsDance.jsx"
  },
  {
    "category": "fine-arts-performing-arts",
    "categoryLabel": "Fine Arts & Performing Arts",
    "level": "ug",
    "name": "BPA in Performing Arts (Theatre / Acting / Drama)",
    "slug": "bpa-in-performing-arts-theatre-acting-drama",
    "path": "/course/fine-arts-performing-arts/bpa-in-performing-arts-theatre-acting-drama/",
    "component": "./pages/Courses/FineArtsPerformingArts/P0084/P0084.jsx"
  },
  {
    "category": "fine-arts-performing-arts",
    "categoryLabel": "Fine Arts & Performing Arts",
    "level": "pg",
    "name": "M.A in Dance",
    "slug": "ma-in-dance",
    "path": "/course/fine-arts-performing-arts/ma-in-dance/",
    "component": "./pages/Courses/FineArtsPerformingArts/MaInDance/MaInDance.jsx"
  },
  {
    "category": "fine-arts-performing-arts",
    "categoryLabel": "Fine Arts & Performing Arts",
    "level": "pg",
    "name": "M.A in Drama / Theatre Arts",
    "slug": "ma-in-drama-theatre-arts",
    "path": "/course/fine-arts-performing-arts/ma-in-drama-theatre-arts/",
    "component": "./pages/Courses/FineArtsPerformingArts/MaInDramaTheatreArts/MaInDramaTheatreArts.jsx"
  },
  {
    "category": "fine-arts-performing-arts",
    "categoryLabel": "Fine Arts & Performing Arts",
    "level": "pg",
    "name": "M.A in Music",
    "slug": "ma-in-music",
    "path": "/course/fine-arts-performing-arts/ma-in-music/",
    "component": "./pages/Courses/FineArtsPerformingArts/MaInMusic/MaInMusic.jsx"
  },
  {
    "category": "fine-arts-performing-arts",
    "categoryLabel": "Fine Arts & Performing Arts",
    "level": "pg",
    "name": "M.Music in Master of Music",
    "slug": "m-music-in-master-of-music",
    "path": "/course/fine-arts-performing-arts/m-music-in-master-of-music/",
    "component": "./pages/Courses/FineArtsPerformingArts/MMusicInMasterOfMusic/MMusicInMasterOfMusic.jsx"
  },
  {
    "category": "fine-arts-performing-arts",
    "categoryLabel": "Fine Arts & Performing Arts",
    "level": "pg",
    "name": "MPA in Performing Arts (Dance)",
    "slug": "mpa-in-performing-arts-dance",
    "path": "/course/fine-arts-performing-arts/mpa-in-performing-arts-dance/",
    "component": "./pages/Courses/FineArtsPerformingArts/MpaInPerformingArtsDance/MpaInPerformingArtsDance.jsx"
  },
  {
    "category": "fine-arts-performing-arts",
    "categoryLabel": "Fine Arts & Performing Arts",
    "level": "phd",
    "name": "PhD in Music",
    "slug": "phd-in-music",
    "path": "/course/fine-arts-performing-arts/phd-in-music/",
    "component": "./pages/Courses/FineArtsPerformingArts/PhdInMusic/PhdInMusic.jsx"
  },
  {
    "category": "fine-arts-performing-arts",
    "categoryLabel": "Fine Arts & Performing Arts",
    "level": "phd",
    "name": "PhD in Theatre / Performing Arts",
    "slug": "phd-in-theatre-performing-arts",
    "path": "/course/fine-arts-performing-arts/phd-in-theatre-performing-arts/",
    "component": "./pages/Courses/FineArtsPerformingArts/PhdInTheatrePerformingArts/PhdInTheatrePerformingArts.jsx"
  },
  {
    "category": "fine-arts-performing-arts",
    "categoryLabel": "Fine Arts & Performing Arts",
    "level": "phd",
    "name": "Ph.D in Dance",
    "slug": "phd-in-dance",
    "path": "/course/fine-arts-performing-arts/phd-in-dance/",
    "component": "./pages/Courses/FineArtsPerformingArts/PhdInDance/PhdInDance.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "UG",
    "name": "B.Voc (Software Development / Multimedia)",
    "slug": "bvoc-software-development-multimedia",
    "path": "/course/arts-science/bvoc-software-development-multimedia/",
    "component": "./pages/Courses/ArtsScience/BVocSoftwareDevelopmentMultimedia/BVocSoftwareDevelopmentMultimedia.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.S.W (Master of Social Work)",
    "slug": "msw-master-of-social-work",
    "path": "/course/arts-science/msw-master-of-social-work/",
    "component": "./pages/Courses/ArtsScience/MSWMasterOfSocialWork/MSWMasterOfSocialWork.jsx"
  },
  {
    "category": "arts-science",
    "categoryLabel": "Arts & Science",
    "level": "PG",
    "name": "M.P.Ed (Physical Education)",
    "slug": "mped-physical-education",
    "path": "/course/arts-science/mped-physical-education/",
    "component": "./pages/Courses/ArtsScience/MPEdPhysicalEducation/MPEdPhysicalEducation.jsx"
  },
  {
    "category": "mbbs",
    "categoryLabel": "MBBS & Medical",
    "level": "Super-speciality",
    "name": "DM – Doctorate of Medicine",
    "slug": "dm-doctorate-of-medicine",
    "path": "/course/mbbs/dm-doctorate-of-medicine/",
    "component": "./pages/Courses/Mbbs/DmDoctorateOfMedicine/DmDoctorateOfMedicine.jsx"
  },
  {
    "category": "mbbs",
    "categoryLabel": "MBBS & Medical",
    "level": "Super-speciality",
    "name": "M.Ch – Master of Chirurgiae",
    "slug": "mch-master-of-chirurgiae",
    "path": "/course/mbbs/mch-master-of-chirurgiae/",
    "component": "./pages/Courses/Mbbs/MchMasterOfChirurgiae/MchMasterOfChirurgiae.jsx"
  },
  {
    "category": "psychology",
    "categoryLabel": "Psychology",
    "level": "",
    "name": "PG Diploma in Child Psychology",
    "slug": "pg-diploma-in-child-psychology",
    "path": "/course/psychology/pg-diploma-in-child-psychology/",
    "component": "./pages/Courses/Psychology/PgDiplomaChildPsychology/PgDiplomaChildPsychology.jsx"
  },
  {
    "category": "psychology",
    "categoryLabel": "Psychology",
    "level": "",
    "name": "PG Diploma in Clinical Psychology",
    "slug": "pg-diploma-in-clinical-psychology",
    "path": "/course/psychology/pg-diploma-in-clinical-psychology/",
    "component": "./pages/Courses/Psychology/PgDiplomaClinicalPsychology/PgDiplomaClinicalPsychology.jsx"
  },
  {
    "category": "psychology",
    "categoryLabel": "Psychology",
    "level": "",
    "name": "PG Diploma in Guidance & Counselling",
    "slug": "pg-diploma-in-guidance-counselling",
    "path": "/course/psychology/pg-diploma-in-guidance-counselling/",
    "component": "./pages/Courses/Psychology/PgDiplomaGuidanceCounselling/PgDiplomaGuidanceCounselling.jsx"
  },
  {
    "category": "psychology",
    "categoryLabel": "Psychology",
    "level": "",
    "name": "PG Diploma in Rehabilitation Psychology",
    "slug": "pg-diploma-in-rehabilitation-psychology",
    "path": "/course/psychology/pg-diploma-in-rehabilitation-psychology/",
    "component": "./pages/Courses/Psychology/PgDiplomaRehabilitationPsychology/PgDiplomaRehabilitationPsychology.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "MBA in Legal Management",
    "slug": "mba-in-legal-management",
    "path": "/course/law/mba-in-legal-management/",
    "component": "./pages/Courses/Law/MbaInLegalManagement/MbaInLegalManagement.jsx"
  },
  {
    "category": "law",
    "categoryLabel": "Law",
    "level": "",
    "name": "MBA in Corporate Law Management",
    "slug": "mba-in-corporate-law-management",
    "path": "/course/law/mba-in-corporate-law-management/",
    "component": "./pages/Courses/Law/MbaInCorporateLawManagement/MbaInCorporateLawManagement.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "BHM / BHMCT Bachelor of Hotel Management & Catering Technology",
    "slug": "bhm-bhmct-bachelor-of-hotel-management-and-catering-technology",
    "path": "/course/hotel-management/bhm-bhmct-bachelor-of-hotel-management-and-catering-technology/",
    "component": "./pages/Courses/HotelManagement/BhmBhmctBachelorOfHotelManagementAndCateringTechnology/BhmBhmctBachelorOfHotelManagementAndCateringTechnology.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "MHM – Master of Hotel Management",
    "slug": "mhm-master-of-hotel-management",
    "path": "/course/hotel-management/mhm-master-of-hotel-management/",
    "component": "./pages/Courses/HotelManagement/MhmMasterOfHotelManagement/MhmMasterOfHotelManagement.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "MBA Food Service Management",
    "slug": "mba-food-service-management",
    "path": "/course/hotel-management/mba-food-service-management/",
    "component": "./pages/Courses/HotelManagement/MbaFoodServiceManagement/MbaFoodServiceManagement.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "Ph.D. in Hospitality Management",
    "slug": "phd-in-hospitality-management",
    "path": "/course/hotel-management/phd-in-hospitality-management/",
    "component": "./pages/Courses/HotelManagement/PhdInHospitalityManagement/PhdInHospitalityManagement.jsx"
  },
  {
    "category": "hotel-management",
    "categoryLabel": "Hotel Management",
    "level": "",
    "name": "M.S. in Tourism & Hotel Research",
    "slug": "ms-in-tourism-and-hotel-research",
    "path": "/course/hotel-management/ms-in-tourism-and-hotel-research/",
    "component": "./pages/Courses/HotelManagement/MsInTourismAndHotelResearch/MsInTourismAndHotelResearch.jsx"
  },
  {
    "category": "sports-physical-education",
    "categoryLabel": "Sports & Physical Education",
    "level": "",
    "name": "B.P.E.S. — Bachelor of Physical Education & Sports",
    "slug": "b-p-e-s-bachelor-of-physical-education-sports",
    "path": "/course/sports-physical-education/b-p-e-s-bachelor-of-physical-education-sports/",
    "component": "./pages/Courses/SportsPhysicalEducation/SportsSubcourseFallback.jsx"
  },
  {
    "category": "sports-physical-education",
    "categoryLabel": "Sports & Physical Education",
    "level": "",
    "name": "B.P.Ed. — Bachelor of Physical Education",
    "slug": "b-p-ed-bachelor-of-physical-education",
    "path": "/course/sports-physical-education/b-p-ed-bachelor-of-physical-education/",
    "component": "./pages/Courses/SportsPhysicalEducation/SportsSubcourseFallback.jsx"
  },
  {
    "category": "sports-physical-education",
    "categoryLabel": "Sports & Physical Education",
    "level": "",
    "name": "M.P.Ed. — Master of Physical Education",
    "slug": "m-p-ed-master-of-physical-education",
    "path": "/course/sports-physical-education/m-p-ed-master-of-physical-education/",
    "component": "./pages/Courses/SportsPhysicalEducation/SportsSubcourseFallback.jsx"
  }
]

export const COURSE_ALIASES = [
  {
    "path": "/engineering/be-computer/",
    "target": "/course/engineering/be-computer-science-and-engineering-cse/"
  },
  {
    "path": "/bpt-bachelor-of-physiotherapy-2/",
    "target": "/course/physiotherapy/bpt-bachelor-of-physiotherapy/"
  }
]
